/**
 * @license
 * @qwik.dev/core 2.0.0-beta.37-dev+586af8c
 * Copyright QwikDev. All Rights Reserved.
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/QwikDev/qwik/blob/main/LICENSE
 */
import { isServer as be, isBrowser as ve } from "@qwik.dev/core/build";

export { isBrowser, isServer } from "@qwik.dev/core/build";

import { p as we } from "@qwik.dev/core/preloader";

const _e = !1;

const Ee = (t, n, ...e) => {
    const s = n instanceof Error ? n : Error(n);
    console.error("%cQWIK ERROR", "", s.message, ...e, s.stack);
    t && setTimeout(() => {
        throw s;
    }, 0);
    return s;
};

/*@__INLINE__*/ const Se = (t, n, e) => {
    let s = e >> 1;
    let o = t.length - 2 >> 1;
    for (;s <= o; ) {
        const e = s + (o - s >> 1);
        const r = t[e << 1];
        if (r === n) {
            return e << 1;
        }
        r < n ? s = e + 1 : o = e - 1;
    }
    return ~(s << 1);
};

const ke = (t, n, e, s, o = !1) => {
    const r = Se(t, n, s);
    r >= 0 ? e != null || o ? t[r + 1] = e : t.splice(r, 2) : (e != null || o) && t.splice(r ^ -1, 0, n, e);
};

const Re = (t, n, e) => {
    const s = Se(t, n, e);
    return s >= 0 ? t[s + 1] : null;
};

const Pe = (t, n, e) => Se(t, n, e) >= 0;

const Te = t => {
    const n = Object.getPrototypeOf(t);
    return n === Object.prototype || n === Array.prototype || n === null;
};

const qe = t => typeof t === "object" && t !== null;

const Me = t => Array.isArray(t);

const Ae = t => typeof t === "string";

const xe = t => typeof t === "function";

const Ie = (t, n = []) => {
    const e = (t => `Code(Q${t}) https://qwikdev-build-v2.qwik-8nx.pages.dev/docs/errors/#q${t}`)(t, ...n);
    return ((t, ...n) => {
        const e = Ee(false, t, ...n);
        debugger;
        return e;
    })(e, ...n);
};

const Ne = "<sync>";

const Ce = t => typeof t === "function" && typeof t.getSymbol === "function";

const Oh = t => {
    const n = t.lastIndexOf("_") + 1;
    return t.slice(n);
};

const Oe = "q:type";

const je = {
    ["V"]: "Virtual",
    ["F"]: "Fragment",
    ["S"]: "Signal",
    ["A"]: "Awaited",
    ["C"]: "Component",
    ["I"]: "InlineComponent",
    ["P"]: "Projection"
};

const Xe = 124;

const De = (t, n) => {
    const e = parseInt(t, 10) - 1;
    const s = e + n;
    return -(s * (s + 1) / 2 + n + 1);
};

function t(t) {
    let n = "";
    for (let e = 0; e < t.length; e++) {
        if (t.charAt(e) === "\\" && e + 1 < t.length) {
            n += t.charAt(e + 1);
            e++;
        } else {
            n += t.charAt(e);
        }
    }
    return n;
}

const Ve = "q:renderFn";

const We = "q:targetEl";

const Ue = "⚡️";

const ze = "q:slot";

const Be = "q:s";

const He = "[q\\:patch]";

const jh = "q:r";

const Lh = "q:rp";

const Je = "q:style";

const Qe = "style[q\\:style]";

const Ye = Qe + ",style[q\\:sstyle]";

const Ge = "q:sstyle";

const Ke = "q:ctx";

const Ze = "q:brefs";

const ts = (t, n) => t["qFuncs_" + n] || [];

const ns = "q:base";

const es = "q:container-island";

const ss = "/" + es;

const rs = "q:ignore";

const is = "/" + rs;

const os = "q:container";

const ls = "/" + os;

const us = "q:cursorBoundary";

const cs = "q:template";

const fs = "[q\\:container]:not([q\\:container=html]):not([q\\:container=text])";

const as = "http://www.w3.org/1999/xhtml";

const hs = "http://www.w3.org/2000/svg";

const ds = "http://www.w3.org/1998/Math/MathML";

const ps = "qRender";

const $s = "q:id";

const ys = "q:key";

const ms = "q:props";

const ws = "q:seq";

const bs = "q:seqIdx";

const vs = "q:p";

const _s = "q:ps";

const Es = ":on";

const Ss = ":onIdx";

const ks = ":onFlags";

const Rs = ":nearestCursorBoundary";

const Ps = ":";

const Ts = "dangerouslySetInnerHTML";

const Ms = 100;

const As = t => !!t && typeof t == "object" && typeof t.then === "function";

const xs = (t, n, e) => {
    try {
        const s = t();
        return As(s) ? s.then(n, e) : n(s);
    } catch (t) {
        return e(t);
    }
};

const Is = (t, n) => As(t) ? t.then(n) : n(t);

const Ns = t => new Promise(n => {
    setTimeout(n, t);
});

const Cs = t => {
    throw t;
};

function n(t, n = Cs) {
    let e = !1;
    let s;
    try {
        s = t();
        e = !0;
    } catch (t) {
        s = t;
    }
    if (!As(s)) {
        if (e) {
            return s;
        }
        return n(s);
    }
    let o = Ms;
    const r = async e => {
        for (;As(e); ) {
            try {
                await e;
                return await t();
            } catch (t) {
                if (!As(t)) {
                    e = t;
                    break;
                }
                if (! --o) {
                    e = Error("Exceeded max retry count in retryOnPromise");
                    break;
                }
                e = t;
            }
        }
        return n(e);
    };
    return e ? s.catch(r) : r(s);
}

const Os = t => Ue + t;

const js = t => {
    if (t) {
        let n = 0;
        do {
            t = t.substring(0, n) + Os(t.substring(n));
        } while ((n = t.indexOf(" ", n) + 1) !== 0);
    }
    return t || null;
};

const Ls = t => t.charCodeAt(0) === 113 && t.charCodeAt(1) === 45 && (t.charCodeAt(3) === 58 || t.charCodeAt(3) === 112 && t.charCodeAt(4) === 58);

function e(t, n = !1) {
    if (t.endsWith("$")) {
        const [e, s] = function o(t, n = !1) {
            let e;
            let s = -1;
            if (t.startsWith("on")) {
                e = n ? "q-ep:" : "q-e:";
                s = 2;
            } else if (t.startsWith("window:on")) {
                e = n ? "q-wp:" : "q-w:";
                s = 9;
            } else if (t.startsWith("document:on")) {
                e = n ? "q-dp:" : "q-d:";
                s = 11;
            }
            return [ e, s ];
        }(t, n);
        if (s !== -1) {
            return e + Fs(t.slice(s, -1));
        }
    }
    return null;
}

const Fs = t => t === "DOMContentLoaded" ? "-d-o-m-content-loaded" : function n(t, e = "") {
    const s = Xs(t);
    return e + s;
}(t.charAt(0) === "-" ? t.slice(1) : t.toLowerCase());

const Xs = t => t.replace(/([A-Z-])/g, t => "-" + t.toLowerCase());

const Ds = t => {
    const n = t.indexOf(":");
    return [ t.slice(2, n), t.slice(n + 1) ];
};

const Vs = new Set([ "animationIterationCount", "aspectRatio", "borderImageOutset", "borderImageSlice", "borderImageWidth", "boxFlex", "boxFlexGroup", "boxOrdinalGroup", "columnCount", "columns", "flex", "flexGrow", "flexShrink", "gridArea", "gridRow", "gridRowEnd", "gridRowStart", "gridColumn", "gridColumnEnd", "gridColumnStart", "fontWeight", "lineClamp", "lineHeight", "opacity", "order", "orphans", "scale", "tabSize", "widows", "zIndex", "zoom", "MozAnimationIterationCount", "MozBoxFlex", "msFlex", "msFlexPositive", "WebkitAnimationIterationCount", "WebkitBoxFlex", "WebkitBoxOrdinalGroup", "WebkitColumnCount", "WebkitColumns", "WebkitFlex", "WebkitFlexGrow", "WebkitFlexShrink", "WebkitLineClamp" ]);

const Ws = (t, n = 0) => {
    for (let e = 0; e < t.length; e++) {
        const s = t.charCodeAt(e);
        n = (n << 5) - n + s;
        n |= 0;
    }
    return (+Math.abs(n)).toString(36);
};

const Us = t => {
    if (!t) {
        return "";
    }
    if (Ae(t)) {
        return t.trim();
    }
    const n = [];
    if (Me(t)) {
        for (let e = 0; e < t.length; e++) {
            const s = t[e];
            const o = Us(s);
            o && n.push(o);
        }
    } else {
        for (const [e, s] of Object.entries(t)) {
            s && n.push(e.trim());
        }
    }
    return n.join(" ");
};

const zs = t => t.replace(/([A-Z])/g, "-$1").toLowerCase();

const Bs = t => {
    if (t == null) {
        return "";
    }
    if (typeof t == "object") {
        if (Me(t)) {
            throw Ie(0, [ t, "style" ]);
        }
        {
            const n = [];
            for (const e in t) {
                if (Object.prototype.hasOwnProperty.call(t, e)) {
                    const s = t[e];
                    s != null && typeof s !== "function" && (e.startsWith("--") ? n.push(e + ":" + s) : n.push(zs(e) + ":" + Hs(e, s)));
                }
            }
            return n.join(";");
        }
    }
    return t + "";
};

function s(t, n, e) {
    if (function s(t) {
        return t === "class";
    }(t)) {
        const t = Us(n);
        n = e ? e + (t.length ? " " + t : t) : t;
    } else {
        t === "style" ? n = Bs(n) : function o(t) {
            return function n(t) {
                return t.startsWith("aria-");
            }(t) || [ "spellcheck", "draggable", "contenteditable" ].includes(t);
        }(t) || typeof n === "number" ? n = (t => t != null ? t + "" : null)(n) : n === !1 || n == null ? n = null : n === !0 && function r(t) {
            return t.startsWith("preventdefault:");
        }(t) && (n = "");
    }
    return n;
}

const Hs = (t, n) => {
    if (typeof n === "number" && n !== 0 && !(t => Vs.has(t))(t)) {
        return n + "px";
    }
    return n;
};

const Js = t => {
    let n;
    if (typeof MessageChannel !== "undefined") {
        const e = new MessageChannel;
        e.port1.onmessage = () => t();
        n = () => e.port2.postMessage(null);
    } else {
        n = () => setTimeout(t);
    }
    return n;
};

const Qs = () => ({
    isServer: be,
    importSymbol(t, n, e) {
        if (be) {
            const t = Oh(e);
            const n = globalThis.__qwik_reg_symbols?.get(t);
            if (n) {
                return n;
            }
            throw Ie(6, [ e ]);
        }
        if (!n) {
            throw Ie(14, [ e ]);
        }
        if (!t) {
            throw Ie(13, [ n, e ]);
        }
        const s = Ys(t.ownerDocument, t, n).toString();
        const o = new URL(s);
        o.hash = "";
        const r = o.href;
        return import(r).then(t => t[e]);
    },
    raf: t => new Promise(n => {
        requestAnimationFrame(() => {
            n(t());
        });
    }),
    chunkForSymbol(t, n) {
        return [ t, n ?? "_" ];
    }
});

const Ys = (t, n, e) => {
    const s = t.baseURI;
    const o = new URL(n.getAttribute(ns) ?? s, s);
    return new URL(e, o);
};

let Gs = /*#__PURE__ */ Qs();

const Ks = t => Gs = t;

const Zs = () => Gs;

const Fh = () => Gs.isServer;

const Xh = typeof document !== "undefined";

const tr = !be && Xh;

const nr = tr ? document : void 0;

const er = tr && nr.createElement("link").relList?.supports?.("modulepreload") ? "modulePreload" : "preload";

const sr = /\.[mc]?js$/;

const rr = 1e3 / 60;

const ir = t => {
    let n = or.get(t);
    if (!n) {
        let e;
        n = ((t, n) => ({
            Vt: t,
            Ot: sr.test(t) ? 0 : 3,
            Wt: n,
            Ut: 1,
            zt: performance.now(),
            Bt: 0,
            Ht: 0
        }))(t, e);
        or.set(t, n);
    }
    return n;
};

const or = new Map;

let lr = 0;

const ur = [];

const cr = Js(function Dh() {
    ar = !1;
    if (!ur.length) {
        return;
    }
    const t = performance.now() + rr;
    let n = !1;
    for (;ur.length; ) {
        const e = ur[0];
        const s = e.Ut;
        const o = 1 - s;
        if (!(o >= .99 || lr < 25)) {
            break;
        }
        ur.shift();
        yr(e);
        if (performance.now() >= t) {
            n = !0;
            break;
        }
    }
    if (n && ur.length && !ar) {
        ar = !0;
        cr();
    }
});

const fr = Js(r);

let ar = !1;

let hr = !1;

let dr = !1;

const pr = [];

const $r = () => {
    const t = pr[pr.length - 1];
    const n = t.Jt;
    if (t.Wt) {
        const e = t.Qt;
        if (e >= t.Wt.length) {
            pr.pop();
            return !1;
        }
        const s = t.Wt[e];
        t.Qt = e + 1;
        const o = ir(s.Vt);
        if (o.Ut === 0) {
            return !0;
        }
        const r = 1 - n.Ut;
        let i;
        if (r === 1 || r >= .99) {
            i = Math.min(.01, 1 - s.Yt);
        } else {
            const t = 1 - s.Yt * r;
            const n = s.Gt;
            const e = t / n;
            i = Math.max(.02, o.Ut * e);
            s.Gt = e;
        }
        pr.push({
            Jt: o,
            Ut: i,
            Kt: t.Kt
        });
        return !0;
    }
    if (t.Kt?.has(n)) {
        pr.pop();
        return !1;
    }
    const e = n.Ut;
    n.Ut = t.Ut;
    if (e - n.Ut < .01) {
        pr.pop();
        return !1;
    }
    if (n.Wt?.length) {
        const e = t.Kt || new Set;
        e.add(n);
        t.Kt = e;
        t.Wt = n.Wt;
        t.Qt = 0;
        return !1;
    }
    pr.pop();
    return !1;
};

function r() {
    if (dr || !pr.length) {
        return;
    }
    hr = !1;
    dr = !0;
    const t = tr ? performance.now() + rr : 0;
    let n = !1;
    for (;pr.length; ) {
        n = !0;
        const e = $r();
        if (tr && e && performance.now() >= t) {
            if (!hr) {
                hr = !0;
                fr();
            }
            break;
        }
    }
    dr = !1;
    n && tr && cr();
}

const yr = t => {
    if (t.Ot >= 2) {
        return;
    }
    lr++;
    const n = performance.now();
    t.Bt = n - t.zt;
    t.Ot = 2;
    const e = nr.createElement("link");
    e.href = new URL("undefined" + t.Vt, nr.baseURI).toString();
    e.rel = er;
    e.as = "script";
    e.onload = e.onerror = () => {
        lr--;
        const s = performance.now();
        t.Ht = s - n;
        t.Ot = 4;
        e.remove();
        cr();
    };
    nr.head.appendChild(e);
};

const mr = (t, n) => {
    const e = ir(t);
    e && ((t, n) => {
        pr.unshift({
            Jt: t,
            Ut: n,
            Kt: void 0
        });
    })(e, n);
};

tr && document.addEventListener("qsymbol", t => {
    const {symbol: n, href: e} = t.detail;
    if (e) {
        const t = n.slice(n.lastIndexOf("_") + 1);
        (t => {
            if (!t?.length) {
                return;
            }
            if (Array.isArray(t)) {
                for (let n = t.length - 1; n >= 0; n--) {
                    const e = t[n];
                    mr(e, 0);
                }
            } else {
                mr(t, 0);
            }
            tr ? fr() : r();
        })(t);
    }
});

const wr = t => {
    for (const n in t) {
        if (Object.prototype.hasOwnProperty.call(t, n)) {
            return !1;
        }
    }
    return !0;
};

const br = t => ({
    write: t,
    writeRootRef(t) {
        return ((t, n) => t.write(n + ""))(this, t);
    },
    writeRootRefPath(t) {
        return ((t, n) => t.write((t => {
            let n = t[0] + "";
            for (let e = 1; e < t.length; e++) {
                n += " " + t[e];
            }
            return n;
        })(n)))(this, t);
    }
});

const vr = '"';

const _r = "[";

const gr = "]";

const Er = ",";

const Sr = "2.0.0-beta.37-dev+586af8c";

const kr = t => t.nodeType === 1;

const Wh = t => t.Cn;

const Rr = Symbol();

class Pr {
    [Rr]=void 0;
}

const Tr = t => t === "foreignObject";

const qr = t => t === "svg" || Tr(t);

const Mr = t => t === "math";

function i(t, n, e, s = !1) {
    const o = t.ownerDocument.createElementNS(e, n);
    for (let n = 0; n < t.attributes.length; n++) {
        const e = t.attributes[n];
        e.name !== Ps && o.setAttribute(e.name, e.value);
    }
    if (s) {
        for (let n = 0; n < t.childNodes.length; n++) {
            const r = t.childNodes[n];
            const c = r.nodeType;
            c === 3 ? o.appendChild(r.cloneNode()) : c === 1 && o.appendChild(i(r, r.localName, e, s));
        }
    }
    return o;
}

const Ar = {
    elementNamespace: as,
    elementNamespaceFlag: 0
};

function o(t, n) {
    const e = !t || !!Ml(t) && (t => {
        const n = t.flags;
        return (n & 1536) === 0;
    })(t);
    const s = !e && Tr(Ml(t));
    let o = as;
    let r = 0;
    const i = typeof n === "string" || Ko(n);
    if (i && function c(t) {
        if (typeof t === "string") {
            return qr(t);
        }
        if (Ko(t)) {
            return qr(Ml(t)) || (t.flags & 512) !== 0;
        }
        return !1;
    }(n)) {
        o = hs;
        r = 512;
    } else if (i && function l(t) {
        if (typeof t === "string") {
            return Mr(t);
        }
        if (Ko(t)) {
            return Mr(Ml(t)) || (t.flags & 1024) !== 0;
        }
        return !1;
    }(n)) {
        o = ds;
        r = 1024;
    } else if (t && !s && !e) {
        const n = (t.flags & 512) !== 0;
        const e = (t.flags & 1024) !== 0;
        o = n ? hs : e ? ds : as;
        r = t.flags & 1536;
    }
    Ar.elementNamespace = o;
    Ar.elementNamespaceFlag = r;
    return Ar;
}

class xr {
    flags;
    parent;
    previousSibling;
    nextSibling;
    props;
    [Rr]=void 0;
    slotParent=null;
    dirty=0;
    dirtyChildren=null;
    nextDirtyChildIndex=0;
    constructor(t, n, e, s, o) {
        this.flags = t;
        this.parent = n;
        this.previousSibling = e;
        this.nextSibling = s;
        this.props = o;
    }
    toString() {
        return Object.prototype.toString.call(this);
    }
}

class Ir extends xr {
    key;
    firstChild;
    lastChild;
    constructor(t, n, e, s, o, r, i, c) {
        super(n, e, s, o, r);
        this.key = t;
        this.firstChild = i;
        this.lastChild = c;
    }
}

class Nr extends Ir {
    node;
    elementName;
    constructor(t, n, e, s, o, r, i, c, l, u) {
        super(t, n, e, s, o, r, i, c);
        this.node = l;
        this.elementName = u;
    }
}

class Cr extends xr {
    node;
    text;
    constructor(t, n, e, s, o, r, i) {
        super(t, n, e, s, o);
        this.node = r;
        this.text = i;
    }
}

const Or = [];

const jr = [];

function l(t, n) {
    const e = y(n).priority;
    let s = Or.length;
    for (let t = 0; t < Or.length; t++) {
        const n = y(Or[t]).priority;
        if (e < n) {
            s = t;
            break;
        }
    }
    Or.splice(s, 0, n);
    t.o++;
    t.l ||= new Promise(n => t.u = n);
}

function u() {
    for (let t = 0; t < Or.length; t++) {
        const n = Or[t];
        let e = !1;
        for (let t = 0; t < jr.length; t++) {
            const s = jr[t];
            if (Kl(n, s)) {
                e = !0;
                break;
            }
        }
        if (!e) {
            return n;
        }
    }
    return null;
}

function c(t, n) {
    jr.push(t);
    h(t, n, !0);
    n.o++;
}

function f(t, n) {
    d(t, n);
    if (!(t.flags & 256)) {
        return;
    }
    l(n, t);
}

function a(t, n, e) {
    const s = y(e);
    if (!s || s === n) {
        return;
    }
    h(e, t, !1);
    d(e, t);
    $(n, s);
    s.afterFlushTasks = null;
    s.extraPromises = null;
    s.journal = null;
    s.boundaries = null;
    s.position = null;
    s.promise = null;
}

function h(t, n, e) {
    e || (t.flags &= -257);
    const s = Or.indexOf(t);
    if (s !== -1) {
        Or.splice(s, 1);
        n.o--;
        return !0;
    }
    return !1;
}

function d(t, n) {
    const e = jr.indexOf(t);
    if (e === -1) {
        return !1;
    }
    const s = jr.length - 1;
    e !== s && (jr[e] = jr[s]);
    jr.pop();
    n.o--;
    return !0;
}

const Lr = new WeakMap;

const Fr = ":nodeProps";

const Xr = ":nodeDiff";

const Dr = ":errorData";

const Vr = ":signal";

const Wr = ":inlineComponentData";

function p(t, n, e) {
    n.position = e;
    e && dn(e) && function s(t, n, e) {
        const s = y(e);
        if (!s || s === n) {
            return;
        }
        h(e, t);
        (function o(t, n) {
            if (n === t) {
                return;
            }
            const e = n.afterFlushTasks;
            if (e && e.length > 0) {
                const n = t.afterFlushTasks;
                n ? n.push(...e) : t.afterFlushTasks = e;
            }
            const s = n.extraPromises;
            if (s && s.length > 0) {
                const n = t.extraPromises;
                n ? n.push(...s) : t.extraPromises = s;
            }
            $(t, n);
        })(n, s);
    }(t, n, e);
}

function $(t, n) {
    if (n === t) {
        return;
    }
    const e = n.journal;
    if (e && e.length > 0) {
        const n = t.journal;
        n ? n.push(...e) : t.journal = e;
    }
    const s = n.boundaries;
    if (__EXPERIMENTAL__.suspense && s && s.length > 0) {
        const n = t.boundaries ||= [];
        for (let t = 0; t < s.length; t++) {
            const e = s[t];
            n.includes(e) || n.push(e);
        }
    }
}

function y(t) {
    return Lr.get(t) ?? null;
}

const Ur = Symbol();

class zr {
    consumer;
    property;
    backRef;
    data;
    constructor(t, n, e = null, s = null) {
        this.consumer = t;
        this.property = n;
        this.backRef = e;
        this.data = s;
    }
}

const Br = Symbol();

const Hr = Symbol();

const Jr = Symbol();

function m(t, n, e) {
    t[Rr] || (be && function s(t) {
        return "__brand__" in t && t.__brand__ === "SsrNode";
    }(t) ? t.setProp(Ze, new Map) : t[Rr] = new Map);
    const o = t[Rr];
    let r = o.get(n);
    if (!r) {
        r = new zr(t, n);
        o.set(n, r);
    }
    e && (r.data = e);
    return r;
}

const Qr = (t, n) => (e, s) => {
    const o = ye();
    o.Ft = m(t, ":");
    o.$ = n || void 0;
    return de(o, () => {
        if (xe(e)) {
            return e();
        }
        if (s) {
            return e[s];
        }
        if (hu(e)) {
            return e.value;
        }
        if (qe(e) && Tu(e)) {
            In(Su(e), Jr, Eu(e), o.Ft);
            return e;
        }
        throw Ie(2);
    });
};

class Yr {
    Zt;
    ct=void 0;
    $=null;
    tn=null;
    constructor(t, n) {
        this.$ = t || af()?.$ || null;
        this.Zt = n;
    }
    trigger() {
        mu(this.$, this, this.ct);
    }
    force() {
        mu(this.$, this, this.ct);
    }
    get untrackedValue() {
        return this.Zt;
    }
    set untrackedValue(t) {
        this.Zt = t;
    }
    get value() {
        const t = this.untrackedValue;
        const n = af();
        if (!n) {
            return t;
        }
        this.$ === null && (this.$ = n.$);
        const e = n.Ft;
        if (e) {
            const t = be;
            const s = this.ct ||= new Set;
            const o = __EXPERIMENTAL__.suspense && t;
            du(s, e);
            pu(e, this);
            if (t) {
                const t = yu(n.$, this.$);
                o && t?.nn?.(this, e, null);
                $u(e, t);
            }
        }
        return t;
    }
    set value(t) {
        if (t !== this.Zt) {
            this.Zt = t;
            mu(this.$, this, this.ct);
        }
    }
    valueOf() {}
    toString() {
        return this.constructor.name;
    }
    toJSON() {
        return {
            value: this.Zt
        };
    }
}

class Gr extends Yr {
    en;
    h;
    [Rr]=void 0;
    constructor(t, n, e = 17) {
        super(t || af()?.$, Ur);
        this.en = n;
        this.h = e;
    }
    invalidate() {
        this.h |= 1;
        const t = ye();
        t.$ = this.$ || void 0;
        const e = n(pe.bind(this, t, this.p));
        e && e.catch(t => {
            this.$ ? this.$.handleError(t, null) : console.error("Error during computation", t);
        });
    }
    get untrackedValue() {
        this.p();
        return this.Zt;
    }
    set untrackedValue(t) {
        this.Zt = t;
    }
    p() {
        if (!(this.h & 1)) {
            return;
        }
        const t = this.en;
        au(t);
        const n = af();
        const e = n?.Ft;
        if (n) {
            const t = m(this, ".");
            Rn(this.$, t);
            n.Ft = t;
        }
        try {
            const e = t.getFn(n)();
            if (As(e)) {
                throw Ie(29, [ t.dev ? t.dev.file : "", t.it ]);
            }
            this.h &= -2;
            super.value = e;
        } finally {
            n && (n.Ft = e);
        }
    }
}

class Kr {
    sn;
    rn=null;
    ln=!1;
    un=!0;
    constructor(t, n, e) {
        this.sn = t;
        if (n !== void 0) {
            this.info = n;
            this.cn = e;
        }
    }
    get track() {
        return this.fn ||= Qr(this.sn, this.sn.$);
    }
    get abortSignal() {
        return (this.an ||= new AbortController).signal;
    }
    cache() {}
    get previous() {
        const t = this.sn.Zt;
        if (t !== Ur) {
            return t;
        }
    }
    cleanup(t) {
        typeof t === "function" && (this.hn ||= []).push(t);
    }
}

class Zr extends Gr {
    dn=!1;
    pn=void 0;
    $n=null;
    [Rr]=void 0;
    constructor(t, n, e = 17, s) {
        super(t, n, e);
        if (!s) {
            return;
        }
        const o = s.initial;
        if (o !== void 0) {
            const t = typeof o === "function" ? o() : o;
            this.Zt = t;
        }
        const r = s.concurrency;
        if (r !== void 0 && r >= 0 && r !== 1) {
            this.yn = r;
            this.mn = [];
        }
        const i = s.timeout;
        i && (this.wn = i);
        s.eagerCleanup && (this.h |= 32);
        s.clientOnly && (this.h |= 64);
        s.allowStale === !1 && (this.h |= 128);
        const c = s.expires ?? (s.interval ? Math.abs(s.interval) : void 0);
        c && (this.expires = c);
        (s.poll === !1 || s.interval !== void 0 && s.interval < 0) && (this.h |= 256);
    }
    get untrackedValue() {
        this.p();
        if (this.$n?.rn) {
            if (this.Zt === Ur || be) {
                throw this.$n?.rn;
            }
            return this.Zt;
        }
        if (this.pn) {
            throw this.pn;
        }
        if (be && this.h & 64 && this.Zt === Ur) {
            throw Ie(35);
        }
        return this.Zt;
    }
    set untrackedValue(t) {
        this.Zt = t;
    }
    get value() {
        return super.value;
    }
    set value(t) {
        this.h &= -2;
        this.untrackedLoading = !1;
        this.untrackedError = void 0;
        this.bn = void 0;
        if (this.mn) {
            for (let t = 0; t < this.mn.length; t++) {
                this.mn[t].un = !1;
            }
        } else {
            this.$n && (this.$n.un = !1);
        }
        this.vn();
        super.value = t;
        this._n();
    }
    get loading() {
        const t = this.untrackedLoading;
        const n = af();
        if (n && (this.$ ||= n.$ || null)) {
            const t = n.Ft;
            if (t) {
                du(this.$t ||= new Set, t);
                pu(t, this);
                $u(t, this.$);
            }
        }
        return t;
    }
    set untrackedLoading(t) {
        if (t !== this.dn) {
            this.dn = t;
            mu(this.$, this, this.$t);
        }
    }
    get untrackedLoading() {
        this.p();
        if (be && this.$n?.rn) {
            throw this.$n?.rn;
        }
        return this.dn;
    }
    get error() {
        const t = this.untrackedError;
        const n = af();
        if (n && (this.$ ||= n.$ || null)) {
            const t = n.Ft;
            if (t) {
                du(this.yt ||= new Set, t);
                pu(t, this);
                $u(t, this.$);
            }
        }
        return t;
    }
    set untrackedError(t) {
        if (t !== this.pn) {
            this.pn = t;
            mu(this.$, this, this.yt);
        }
    }
    get untrackedError() {
        return this.pn;
    }
    get expires() {
        return this.Pt || 0;
    }
    set expires(t) {
        this.vn();
        this.Pt = t;
        this.Pt && this.gn() && this._n();
    }
    get poll() {
        return !(this.h & 256);
    }
    set poll(t) {
        t ? this.h &= -257 : this.h |= 256;
        if (this.Pt && this.gn()) {
            this.vn();
            this._n();
        }
    }
    get interval() {
        const t = this.Pt || 0;
        return this.h & 256 ? -t : t;
    }
    set interval(t) {
        t < 0 ? this.h |= 256 : this.h &= -257;
        this.expires = Math.abs(t);
    }
    async invalidate(t) {
        if (arguments.length > 0) {
            this.bn = t;
            this.cn = this.cn === void 0 ? 1 : this.cn + 1;
        }
        this.En(!0, this.h & 128);
    }
    En(t, n) {
        this.h |= 1;
        this.vn();
        n && (this.Zt = Ur);
        t && (this.ct?.size || this.$t?.size || this.yt?.size) && Promise.resolve().then(() => this.p());
    }
    abort(t) {
        this.$n && this.Sn(this.$n, t);
    }
    wt() {
        if (!(this.h & 32) || this.gn()) {
            return;
        }
        if (!ve) {
            return;
        }
        setTimeout(() => {
            this.gn() || this.abort();
        });
    }
    async promise() {
        this.p();
        for (;this.$n?.rn; ) {
            await (this.$n?.rn);
        }
    }
    p() {
        if (!(this.h & 1)) {
            return;
        }
        if (be && this.h & 64) {
            this.dn = !0;
            this.$?.serializationCtx.Tt.add(this);
            return;
        }
        this.vn();
        this.h &= -2;
        const t = this.$n;
        t && this.Sn(t);
        const n = this.yn === 0 ? Infinity : this.yn ?? 1;
        if (this.mn ? this.mn.length >= n : t?.rn) {
            this.h |= 1;
            return;
        }
        const e = this.cn;
        const s = new Kr(this, this.bn, e);
        this.$n = s;
        this.mn && this.mn.push(s);
        s.rn = this.kn(s);
    }
    async kn(t) {
        let e = this.en.resolved;
        if (!e) {
            this.untrackedLoading = !0;
            e = await this.en.resolve();
            if (t.an?.signal.aborted) {
                t.rn = null;
                return;
            }
        }
        try {
            this.wn && (this.Rn = setTimeout(() => {
                const n = Error(`timeout ${this.wn}ms`);
                this.Pn(t, n);
                t.an?.abort(n);
            }, this.wn));
            const s = n(e.bind(null, t));
            let o;
            if (As(s)) {
                this.untrackedLoading = !0;
                o = await s;
            } else {
                o = s;
            }
            t.rn = null;
            if (t.un) {
                const n = this.mn;
                if (n) {
                    let e = !1;
                    for (let s = n.length - 1; s >= 0; s--) {
                        n[s] === t ? e = !0 : e && (n[s].un = !1);
                    }
                }
                this.untrackedError = void 0;
                super.value = o;
            }
        } catch (n) {
            t.rn = null;
            this.Pn(t, n);
        }
        if ((() => t === this.$n)()) {
            clearTimeout(this.Rn);
            t.cn === this.cn && (this.bn = void 0);
            if (this.h & 1) {
                this.p();
            } else {
                this.untrackedLoading = !1;
                this._n();
            }
        }
    }
    Pn(t, n) {
        if (t !== this.$n || !t.un) {
            return;
        }
        t.un = !1;
        if (n instanceof Error && n.name === "AbortError") {
            return;
        }
        this.untrackedError = n;
        this.untrackedValue = Ur;
    }
    async Tn() {
        this.vn();
        clearTimeout(this.Rn);
        const t = this.$n;
        t && this.Sn(t);
        this.mn ? await Promise.all(this.mn.map(t => t.rn)) : await (t?.rn);
    }
    vn() {
        if (this.qn !== void 0) {
            clearTimeout(this.qn);
            this.qn = void 0;
        }
    }
    _n() {
        if (be || !this.Pt) {
            return;
        }
        this.vn();
        const t = !(this.h & 256);
        const n = this.h & 128 && !t;
        this.qn = setTimeout(() => this.En(t, n), this.Pt);
        this.qn?.unref?.();
    }
    gn() {
        return !!(this.ct?.size || this.$t?.size || this.yt?.size);
    }
    Sn(t, n) {
        if (t.ln) {
            return;
        }
        t.ln = !0;
        t.an?.abort(n);
        t.rn = Is(t.rn, () => this.Mn(t));
    }
    Mn(t) {
        const n = t.hn;
        const e = t => {
            const n = this.$?.handleError;
            n ? n(t, null) : console.error("Error in async signal cleanup", t);
        };
        const s = () => {
            t.rn = null;
            n && (n.length = 0);
            const e = this.mn;
            if (e) {
                const n = e.indexOf(t);
                n !== -1 && e.splice(n, 1);
            }
            this.p();
        };
        let o;
        if (n) {
            for (let t = 0; t < n.length; t++) {
                try {
                    const s = n[t]();
                    As(s) && (o = (o ? o.then(() => s) : s).catch(e));
                } catch (t) {
                    e(t);
                }
            }
        }
        if (o) {
            return o.then(s);
        }
        s();
    }
}

const ti = (t, n) => {
    const e = t;
    e.invalidate({
        __v: n
    });
    e.p();
};

const ni = Symbol();

const ei = Symbol();

const si = Symbol();

const ri = Symbol();

const ii = Symbol();

const oi = Symbol();

const li = [];

const ui = {};

Object.freeze(li);

Object.freeze(ui);

function w(t) {
    return new Proxy({}, new ci(t));
}

class ci {
    owner;
    ct=void 0;
    $=null;
    constructor(t) {
        this.owner = t;
    }
    get(t, n) {
        if (n === ni) {
            return this.owner.constProps;
        }
        if (n === ei) {
            return this.owner.varProps;
        }
        if (n === si) {
            return this.owner;
        }
        if (n === ri) {
            return this;
        }
        let s;
        if (n === "children") {
            s = this.owner.children;
        } else {
            if (typeof n === "string" && typeof this.owner.type === "string") {
                const t = e(n);
                t && (n = t);
            }
            s = hi(this.owner, n);
            n in this.owner.varProps && fi(this, n);
        }
        return s instanceof xi ? s.value : s;
    }
    set(t, n, s) {
        if (n === si) {
            this.owner = s;
        } else if (n === "children") {
            this.owner.children = s;
        } else if (n === ni) {
            this.owner.constProps = s;
        } else if (n === ei) {
            this.owner.varProps = s;
        } else {
            if (typeof n === "string" && typeof this.owner.type === "string") {
                const t = e(n);
                t && (n = t);
            }
            this.owner.constProps && n in this.owner.constProps && delete this.owner.constProps[n];
            this.owner.varProps === ui ? this.owner.varProps = {} : n in this.owner.varProps || (this.owner.toSort = !0);
            if (this.owner.varProps[n] !== s) {
                this.owner.varProps[n] = s;
                ai(this, n);
            }
        }
        return !0;
    }
    deleteProperty(t, n) {
        let e = delete this.owner.varProps[n];
        e && ai(this, n);
        this.owner.constProps && (e = delete this.owner.constProps[n] || e);
        if (this.owner.children != null && n === "children") {
            this.owner.children = null;
            e = !0;
        }
        return e;
    }
    has(t, n) {
        if (n === "children") {
            return this.owner.children != null;
        }
        if (n === ni || n === ei) {
            return !0;
        }
        const s = n in this.owner.varProps;
        if (typeof n === "string") {
            s && fi(this, n);
            if (typeof this.owner.type === "string") {
                const t = e(n);
                t && (n = t);
            }
        }
        return s || !!this.owner.constProps && n in this.owner.constProps;
    }
    getOwnPropertyDescriptor(t, n) {
        const e = n === "children" ? this.owner.children : this.owner.constProps && n in this.owner.constProps ? this.owner.constProps[n] : this.owner.varProps[n];
        return {
            configurable: !0,
            enumerable: !0,
            value: e
        };
    }
    ownKeys() {
        const t = Object.keys(this.owner.varProps);
        this.owner.children != null && t.push("children");
        if (this.owner.constProps) {
            for (const n in this.owner.constProps) {
                t.indexOf(n) === -1 && t.push(n);
            }
        }
        return t;
    }
}

const fi = (t, n) => {
    const e = af();
    e && t.$ === null && e.$ && (t.$ = e.$);
    const s = e?.Ft;
    s && In(t.owner._proxy, n, t, s);
};

const ai = (t, n) => {
    const e = function s(t, n) {
        return t?.get(n);
    }(t.ct, n);
    e && mu(t.$, t, e);
    return !!e;
};

const hi = (t, n) => t.constProps && n in t.constProps ? t.constProps[n] : t.varProps[n];

const di = (t, n) => pi(t)?.[n] || $i(t)?.[n] || null;

const pi = t => {
    if (!t) {
        return null;
    }
    return ei in t ? "children" in t ? {
        ...t[ei],
        children: t.children
    } : t[ei] : t;
};

const $i = t => {
    if (!t) {
        return null;
    }
    return ni in t ? t[ni] : null;
};

const yi = t => t && ei in t;

const mi = t => (n, ...e) => t.call(null, Bf(n), ...e);

class wi extends Gr {
    constructor(t, n) {
        super(t, n, 17);
    }
    An=!1;
    p() {
        if (!(this.h & 1)) {
            return;
        }
        au(this.en);
        const t = $f(this.en.resolved);
        const {deserialize: n, initial: e} = t;
        const s = t.update;
        const o = this.Zt === Ur ? e : this.Zt;
        const r = mf(() => this.An ? s?.(o) || o : n(o), this, ".", this.$);
        this.An = !0;
        this.h &= -2;
        const i = this.An && r !== "undefined" || r !== this.Zt;
        if (i) {
            this.Zt = r;
            mu(this.$, this, this.ct);
        }
    }
}

const bi = (t, n) => new Gr(n?.container || null, t, bu(n?.serializationStrategy || "always"));

const vi = (t, n) => new Zr(n?.container || null, t, bu(n?.serializationStrategy || "always"), n);

const _i = t => new wi(null, t);

const gi = t => new Yr(null, t);

const Ei = /*#__PURE__*/ mi(bi);

const Si = /*#__PURE__*/ mi(vi);

const ki = mi(_i);

const Ri = t => t.value;

const Pi = (t, n) => t[n];

const Ti = t => {
    if (t.length === 1) {
        if (hu(t[0])) {
            return t[0].tn ||= new xi(null, Ri, t, null);
        }
        if (Tu(t[0])) {
            return new xi(null, Ri, t, null);
        }
        return t[0].value;
    }
    return new xi(null, Pi, t, null);
};

const qi = (...t) => {
    const n = t[0];
    const e = t.length < 2 ? "value" : t[1];
    if (!qe(n)) {
        return n[e];
    }
    if (hu(n)) {
        if (n instanceof xi) {
            return n;
        }
        return Ti(t);
    }
    if (yi(n)) {
        const s = n[ni];
        const o = n[ei];
        if (s && Object.prototype.hasOwnProperty.call(s, e)) {
            return s[e];
        }
        if (Object.prototype.hasOwnProperty.call(o, e)) {
            const n = o[e];
            return Mi(n, t);
        }
    } else {
        const s = Su(n);
        if (s) {
            const n = s[e];
            return Mi(n, t);
        }
    }
    return n[e];
};

const Mi = (t, n) => hu(t) ? t : Ti(n);

const Ai = (t, n) => {
    const e = qi(t, n);
    if (e === ii) {
        return t[n];
    }
    return e;
};

class xi extends Yr {
    lt;
    ot;
    kt;
    h;
    m=void 0;
    [Rr]=void 0;
    constructor(t, n, e, s, o = 1) {
        super(t, Ur);
        this.lt = e;
        this.ot = n;
        this.kt = s;
        this.h = o;
    }
    invalidate() {
        this.h |= 1;
        try {
            this.p();
        } catch (t) {
            if (this.$ && this.m) {
                this.$.setHostProp(this.m, Vr, this);
                yn(this.$, this.m, 32);
            }
        }
        if (this.h & 2) {
            this.h &= -3;
            mu(this.$, this, this.ct);
        }
    }
    get untrackedValue() {
        this.p();
        return this.Zt;
    }
    p() {
        if (!(this.h & 1)) {
            return;
        }
        const t = mf(() => this.ot(...this.lt), this, ".", this.$);
        this.h &= -3;
        const n = t !== this.Zt;
        if (n) {
            this.h |= 2;
            this.Zt = t;
        }
    }
    rt() {
        return this.ot === Ri && hu(this.lt[0]) ? this.lt[0] : this;
    }
    set value(t) {
        throw Ie(31);
    }
    get value() {
        return super.value;
    }
}

class Ii {
    data;
    constructor(t) {
        this.data = t;
    }
}

Object.prototype.hasOwnProperty;

class Ni {
    type;
    children;
    flags;
    toSort;
    key;
    varProps;
    constProps;
    dev;
    _proxy=null;
    constructor(t, n, e, s, o, r, i, c) {
        this.type = t;
        this.children = s;
        this.flags = o;
        this.toSort = !!i;
        this.key = r === null || r === void 0 ? null : typeof r === "string" ? r : "" + r;
        this.varProps = !n || wr(n) ? ui : n;
        this.constProps = !e || wr(e) ? null : e;
    }
    get props() {
        return this._proxy ||= w(this);
    }
}

const Ci = (t, n, e) => {
    let s = t[n];
    if (!s) {
        t[n] = e;
        return !0;
    }
    Array.isArray(s) ? s.push(e) : s = t[n] = [ s, e ];
};

const Oi = t => t instanceof Ni;

const ji = (t, n) => {
    if (typeof t === "string") {
        const e = le(n);
        If(Nf(e, t));
    }
    return null;
};

function b(t, n) {
    ji(this, n);
    const e = xf[0];
    e.value = n.type === "number" ? n.valueAsNumber : n.value;
}

function v(t, n) {
    ji(this, n);
    const e = xf[0];
    e.value = n.checked;
}

function _(t, n) {
    ji(this, n);
    if (xf) {
        for (let t = 0; t < xf.length; t++) {
            const n = xf[t];
            n instanceof Zr && n.h & 64 && n.p();
        }
    }
}

const Li = "bind:value";

const Fi = "bind:checked";

const Xi = "passive:";

const Di = "preventdefault:";

const Vi = Object.prototype.hasOwnProperty;

const Wi = (t, n, e, s, o = !1) => {
    let r = t;
    let i = o;
    if (n.length > 0) {
        if (!i) {
            r = {
                ...r
            };
            i = !0;
        }
        for (let t = 0; t < n.length; t++) {
            const e = n[t];
            delete r[e];
        }
    }
    if (e.length > 0) {
        for (let t = 0; t < e.length; t++) {
            const n = e[t];
            if (s.has(Fs(n.slice(15)))) {
                if (!i) {
                    r = {
                        ...r
                    };
                    i = !0;
                }
                delete r[n];
            }
        }
    }
    return r;
};

const Ui = t => {
    if (t.startsWith("on") && t.endsWith("$")) {
        return Fs(t.slice(2, -1));
    }
    if (t.startsWith("window:on") && t.endsWith("$")) {
        return Fs(t.slice(9, -1));
    }
    if (t.startsWith("document:on") && t.endsWith("$")) {
        return Fs(t.slice(11, -1));
    }
    return null;
};

const zi = (t, n, s, o, r = !1) => {
    let i = t;
    let c = r;
    for (let t = 0; t < n.length; t++) {
        const r = n[t];
        const l = Ui(r);
        const u = e(r, o.has(l));
        if (u) {
            if (!c) {
                i = {
                    ...i
                };
                c = !0;
            }
            const t = s.get(u);
            (t === void 0 || t < s.get(r)) && (i[u] = i[r]);
            delete i[r];
        }
    }
    return i;
};

const Bi = (t, n, e, s, o, r, i) => new Ni(t, n, e, s, o, r, !1, i);

const Hi = (t, n, e, s, o, r, i) => {
    let c = !1;
    let l = !1;
    let u = !1;
    let f = null;
    let a = null;
    if (typeof t === "string") {
        const t = new Set;
        const s = [];
        const o = [];
        const r = [];
        const i = [];
        const h = [];
        const d = [];
        const p = new Map;
        const $ = new Map;
        if (e) {
            let n = 0;
            for (const o in e) {
                p.set(o, n++);
                if (o.startsWith(Xi)) {
                    r.push(o);
                    t.add(Fs(o.slice(8)));
                } else {
                    o.startsWith(Di) ? h.push(o) : Ui(o) !== null ? s.push(o) : o === Fi ? a = e[o] : o === Li && (f = e[o]);
                }
            }
        }
        if (n) {
            let e = 0;
            for (const s in n) {
                $.set(s, e++);
                if (s.startsWith(Xi)) {
                    i.push(s);
                    t.add(Fs(s.slice(8)));
                } else {
                    s.startsWith(Di) ? d.push(s) : Ui(s) !== null ? o.push(s) : s === Fi ? a = n[s] : s === Li && (f = n[s]);
                }
            }
        }
        if (e) {
            const n = e;
            e = Wi(e, r, h, t, l);
            l = l || e !== n;
            e = zi(e, s, p, t, l);
            l = l || e !== n;
        }
        if (n) {
            const e = n;
            n = Wi(n, i, d, t, u);
            u = u || n !== e;
            n = zi(n, o, $, t, u);
            u = u || n !== e;
            c = c || o.length > 0;
        }
        if (a || f) {
            if (!u) {
                n = {
                    ...n
                };
                u = !0;
            }
            n ||= {};
            if (a) {
                n && Vi.call(n, Fi) && delete n[Fi];
                if (e && Vi.call(e, Fi)) {
                    if (!l) {
                        e = {
                            ...e
                        };
                        l = !0;
                    }
                    delete e[Fi];
                }
                n.checked = a;
                const t = Lf(null, "_chk", v, null, [ a ]);
                if (e && Vi.call(e, "q-e:input")) {
                    if (!l) {
                        e = {
                            ...e
                        };
                        l = !0;
                    }
                    const t = e["q-e:input"];
                    delete e["q-e:input"];
                    c = Ci(n, "q-e:input", t) || c;
                }
                c = Ci(n, "q-e:input", t) || c;
            } else if (f) {
                n && Vi.call(n, Li) && delete n[Li];
                if (e && Vi.call(e, Li)) {
                    if (!l) {
                        e = {
                            ...e
                        };
                        l = !0;
                    }
                    delete e[Li];
                }
                n.value = f;
                const t = Lf(null, "_val", b, null, [ f ]);
                if (e && Vi.call(e, "q-e:input")) {
                    if (!l) {
                        e = {
                            ...e
                        };
                        l = !0;
                    }
                    const t = e["q-e:input"];
                    delete e["q-e:input"];
                    c = Ci(n, "q-e:input", t) || c;
                }
                c = Ci(n, "q-e:input", t) || c;
            }
        }
        if (n && Vi.call(n, "className")) {
            if (!u) {
                n = {
                    ...n
                };
                u = !0;
            }
            n.class = n.className;
            n.className = void 0;
            c = !0;
        }
        if (e && Vi.call(e, "className")) {
            if (!l) {
                e = {
                    ...e
                };
                l = !0;
            }
            e.class = e.className;
            e.className = void 0;
        }
    }
    if (n) {
        for (const t in n) {
            if (t === "children") {
                if (!u) {
                    n = {
                        ...n
                    };
                    u = !0;
                }
                s ||= n.children;
                delete n.children;
            } else if (t === "key") {
                if (!u) {
                    n = {
                        ...n
                    };
                    u = !0;
                }
                r ||= n.key;
                delete n.key;
            } else if (e && t in e) {
                if (!u) {
                    n = {
                        ...n
                    };
                    u = !0;
                }
                delete n[t];
            } else if (n[t] === null) {
                if (!u) {
                    n = {
                        ...n
                    };
                    u = !0;
                }
                delete n[t];
            }
        }
    }
    return new Ni(t, n, e, s, o, r, c || !0, i);
};

const Ji = (t, n, e, s) => Ki(t, n, s);

const Qi = (t, n, e, s, o) => Ki(t, {
    ...e,
    ...n
}, o);

const Yi = (t, n, e, s, o, r) => Ki(t, {
    ...e,
    ...n,
    children: s
}, r);

const Gi = t => t.children;

const Ki = (t, n, e, s, o) => Hi(t, n, null, null, 0, e, o);

const Zi = Ki;

const to = Ki;

function g(t, n, ...e) {
    const s = {
        children: arguments.length > 2 ? e.flat(100) : null
    };
    let o = null;
    for (const t in n) {
        t == "key" ? o = n[t] : s[t] = n[t];
    }
    return Hi(t, n, null, s.children, 0, o);
}

const no = t => t.children;

const eo = (t, n) => new Ni(Gi, null, null, t.children, 0, n);

const so = t => Bi(Gi, null, {
    [Be]: ""
}, t.children, 0, t.name ?? "");

const ro = Symbol();

const io = () => null;

const oo = () => null;

const lo = t => t.children;

const uo = (t, n) => Ki(eo, {
    children: Ki(co, t)
}, n);

const co = () => null;

let fo = null;

let ao = null;

function E(t, n, e, s) {
    if (e != null) {
        if (s) {
            const s = function o(t) {
                switch (t) {
                  case "xlink:href":
                  case "xlink:actuate":
                  case "xlink:arcrole":
                  case "xlink:role":
                  case "xlink:show":
                  case "xlink:title":
                  case "xlink:type":
                    return "http://www.w3.org/1999/xlink";

                  case "xml:base":
                  case "xml:lang":
                  case "xml:space":
                    return "http://www.w3.org/XML/1998/namespace";

                  default:
                    return null;
                }
            }(n);
            if (s) {
                ((t, n, e, s) => {
                    ao || (ao = t.setAttributeNS);
                    ao.call(t, n, e, s);
                })(t, s, n, e);
                return;
            }
        }
        ((t, n, e) => {
            fo || (fo = t.setAttribute);
            fo.call(t, n, e);
        })(t, n, e);
    }
}

const ho = Object.prototype.hasOwnProperty;

function S(t) {
    return !t.startsWith("q:") && !t.startsWith(":");
}

const po = (t, n = [], e = {}) => {
    let s = null;
    const o = t[ni];
    if (o) {
        for (const t in o) {
            if (!n.includes(t)) {
                s ||= {};
                s[t] = o[t];
            }
        }
    }
    const r = e;
    const i = t[ei];
    for (const t in i) {
        n.includes(t) || (r[t] = i[t]);
    }
    return w(new Ni(null, r, s, null, 0, null));
};

function k(t, n, e) {
    const s = n.constProps;
    if (s && typeof s == "object" && ho.call(s, "name")) {
        const n = s.name;
        if (t && n instanceof xi) {
            return wf(n, t, ":", e);
        }
    }
    return hi(n, "name") || "";
}

class $o {
    target;
    constructor(t) {
        this.target = t;
    }
}

class yo {
    target;
    constructor(t) {
        this.target = t;
    }
}

class mo {
    target;
    text;
    constructor(t, n) {
        this.target = t;
        this.text = n;
    }
}

class wo {
    target;
    parent;
    beforeTarget;
    constructor(t, n, e) {
        this.target = t;
        this.parent = n;
        this.beforeTarget = e;
    }
}

class bo {
    target;
    attrName;
    attrValue;
    scopedStyleIdPrefix;
    isSvg;
    constructor(t, n, e, s, o) {
        this.target = t;
        this.attrName = n;
        this.attrValue = e;
        this.scopedStyleIdPrefix = s;
        this.isSvg = o;
    }
}

const vo = t => new $o(t);

const _o = t => new yo(t);

const go = (t, n) => new mo(t, n);

const Eo = (t, n, e) => new wo(t, n, e);

const So = (t, n, e, s = null, o = !1) => new bo(t, n, e, s, o);

const ko = () => {
    const t = df();
    const n = t.m;
    const e = n;
    let s = t.$.getHostProp(e, ws);
    if (s === null) {
        s = [];
        t.$.setHostProp(e, ws, s);
    }
    let o = t.$.getHostProp(e, bs);
    o === null && (o = 0);
    t.$.setHostProp(e, bs, o + 1);
    for (;s.length <= o; ) {
        s.push(void 0);
    }
    return {
        val: s[o],
        set: t => s[o] = t,
        i: o,
        iCtx: t
    };
};

const Ro = t => {
    const n = xe(t) && !Kf(t) ? de(void 0, t) : t;
    return gi(n);
};

const Po = t => To(Ro, t);

const To = (t, ...n) => {
    const {val: e, set: s} = ko();
    if (e != null) {
        return e;
    }
    t = xe(t) && !Kf(t) ? $f(t, ...n) : t;
    return s(t);
};

const qo = () => ({
    pending: gi(0),
    version: gi(0)
});

function R(t, n) {
    if (!__EXPERIMENTAL__.suspense) {
        return;
    }
    const e = q(t.container, n);
    if (!e) {
        return;
    }
    const s = t.boundaries ||= [];
    if (!s.includes(e)) {
        s.push(e);
        e.pending.value++;
    }
}

function P(t, n) {
    if (!__EXPERIMENTAL__.suspense) {
        return null;
    }
    return t.getHostProp(n, us);
}

function T(t) {
    if (!__EXPERIMENTAL__.suspense) {
        return;
    }
    il(t, Rs, null);
}

function q(t, n) {
    if (!__EXPERIMENTAL__.suspense) {
        return null;
    }
    return function e(t) {
        if (!__EXPERIMENTAL__.suspense) {
            return null;
        }
        return rl(t, Rs, null) || null;
    }(n) || P(t, n);
}

function M(t, n) {
    __EXPERIMENTAL__.suspense && il(t, Rs, n);
}

function A(t, n, e) {
    if (!__EXPERIMENTAL__.suspense) {
        return;
    }
    M(n, e);
    const s = n.dirtyChildren;
    if (!s || s.length === 0) {
        return;
    }
    for (let n = 0; n < s.length; n++) {
        const o = s[n];
        A(t, o, P(t, o) || e);
    }
}

const Mo = t => {
    if (t.Tn) {
        try {
            t.Tn();
        } catch (t) {
            ((t, ...n) => {
                Ee(!1, t, ...n);
            })(t);
        }
        t.Tn = null;
    }
};

function x(t, e, s, o) {
    if (!s.isConnected) {
        return;
    }
    o || (o = pf(e, s));
    const r = o.$;
    const i = o.m;
    ul(r, i);
    let c = t;
    if (i.flags & 64) {
        let n;
        if (!(i.flags & 128)) {
            n = !0;
            i.flags |= 128;
        }
        const o = n ? r._ : null;
        const l = rl(i, vs, o);
        if (l !== null) {
            c = () => t(e, s, l);
        } else {
            const n = rl(i, _s, o);
            n !== null && (c = () => t(e, s, ...n));
        }
    }
    return n(() => {
        if (!(i.flags & 32)) {
            return pe(o, c, [ e, s ]);
        }
    }, t => r.handleError(t, i));
}

function I(t, n) {
    if (!n.isConnected) {
        return;
    }
    const e = pf(t, n);
    typeof this === "string" && If(Nf(e.$, this));
    const s = xf[0];
    return x(s, t, n, e);
}

function N(t) {
    return t.k === t.R ? t.T : null;
}

function C(t) {
    return t.q || N(t);
}

function O(t, n) {
    const e = function s(t) {
        return t ? t.nextSibling : null;
    }(n);
    const o = N(t);
    return e === o ? null : e;
}

const Ao = Object.prototype.hasOwnProperty;

function j(t, n, e, s, o, r) {
    il(n, e, r);
    mn(t, So(n.node, e, s, o, (n.flags & 512) !== 0));
}

function L(t, n, e, s) {
    return {
        $: t,
        M: n,
        N: e,
        O: s,
        j: [],
        L: [],
        X: [],
        k: null,
        q: null,
        D: null,
        T: null,
        R: null,
        W: null,
        U: null,
        B: null,
        H: null,
        J: null,
        Y: 0,
        G: 0,
        K: !0,
        Z: !1,
        tt: {
            nt: new Ii({
                O: s,
                et: !0
            }),
            st: new Ii({
                O: s,
                et: !1
            })
        }
    };
}

function F(t, n, e, s, o) {
    const r = t ?? L(n, e, s, o);
    (function i(t, n, e, s, o) {
        t.$ = n;
        t.M = e;
        t.N = s;
        t.O = o;
        t.tt.nt.data.O = o;
        t.tt.st.data.O = o;
        t.L.length = 0;
        t.X.length = 0;
    })(r, n, e, s, o);
    return r;
}

const xo = (t, n, e, s, o, r, i) => X(F(i, t, n, o, r), e, s);

const Io = (t, n, e, s, o, r, i, c, l = !1, u) => X(F(u, t, n, i, c), e, s, o, r, l);

function X(t, n, e, s = Il(e), o = null, r = !1) {
    D(t, n, e, s, o, r);
    const i = G(t);
    if (As(i)) {
        return i.finally(() => {
            K(t);
        });
    }
    K(t);
}

function D(t, n, e, s = Il(e), o = null, r = !1) {
    const i = t.Z;
    t.Z = r || i;
    t.k = e;
    t.D = null;
    t.q = s;
    t.T = o;
    t.R = e;
    B(t, n, !0);
    try {
        if (t.k.flags & 32) {
            return;
        }
        for (;t.j.length; ) {
            for (;t.Y < t.G; ) {
                if (typeof t.J === "string") {
                    mt(t, t.J);
                } else if (typeof t.J === "number") {
                    mt(t, t.J + "");
                } else if (t.J && typeof t.J === "object") {
                    if (Oi(t.J)) {
                        const n = t.J.type;
                        if (typeof n === "string") {
                            nt(t);
                            ct(t, t.J, n);
                            const e = t.J.constProps && Ao.call(t.J.constProps, Ts) || Ao.call(t.J.varProps, Ts);
                            e ? t.D || Z(t, !1) : U(t, t.J.children, !0);
                        } else if (typeof n === "function") {
                            if (n === no) {
                                nt(t);
                                dt(t, "F", t.J.key);
                                U(t, t.J.children, !0);
                            } else if (n === so) {
                                nt(t);
                                Q(t) || U(t, t.J.children, !0);
                            } else if (n === vt) {
                                J(t);
                                U(t, t.J.children, !0, !0);
                            } else if (n === oo) {
                                tt(t);
                            } else if (n === io) {
                                tt(t);
                            } else {
                                nt(t);
                                pt(t, n);
                            }
                        }
                    } else if (Array.isArray(t.J)) {
                        U(t, t.J, !1);
                    } else if (hu(t.J)) {
                        dt(t, "S", null);
                        const n = t.J instanceof xi ? t.J.rt() : t.J;
                        const e = t.q?.[Rr]?.get(".")?.backRef;
                        let s = e?.has(n);
                        e && n instanceof xi && (s = xt(e, n));
                        if (!s) {
                            const e = t.D || t.q;
                            U(t, V(t, () => wf(n, e, ".", t.$)), !0);
                        }
                    } else if (As(t.J)) {
                        dt(t, "A", null);
                        t.L.push(t.J, t.D || t.q);
                    }
                } else {
                    t.J === ro || mt(t, "");
                }
                W(t);
            }
            tt(t);
            Y(t);
            z(t);
        }
    } finally {
        t.Z = i;
    }
}

function V(t, e) {
    try {
        return e();
    } catch (s) {
        if (As(s)) {
            const o = s.then(() => n(e));
            t.L.push(o, t.D || t.q);
            return null;
        }
        throw s;
    }
}

function W(t) {
    if (!t.K) {
        t.K = !0;
        return;
    }
    t.Y++;
    if (t.Y < t.G) {
        t.J = t.H[t.Y];
    } else if (t.j.length > 0 && t.j[t.j.length - 1] === !1) {
        return z(t);
    }
    t.D !== null ? t.D = null : t.q = O(t, t.q);
}

function U(t, n, e, s = !1) {
    if (!s && (n == null || e && Me(n) && n.length === 0)) {
        Z(t);
        return;
    }
    B(t, n, e);
    if (e) {
        const n = !s && t.Z || !!t.D || !Il(t.q);
        t.Z = n;
        t.B = null;
        t.W = null;
        t.U = null;
        t.k = t.D || t.q;
        t.q = Il(t.k);
        t.D = null;
    }
    t.K = !1;
}

function z(t) {
    const n = t.j.pop();
    if (n) {
        t.Z = t.j.pop();
        t.B = t.j.pop();
        t.W = t.j.pop();
        t.U = t.j.pop();
        t.D = t.j.pop();
        t.q = t.j.pop();
        t.k = t.j.pop();
    }
    t.J = t.j.pop();
    t.G = t.j.pop();
    t.Y = t.j.pop();
    t.H = t.j.pop();
    W(t);
}

function B(t, n, e) {
    t.j.push(t.H, t.Y, t.G, t.J);
    e && t.j.push(t.k, t.q, t.D, t.U, t.W, t.B, t.Z);
    t.j.push(e);
    if (Array.isArray(n)) {
        t.Y = 0;
        t.G = n.length;
        t.H = n;
        t.J = t.G > 0 ? n[0] : null;
    } else if (n === void 0) {
        t.Y = 0;
        t.J = null;
        t.H = null;
        t.G = 0;
    } else {
        t.Y = 0;
        t.J = n;
        t.H = null;
        t.G = 1;
    }
}

function H(t) {
    if (t.D) {
        return C(t);
    }
    return O(t, t.q) || N(t);
}

function J(t) {
    const n = t.J;
    const e = n.key;
    t.q = rl(t.k, e, n => hl(t.$.rootVNode, n));
    t.q = t.q && t.q.flags & 32 ? null : t.q;
    if (t.q == null) {
        t.D = Yo();
        il(t.D, ze, e);
        t.D.slotParent = t.k;
        il(t.k, e, t.D);
    }
}

function Q(t) {
    const n = t.J;
    const e = ou(t.k);
    const s = k(e, n, t.$);
    const o = hi(n, us) || null;
    const r = e ? rl(e, s, null) : null;
    if (r == null) {
        t.D = Yo();
        il(t.D, ze, s);
        il(t.D, us, o);
        A(t.$, t.D, o);
        e && il(e, s, t.D);
        kl(t.M, t.k, t.D, H(t));
        return !1;
    }
    if (r === t.q) {} else {
        const n = r.parent;
        t.D = r;
        il(t.D, ze, s);
        il(t.D, us, o);
        A(t.$, t.D, o);
        e && il(e, s, t.D);
        Sl(t.M, t.D);
        kl(t.M, t.k, t.D, H(t));
        n && Ko(n) && !n.firstChild && Ml(n) === cs && Tl(t.M, n.parent, n, !0);
    }
    return !0;
}

function Y(t) {
    const n = t.B;
    if (n) {
        for (const e of n.values()) {
            if (e.flags & 32) {
                continue;
            }
            Et(t.$, t.M, e, t.N);
            Tl(t.M, t.k, e, !0);
        }
        n.clear();
        t.B = null;
    }
    t.q = null;
}

function G(t) {
    for (;t.L.length; ) {
        const n = t.L.shift();
        const e = t.L.shift();
        if (As(n)) {
            return n.then(n => {
                D(t, n, e);
                return G(t);
            }).catch(n => {
                t.$.handleError(n, e);
                return G(t);
            });
        }
        D(t, n, e);
    }
    if (t.X.length) {
        const n = t.X.splice(0);
        return Promise.all(n).then(() => G(t));
    }
}

function K(t) {
    t.M = null;
    t.N = null;
}

function Z(t, n = !0) {
    const e = t.q && Il(t.q);
    if (e !== null) {
        let s = e;
        for (;s; ) {
            Et(t.$, t.M, s, t.N);
            s = s.nextSibling;
        }
        ql(t.M, t.q, e, n);
    }
}

function tt(t) {
    const n = N(t);
    if (t.q !== null && t.q !== n) {
        for (;t.q && t.q !== n; ) {
            const n = t.q;
            t.q = O(t, t.q);
            if (t.k === n.parent) {
                Et(t.$, t.M, n, t.N);
                Tl(t.M, t.k, n, !0);
            }
        }
    }
}

function nt(t) {
    if (t.q !== null && nl(t.q)) {
        const n = t.q;
        t.q = O(t, t.q);
        Tl(t.M, t.k, n, !0);
    }
}

function et(t, n, e) {
    if (hu(t)) {
        t.value = n;
        return !0;
    }
    if (typeof t === "function") {
        t(n);
        return !0;
    }
    if (t == null) {
        return !0;
    }
    throw Ie(15, [ e ]);
}

function st(t, e, s, o, r) {
    return n(() => wf(o, e, s, t, r));
}

function rt(t, n, e, o, r) {
    const i = t.O;
    const c = o.then(t => E(n, e, s(e, t, i), r));
    t.X.push(c);
}

function it(t, n) {
    if (n) {
        t.innerHTML = n + "";
        t.setAttribute(os, "html");
    }
}

function ot(t, n) {
    if (n && typeof n !== "string") {
        return !0;
    }
    t.value = function e(t) {
        let n = "";
        const e = t.length;
        let s = 0;
        let o = s;
        for (;s < e; s++) {
            const e = t.charCodeAt(s);
            if (e === 60) {
                n += t.substring(o, s) + "&lt;";
            } else if (e === 62) {
                n += t.substring(o, s) + "&gt;";
            } else if (e === 38) {
                n += t.substring(o, s) + "&amp;";
            } else if (e === 34) {
                n += t.substring(o, s) + "&quot;";
            } else {
                if (e !== 39) {
                    continue;
                }
                n += t.substring(o, s) + "&#39;";
            }
            o = s + 1;
        }
        return o === 0 ? t : n + t.substring(o);
    }(n || "");
    return !0;
}

function lt(t, n, e, r) {
    const i = function c(t, n) {
        const e = Pl(t.k, !0);
        const s = o(e, n);
        const r = document;
        const i = s.elementNamespaceFlag === 0 ? r.createElement(n) : r.createElementNS(s.elementNamespace, n);
        t.D = Ho(i, n);
        t.D.flags |= s.elementNamespaceFlag;
        return i;
    }(t, e);
    const l = t.D;
    const u = (l.flags & 512) !== 0;
    const {constProps: f} = n;
    if (f) {
        for (const n in f) {
            let o = f[n];
            if (Ls(n)) {
                ut(n, o, i, l, t);
                continue;
            }
            if (n === "ref" && et(o, i, r)) {
                continue;
            }
            hu(o) && (o = st(t.$, t.D, n, o, t.tt.nt));
            if (As(o)) {
                rt(t, i, n, o, u);
                continue;
            }
            if (n === Ts) {
                it(i, o);
                continue;
            }
            if (e === "textarea" && n === "value" && ot(i, o)) {
                continue;
            }
            E(i, n, s(n, o, t.O), u);
        }
    }
    const a = n.key;
    a && (t.D.key = a);
    if (t.O) {
        const e = Ao.call(n.varProps, "class") || n.constProps && Ao.call(n.constProps, "class");
        e || i.setAttribute("class", t.O);
    }
    bl(t.M, t.k, t.D, C(t));
}

function ut(t, n, e, s, o) {
    const r = t.slice(2);
    if (Array.isArray(n)) {
        const t = n;
        const s = [];
        for (let n = 0; n < t.length; n++) {
            const e = t[n];
            if (Array.isArray(e)) {
                for (let t = 0; t < e.length; t++) {
                    const n = e[t];
                    n && s.push(x.bind(null, n));
                }
            } else {
                e && s.push(x.bind(null, e));
            }
        }
        s.length > 0 && ((e._qDispatch ||= {})[r] = s.length === 1 ? s[0] : s);
    } else {
        n && ((e._qDispatch ||= {})[r] = x.bind(null, n));
    }
    t.charAt(2) !== "e" && ol(o.M, s, t, "");
    (function i(t, n) {
        const e = window;
        e && (e._qwikEv ||= []).push(n);
    })(0, r);
}

function ct(t, n, e) {
    if (t.Z) {
        lt(t, n, e, null);
    } else {
        const s = t.q && Ko(t.q);
        const o = s && e === Ml(t.q);
        const r = n.key;
        const i = s && t.q.key;
        if (o && r === i) {
            at(t, e, r);
        } else {
            const s = ft(e, r);
            ht(t, e, r, s, t.k) && lt(t, n, e, null);
        }
    }
    const s = n.varProps;
    const o = t.D || t.q;
    s && function r(t, n, e, s) {
        t.Z || ul(t.$, n);
        const o = n.props;
        for (const r in e) {
            const i = e[r];
            if (o && Ao.call(o, r)) {
                const e = o[r];
                Pt(i, e) || No(t, n, r, i, s);
            } else {
                i != null && No(t, n, r, i, s);
            }
        }
        if (o) {
            for (const r in o) {
                Ao.call(e, r) || r.charAt(0) === ":" || Ls(r) || No(t, n, r, null, s);
            }
        }
    }(t, o, s, null);
}

const No = (t, n, e, s, o) => {
    if (Ls(e)) {
        ut(e, s, n.node, n, t);
        return;
    }
    if (e === vs || e === _s) {
        il(n, e, s);
        n.flags |= 192;
        return;
    }
    const r = s;
    if (e === "ref") {
        const t = n.node;
        if (et(s, t, o)) {
            return;
        }
    }
    const i = n[Rr]?.get(e);
    if (hu(s)) {
        const o = s instanceof xi ? s.rt() : s;
        if (i?.backRef?.has(o)) {
            return;
        }
        i && Rn(t.$, i);
        const r = n;
        s = st(t.$, r, e, o, t.tt.st);
    } else {
        i && Rn(t.$, i);
    }
    if (As(s)) {
        const o = n;
        const i = s.then(n => {
            j(t.M, o, e, n, t.O, r);
        });
        t.X.push(i);
        return;
    }
    j(t.M, n, e, s, t.O, r);
};

function ft(t, n) {
    if (n == null) {
        return null;
    }
    return t ? t + ":" + n : n;
}

function at(t, n, e) {
    const s = ft(n, e);
    if (s && t.B?.has(s)) {
        t.B.delete(s);
        return !0;
    }
    return !1;
}

function ht(t, n, e, s, o, r) {
    t.D = function i(t, n, e) {
        let s = null;
        if (t.W === null) {
            const o = t.q;
            if (o) {
                const s = Ko(o) ? Ml(o) : null;
                const r = wt(o) || bt(o, t.$._);
                if (r === e && s === n) {
                    return o;
                }
            }
            t.W = new Map;
            t.U = [];
            const r = N(t);
            let i = t.q;
            for (;i && i !== r; ) {
                const o = Ko(i) ? Ml(i) : null;
                const r = wt(i) || bt(i, t.$._);
                s === null && r == e && o == n ? s = i : r === null ? t.U.push(o, i) : t.W.set(ft(o, r), i);
                i = i.nextSibling;
            }
        } else if (e === null) {
            for (let e = 0; e < t.U.length; e += 2) {
                if (t.U[e] === n) {
                    s = t.U[e + 1];
                    t.U.splice(e, 2);
                    break;
                }
            }
        } else {
            const o = ft(n, e);
            const r = t.W.get(o);
            if (r) {
                s = r;
                t.W.delete(o);
            }
        }
        (function o(t, n) {
            if (!n) {
                if (t.q) {
                    const n = Ko(t.q) ? Ml(t.q) : null;
                    const e = wt(t.q) || bt(t.q, t.$._);
                    if (e != null) {
                        const s = ft(n, e);
                        t.B ||= new Map;
                        t.B.set(s, t.q);
                        t.W?.delete(s);
                    }
                }
                return;
            }
            const e = N(t);
            let s = t.q;
            for (;s && s !== n && s !== e; ) {
                const n = Ko(s) ? Ml(s) : null;
                const e = wt(s) || bt(s, t.$._);
                if (e != null) {
                    const o = ft(n, e);
                    t.B ||= new Map;
                    t.B.set(o, s);
                    t.W?.delete(o);
                }
                s = s.nextSibling;
            }
        })(t, s);
        return s;
    }(t, n, e);
    if (t.D) {
        s || kl(t.M, o, t.D, C(t));
        t.q = t.D;
        t.D = null;
        return !1;
    }
    if (s != null) {
        const n = t.B?.get(s) || null;
        if (n) {
            t.B.delete(s);
            if (r && t.q) {
                const n = wt(t.q) || bt(t.q, t.$._);
                if (n != null) {
                    const e = Ko(t.q) ? Ml(t.q) : null;
                    const s = ft(e, n);
                    if (s != null) {
                        t.B ||= new Map;
                        t.B.set(s, t.q);
                    }
                }
            }
            n !== t.q && kl(t.M, o, n, C(t));
            t.q = n;
            t.D = null;
            return !1;
        }
    }
    return !0;
}

function dt(t, n, e) {
    const s = n === "F";
    const o = wt(t.q);
    const r = t.q && el(t.q);
    const i = r && o === e && (!s || !!e);
    if (i) {
        at(t, null, o);
        return;
    }
    if (e === null || t.Z) {
        vl(t.M, t.k, t.D = Yo(), H(t));
        t.D.key = e;
        return;
    }
    if (ht(t, null, e, ft(null, e), t.k, !0)) {
        vl(t.M, t.k, t.D = Yo(), H(t));
        t.D.key = e;
    }
}

function pt(t, n) {
    const e = n[Gf];
    let s = t.D || t.q;
    const o = t.J;
    if (e) {
        const n = o.props;
        let r = !1;
        const [i] = e;
        const c = i.it;
        const l = bt(s, t.$._);
        const u = o.key || c;
        const f = wt(s) || l;
        const a = u === f;
        const h = c === l;
        if (a) {
            if (h) {
                at(t, null, u);
            } else {
                $t(t, s, i, n);
                s = t.D;
                r = !0;
            }
        } else {
            if (ht(t, null, u, u, t.k)) {
                $t(t, s, i, n);
                r = !0;
            }
            s = t.D || t.q;
        }
        if (s) {
            const e = rl(s, ms, t.$._);
            if (!r) {
                const c = function l(t, n, e, s) {
                    let o = !1;
                    if (e) {
                        const t = _t(n[ni], e[ni], e[ri], s, !1);
                        o ||= t;
                        const r = _t(n[ei], e[ei], e[ri], s, !0);
                        o ||= r;
                        e[si] = n[si];
                    } else if (n) {
                        il(t, ms, n);
                        e = n;
                    }
                    return o;
                }(s, n, e, t.$);
                if (c && o.key == null) {
                    $t(t, s, i, n);
                    s = t.D;
                    r = !0;
                }
                r ||= c;
            }
            if (r) {
                il(s, Ve, i);
                s.flags &= -33;
                yn(t.$, s, 4, t.N);
            }
        }
        (function d(t, n, e) {
            const s = Array.isArray(n) ? n : [ n ];
            const o = t => new Ni(vt, null, null, [], 0, t);
            const r = [];
            if (e) {
                const t = e.props;
                if (t) {
                    for (const n in t) {
                        if (S(n)) {
                            const t = n;
                            ke(r, t, o(t), 0);
                        }
                    }
                }
            }
            if (r.length === 0 && n == null) {
                return;
            }
            for (let t = 0; t < s.length; t++) {
                const n = s[t];
                const e = (Oi(n) && hi(n, ze) || "") + "";
                const i = Se(r, e, 0);
                let c;
                i >= 0 ? c = r[i + 1] : r.splice(~i, 0, e, c = o(e));
                const l = n === !1;
                l || c.children.push(n);
            }
            for (let t = r.length - 2; t >= 0; t -= 2) {
                r.splice(t, 1);
            }
            U(t, r, !0);
        })(t, o.children, s);
    } else {
        const e = o.key;
        const r = wt(s);
        const i = e === r;
        const c = bt(s, t.$._);
        const l = c == null;
        if (s && !l || !s) {
            yt(t);
            s = t.D;
        } else if (i) {
            at(t, null, e);
        } else {
            ht(t, null, e, e, t.k) && yt(t);
            s = t.D || t.q;
        }
        if (s) {
            let e = s;
            for (;e && (!el(e) || rl(e, Ve, null) === null); ) {
                e = e.parent || ou(e);
            }
            (function r(t, n, e, s) {
                const o = t.props ||= {};
                o[Wr] = {
                    componentFn: n,
                    subscriptionHost: e,
                    props: s
                };
            })(s, n, e, o.props);
            yn(t.$, s, 8, t.N);
        }
    }
}

function $t(t, n, e, s) {
    n && kn(t.$, n);
    vl(t.M, t.k, t.D = Yo(), H(t));
    const o = t.J;
    il(t.D, Ve, e);
    il(t.D, ms, s);
    t.D.key = o.key;
}

function yt(t) {
    vl(t.M, t.k, t.D = Yo(), H(t));
    const n = t.J;
    il(t.D, ms, n.props);
    n.key && (t.D.key = n.key);
}

function mt(t, n) {
    if (t.q !== null) {
        const e = ru(t.q);
        if (e === 3) {
            if (n !== Al(t.q)) {
                xl(t.M, t.q, n);
                return;
            }
            return;
        }
    }
    bl(t.M, t.k, t.D = Qo(document.createTextNode(n), n), C(t));
}

function wt(t) {
    if (t == null || nl(t)) {
        return null;
    }
    return t.key;
}

function bt(t, n) {
    if (t == null || nl(t)) {
        return null;
    }
    const e = rl(t, Ve, n);
    return e ? e.it : null;
}

function vt() {}

function _t(t, n, e, s, o = !0) {
    if (gt(t) && gt(n)) {
        return !1;
    }
    e.$ = s;
    let r = !1;
    if (t) {
        for (const s in t) {
            if (s === "children" || s === Ze) {
                continue;
            }
            const i = t[s];
            const c = n?.[s];
            if (!n || !Pt(i, c) && !Tt(i, c)) {
                if (s === "class") {
                    if (Mt(i, c)) {
                        continue;
                    }
                } else if (s === "style" && qt(i, c)) {
                    continue;
                }
                if (!o) {
                    return !0;
                }
                {
                    n && (n[s] = i);
                    const t = ai(e, s);
                    t || (r = !0);
                }
            }
        }
    }
    if (n) {
        for (const s in n) {
            if (s === "children" || s === Ze) {
                continue;
            }
            if ((!t || !Ao.call(t, s)) && o) {
                delete n[s];
                const t = ai(e, s);
                t || (r = !0);
            }
        }
    }
    return r;
}

function gt(t) {
    if (!t) {
        return !0;
    }
    return wr(t);
}

function Et(t, n, e, s = null) {
    let o = e;
    const r = s && dn(s) ? y(s) : null;
    if (nl(e)) {
        Rt(o);
        return;
    }
    let i = null;
    for (;;) {
        r && o !== s && dn(o) && a(t, r, o);
        const c = o.flags;
        if (c & 3) {
            kn(t, o);
            Rt(o);
            const r = c & 2 && rl(o, Ve, null) !== null;
            if (r) {
                const e = t.getHostProp(o, ws);
                if (e) {
                    for (let n = 0; n < e.length; n++) {
                        const r = e[n];
                        if (qe(r)) {
                            const n = fu(r);
                            if (n && r.h & 1) {
                                r.h |= 16;
                                yn(t, o, 128, s);
                                continue;
                            }
                            (r instanceof Gr || r instanceof xi) && (r.h & 4 || kn(t, r));
                            (n || r instanceof Zr) && Mo(r);
                        }
                    }
                }
                const r = o.props;
                if (r) {
                    const e = Object.keys(r);
                    for (let o = 0; o < e.length; o++) {
                        const i = e[o];
                        if (S(i)) {
                            const e = r[i];
                            if (e) {
                                r[i] = null;
                                const o = typeof e === "string" ? hl(t.rootVNode, e) : e;
                                let c = Il(o);
                                for (;c; ) {
                                    Et(t, n, c, s);
                                    c = c.nextSibling;
                                }
                                kt(t, n, o);
                            }
                        }
                    }
                }
            }
            const i = sl(o);
            if (i) {
                if (o === e) {
                    const n = Il(o);
                    if (n) {
                        vn(n);
                        return;
                    }
                    St(t, o);
                }
            } else {
                const t = Il(o);
                if (t) {
                    o = t;
                    continue;
                }
            }
        } else {
            c & 4 && Rt(o);
        }
        if (o === e) {
            return;
        }
        const l = o.nextSibling;
        if (l) {
            o = l;
            continue;
        }
        i = o.parent;
        for (;i; ) {
            if (i === e) {
                return;
            }
            const t = i.nextSibling;
            if (t) {
                o = t;
                break;
            }
            i = i.parent;
        }
        if (i == null) {
            return;
        }
    }
}

function St(t, n) {
    if (!n.slotParent) {
        return;
    }
    const e = t.getHostProp(n, ze);
    e != null && t.getHostProp(n.slotParent, e) === n && il(n.slotParent, e, null);
}

function kt(t, n, e) {
    const s = e.parent;
    if (s) {
        const o = s.flags;
        if (o & 1 && Ml(s) === cs) {
            St(t, e);
            Tl(n, s, e, !0);
        }
    }
}

function Rt(t) {
    t.flags |= 32;
}

function Pt(t, n) {
    if (t === n) {
        return !0;
    }
    return t instanceof xi && n instanceof xi && At(n, t);
}

function Tt(t, n) {
    if (t === n) {
        return !0;
    }
    if (hu(t) && hu(n)) {
        const e = t instanceof xi ? t.rt() : t;
        const s = n instanceof xi ? n.rt() : n;
        return $f(() => e.value === s.value);
    }
    return !1;
}

function qt(t, n) {
    if (t === n) {
        return !0;
    }
    return Bs(t) === Bs(n);
}

function Mt(t, n) {
    if (t === n) {
        return !0;
    }
    return Us(t) === Us(n);
}

function At(t, n) {
    if (t === n) {
        return !0;
    }
    return n.ot === t.ot && function e(t, n) {
        if (t === n) {
            return !0;
        }
        if (!t || !n || t.length !== n.length) {
            return !1;
        }
        for (let e = 0; e < t.length; e++) {
            if (t[e] !== n[e]) {
                return !1;
            }
        }
        return !0;
    }(n.lt, t.lt);
}

function xt(t, n) {
    if (!(n instanceof xi)) {
        return !1;
    }
    for (let e = 0; e < t.length; e++) {
        const s = t[e];
        if (s instanceof xi && At(s, n)) {
            return !0;
        }
    }
    return !1;
}

const Co = (t, n, e, s, o) => {
    const r = $e(t.jt, n, t);
    if (e) {
        r.Ft = m(e, ":");
        r.$ = t;
    }
    let i;
    t.ensureProjectionResolved(n);
    let c = !1;
    s === null && (s = t.getHostProp(n, Ve));
    if (Ce(s)) {
        o = o || t.getHostProp(n, ms) || ui;
        "children" in o && delete o.children;
        i = s.getFn(r);
    } else if (Kf(s)) {
        const t = s;
        i = () => pe(r, t, [ o || ui, null, 0 ]);
    } else {
        c = !0;
        const t = s;
        i = () => pe(r, t, [ o || ui ]);
    }
    const l = be;
    const u = (e = 0) => xs(() => {
        if (!c) {
            t.setHostProp(n, bs, null);
            t.setHostProp(n, Ss, null);
        }
        e > 0 && Go(n) && kn(t, n);
        return Is(i(o), t => Is(r.Xt, () => t));
    }, s => {
        if (l && !c) {
            const t = n;
            if (t.dirty & 4) {
                t.dirty &= -5;
                if (e < Ms) {
                    return u(e + 1);
                }
            }
        }
        const o = t.getHostProp(n, Es);
        if (o) {
            return function r(t, n, e) {
                const s = Ot(n);
                let o = n;
                const r = "q-e:qvisible";
                return Is(s, n => {
                    const s = !n;
                    let i = null;
                    for (const c in e) {
                        if (Object.prototype.hasOwnProperty.call(e, c)) {
                            let l = n;
                            let u = c;
                            if (s) {
                                if (c !== r && !c.startsWith("q-d:") && !c.startsWith("q-w:")) {
                                    continue;
                                }
                                if (!i) {
                                    i = Lt();
                                    const n = be;
                                    n && t.ut(i) || (o = jt(o, i));
                                }
                                l = i;
                            }
                            if (l) {
                                l.type === "script" && c === r && (u = "q-d:qinit");
                                Nt(l, u, e[c]);
                            }
                        }
                    }
                    return o;
                });
            }(t, s, o);
        }
        return s;
    }, t => {
        if (As(t) && e < Ms) {
            return t.then(() => u(++e));
        }
        if (e >= Ms) {
            throw Error("Max retry count of component execution reached");
        }
        throw t;
    });
    return u();
};

function Nt(t, n, e) {
    const s = t.constProps ||= {};
    const o = s[n];
    const r = e.qrls;
    o == null ? s[n] = r : Array.isArray(o) ? o.push(...r) : s[n] = [ o, ...r ];
    const i = t.varProps[n];
    if (i) {
        Array.isArray(o) ? o.push(...s[n]) : t.varProps[n] = [ o, ...r ];
        s[n] = void 0;
    }
    const c = e.capture;
    const l = e.preventdefault;
    const u = e.stoppropagation;
    if (!c && !l && !u) {
        return;
    }
    const [, f] = Ds(n);
    c && Ct(t, f, "capture");
    l && Ct(t, f, "preventdefault");
    u && Ct(t, f, "stoppropagation");
}

function Ct(t, n, e) {
    const s = `${e}:${n}`;
    const o = t.varProps;
    o === ui && (t.varProps = {});
    t.varProps[s] = !0;
}

function Ot(t) {
    const n = [ t ];
    for (;n.length; ) {
        const t = n.shift();
        if (Oi(t)) {
            if (typeof t.type === "string") {
                return t;
            }
            n.push(t.children);
        } else if (Me(t)) {
            n.push(...t);
        } else {
            if (As(t)) {
                return Is(t, t => Ot(t));
            }
            if (hu(t)) {
                return Ot(t.untrackedValue);
            }
        }
    }
    return null;
}

function jt(t, n) {
    if (Oi(t)) {
        if (t.type !== no && !Kf(t.type)) {
            return Bi(no, null, null, [ t, n ], 0, null);
        }
        t.children == null ? t.children = n : Me(t.children) ? t.children.push(n) : t.children = [ t.children, n ];
        return t;
    }
    if ((t => typeof t !== "object" && typeof t !== "function" || t === null || t === void 0)(t)) {
        return Bi(no, null, null, [ t, n ], 0, null);
    }
    if (Me(t) && t.length > 0) {
        jt(t[0], n);
        return t;
    }
    return t;
}

function Lt() {
    return new Ni("script", null, {
        hidden: ""
    }, null, 0, null);
}

function Ft(t, n, e, s) {
    const o = s(t, n);
    o.key = e;
    return o;
}

function Xt(t, n, e, s, o, r) {
    const i = Array(r - o + 1);
    for (let c = o; c <= r; c++) {
        const r = n[c] ?? (n[c] = e(t[c], c));
        i[c - o] = Ft(t[c], c, r, s);
    }
    return i;
}

function Dt(t, n, e) {
    let s = n ? n.previousSibling : t.lastChild;
    for (let t = 1; t < e && s; t++) {
        s = s.previousSibling;
    }
    return s;
}

function Vt(t, n, e, s, o, r, i) {
    const c = t;
    const l = o.length;
    const u = Il(e);
    const f = L(c, n, s, null);
    const a = Array(l);
    if (u === null) {
        if (l > 0) {
            return Io(c, n, Xt(o, a, r, i, 0, l - 1), e, null, null, s, null, !0, f);
        }
        return;
    }
    if (l === 0) {
        ql(n, e, u, !0);
        return;
    }
    let h = 0;
    let d = l - 1;
    let p = u;
    for (;p && h <= d && p.key === (a[h] ??= r(o[h], h)); ) {
        p = p.nextSibling;
        h++;
    }
    if (p === null) {
        if (h > d) {
            return;
        }
        return Io(c, n, Xt(o, a, r, i, h, d), e, null, null, s, null, !0, f);
    }
    if (h > d) {
        ql(n, e, p, !0);
        return;
    }
    const $ = p.previousSibling;
    let y = e.lastChild;
    for (;y !== $ && d >= h && y.key === (a[d] ??= r(o[d], d)); ) {
        y = y.previousSibling;
        d--;
    }
    const m = y ? y.nextSibling : p;
    if (h > d) {
        let t = p;
        for (;t && t !== m; ) {
            const s = t.nextSibling;
            Tl(n, e, t, !0);
            t = s;
        }
        return;
    }
    if (y === $) {
        const t = m;
        return Io(c, n, Xt(o, a, r, i, h, d), e, t, t, s, null, !0, f);
    }
    for (let t = h; t <= d; t++) {
        a[t] ??= r(o[t], t);
    }
    const w = d - h + 1;
    const b = new Map;
    for (let t = h; t <= d; t++) {
        b.set(a[t], t - h);
    }
    const _ = function v(t, n = null) {
        const e = [];
        let s = t;
        for (;s; ) {
            e.push(s);
            if (s === n) {
                break;
            }
            s = s.nextSibling;
        }
        return e;
    }(p, y);
    const g = [];
    const E = new Map;
    for (let t = 0; t < _.length; t++) {
        const s = _[t];
        const o = s.key;
        if (b.has(o)) {
            E.set(o, g.length);
            g.push(s);
        } else {
            Tl(n, e, s, !0);
        }
    }
    const S = new Int32Array(w);
    S.fill(-1);
    const k = [];
    const R = [];
    for (let t = 0; t < w; t++) {
        const n = E.get(a[h + t]);
        if (n !== void 0) {
            S[t] = n;
            R.push(t);
            k.push(n);
        }
    }
    const T = new Uint8Array(w);
    const P = function q(t) {
        const n = t.length;
        if (n === 0) {
            return [];
        }
        const e = [];
        const s = Array(n).fill(-1);
        for (let o = 0; o < n; o++) {
            const n = t[o];
            let r = 0;
            let i = e.length;
            for (;r < i; ) {
                const s = r + i >> 1;
                t[e[s]] < n ? r = s + 1 : i = s;
            }
            r > 0 && (s[o] = e[r - 1]);
            r === e.length ? e.push(o) : e[r] = o;
        }
        const o = [];
        let r = e[e.length - 1];
        for (;r !== -1; ) {
            o.push(r);
            r = s[r];
        }
        o.reverse();
        return o;
    }(k);
    for (let t = 0; t < P.length; t++) {
        T[R[P[t]]] = 1;
    }
    let M = d;
    let I = m;
    const A = () => {
        for (;M >= h; ) {
            const t = M - h;
            if (T[t] === 1) {
                I = g[S[t]];
                M--;
                continue;
            }
            const r = S[t];
            if (r !== -1) {
                const t = g[r];
                const s = I === null ? e.lastChild === t : t.nextSibling === I;
                s || kl(n, e, t, I);
                I = t;
                M--;
                continue;
            }
            let l = M;
            for (;l > h; ) {
                const t = l - 1 - h;
                if (T[t] === 1 || S[t] !== -1) {
                    break;
                }
                l--;
            }
            const u = M - l + 1;
            const d = Io(c, n, Xt(o, a, null, i, l, M), e, I, I, s, null, !0, f);
            return Is(d, () => {
                const t = Dt(e, I, u);
                I = t;
                M = l - 1;
                return A();
            });
        }
    };
    return A();
}

function Wt(t, n, e) {
    t.dirty &= -2;
    const s = n.getHostProp(t, ws);
    if (!s || s.length === 0) {
        return;
    }
    let o;
    for (let r = 0; r < s.length; r++) {
        const i = s[r];
        if (i instanceof cu) {
            const s = i;
            if (!(s.h & 4)) {
                continue;
            }
            if (s.h & 1) {
                (e.afterFlushTasks ||= []).push(s);
            } else {
                const r = !!(s.h & 8);
                const i = uu(s, n, t);
                As(i) && (r ? o = o ? o.then(() => i) : i : (e.extraPromises ||= []).push(i));
            }
        }
    }
    return o;
}

function Ut(t, n) {
    const e = t.props ||= {};
    e[Xr] = n;
}

function zt(t, n) {
    t.dirty &= -513;
    const e = function s(t) {
        const n = t.props;
        return n?.[Dr] ?? null;
    }(t);
    if (!e) {
        return;
    }
    (function o(t, n) {
        const e = t.props ||= {};
        e[Dr] = n;
    })(t, null);
    const r = t;
    const i = r.parent;
    const c = r.nextSibling;
    const l = ml(n, document, r, e);
    const u = Ko(r) && i || r;
    const f = u === r ? null : c;
    bl(n, u, l, f);
    t.dirty &= -65;
    t.dirtyChildren = null;
}

function Bt(t, n, e, s) {
    t.dirty &= -3;
    const o = t;
    let r = function i(t) {
        const n = t.props;
        return n?.[Xr];
    }(t);
    if (!r) {
        return;
    }
    Ut(t, null);
    hu(r) && (r = r.value);
    return xo(n, e, r, o, s, null);
}

function Ht(t, n, e, s) {
    const o = t;
    const r = n.getHostProp(o, Ve);
    if (r && !r.resolved) {
        return r.resolve();
    }
    t.dirty &= -5;
    if (!r) {
        return;
    }
    const i = n.getHostProp(o, ms) || null;
    return Qt(n, o, o, r, i, e, s);
}

function Jt(t, n, e, s) {
    t.dirty &= -9;
    const o = t;
    const r = function i(t) {
        const n = t.props;
        const e = n?.[Wr] || null;
        e && delete n[Wr];
        return e;
    }(t);
    if (!r) {
        return;
    }
    return Qt(n, o, r.subscriptionHost || n.rootVNode, r.componentFn, r.props, e, s);
}

function Qt(t, e, s, o, r, i, c) {
    const l = xs(() => Co(t, e, s, o, r), s => {
        const o = t.getHostProp(e, Ge);
        return n(() => xo(t, i, s, e, c, js(o)));
    }, n => {
        t.handleError(n, e);
    });
    if (As(l)) {
        return l;
    }
    return;
}

function Yt(t, n, e, s, o, r = null) {
    n.push(So(t.node, e, s, r, (t.flags & 512) !== 0));
    o || (t.props && s == null ? delete t.props[e] : (t.props ||= {})[e] = s);
}

function Gt(t, n) {
    t.dirty &= -17;
    if (!(t.flags & 1)) {
        return;
    }
    const e = function s(t) {
        const n = t.props ||= {};
        return n[Fr] ?? null;
    }(t);
    if (!e || e.size === 0) {
        return;
    }
    const o = t;
    for (const [t, s] of e.entries()) {
        let e = s.value;
        hu(e) && (e = e.value);
        const r = s.isConst;
        Yt(o, n, t, e, r, s.scopedStyleIdPrefix);
    }
    (function r(t) {
        const n = t.props ||= {};
        delete n[Fr];
    })(t);
}

function Kt(t, n) {
    t.dirty &= -129;
    const e = n.getHostProp(t, ws);
    if (!e || e.length === 0) {
        return;
    }
    for (let t = 0; t < e.length; t++) {
        const n = e[t];
        if (n instanceof cu && n.h & 16) {
            n.h &= -17;
            const t = n;
            Mo(t);
        }
    }
}

function Zt(t, e) {
    t.dirty &= -33;
    const s = e.getHostProp(t, Vr);
    if (!s) {
        return;
    }
    const o = s.ct;
    const r = ye();
    r.$ = e;
    return Is(n(() => de.call(s, r, s.p)), () => {
        if (s.h & 2) {
            s.h &= -3;
            return mu(e, s, o);
        }
    });
}

function tn(t, n, e, s) {
    t.dirty &= -257;
    const o = t;
    const r = n.getHostProp(o, ms) || null;
    if (!r) {
        return;
    }
    let i = di(r, "items");
    hu(i) && (i = $f(i));
    const c = di(r, "key$");
    const l = di(r, "item$");
    const u = c.resolved;
    const f = l.resolved;
    if (u !== void 0 && f !== void 0) {
        return Vt(n, e, o, s, i, u, f);
    }
    return Is(c.resolve(), t => Is(l.resolve(), r => Vt(n, e, o, s, i, t, r)));
}

let Oo = null;

const jo = (t, n, e) => {
    Oo || (Oo = t.insertBefore);
    Oo.call(t, n, e);
};

function nn(t) {
    let n = null;
    let e = null;
    let o = null;
    const r = new Set;
    const i = () => {
        if (o) {
            if (o.length === 1) {
                jo(n, o[0], e);
            } else {
                const t = n.ownerDocument || n;
                const s = t.createDocumentFragment();
                for (let t = 0; t < o.length; t++) {
                    s.appendChild(o[t]);
                }
                jo(n, s, e);
            }
            o = null;
            n = null;
            e = null;
            r.clear();
        }
    };
    for (let c = 0; c < t.length; c++) {
        const l = t[c];
        if (l instanceof wo) {
            if (n === l.parent && e === l.beforeTarget) {
                o || (o = []);
                o.push(l.target);
                r.add(l.target);
                continue;
            }
            if (!o) {
                n = l.parent;
                e = l.beforeTarget;
                o = [ l.target ];
                r.add(l.target);
                continue;
            }
            if (n === l.parent) {
                i();
                n = l.parent;
                e = l.beforeTarget;
                o = [ l.target ];
                r.add(l.target);
                continue;
            }
            if (r.has(l.target) || e && l.target === e || n && l.target === n) {
                i();
                n = l.parent;
                e = l.beforeTarget;
                o = [ l.target ];
                r.add(l.target);
                continue;
            }
            jo(l.parent, l.target, l.beforeTarget);
            continue;
        }
        if (l instanceof $o) {
            (r.has(l.target) || e && l.target === e || n && l.target === n) && i();
            l.target.remove();
            continue;
        }
        if (l instanceof yo) {
            (r.has(l.target) || e && l.target === e || n && l.target === n) && i();
            const t = l.target;
            t.textContent = "";
            continue;
        }
        if (l instanceof mo) {
            l.target.nodeValue = l.text;
        } else if (l instanceof bo) {
            const t = l.target;
            const e = l.attrName;
            const o = l.attrValue;
            const r = o != null ? s(e, o, l.scopedStyleIdPrefix) : null;
            const c = r == null || r === !1;
            if (Lo(t, e)) {
                t[e] = Fo(r);
            } else if (e === Ts) {
                n === t && i();
                t.innerHTML = r;
                t.setAttribute(os, "html");
            } else {
                c ? t.removeAttribute(e) : e === "value" && e in t ? t.value = r : E(t, e, r, l.isSvg);
            }
        }
    }
    i();
}

const Lo = (t, n) => {
    const e = n == "allowfullscreen" || n == "async" || n == "autofocus" || n == "autoplay" || n == "checked" || n == "controls" || n == "default" || n == "defer" || n == "disabled" || n == "formnovalidate" || n == "inert" || n == "ismap" || n == "itemscope" || n == "loop" || n == "multiple" || n == "muted" || n == "nomodule" || n == "novalidate" || n == "open" || n == "playsinline" || n == "readonly" || n == "required" || n == "reversed" || n == "selected";
    return e && n in t;
};

const Fo = t => {
    if (t === "false") {
        return !1;
    }
    return !!t;
};

const Xo = (t => () => queueMicrotask(t))(rn);

const Vo = Js(rn);

let Wo = !1;

function en() {
    if (!Wo) {
        Wo = !0;
        Xo();
    }
}

function sn() {
    if (!Wo) {
        Wo = !0;
        Vo();
    }
}

function rn() {
    Wo = !1;
    const t = performance.now();
    const n = t + 15;
    let e = null;
    for (;e = u(); ) {
        if (on(e, n)) {
            sn();
            return;
        }
    }
}

function on(t, n) {
    const e = be;
    const s = y(t);
    const o = s.promise;
    if (o) {
        return;
    }
    const r = s.container;
    if (!t.dirty) {
        ln(r, t, s, e);
        return;
    }
    const i = s.journal ||= [];
    let l = null;
    for (;l = s.position; ) {
        if (s.promise) {
            return;
        }
        if (!(l.dirty & 1023)) {
            __EXPERIMENTAL__.suspense && T(l);
            p(r, s, fn(l, t, r));
            continue;
        }
        if (l.flags & 32) {
            if (l.dirty & 128) {
                Kt(l, r);
            } else if (l.dirty & 64) {
                const n = cn(r, s, l, t);
                if (n !== null) {
                    l = n;
                    continue;
                }
            }
            l.dirty &= -1024;
            p(r, s, fn(l, t, r));
            continue;
        }
        let e;
        try {
            if (l.dirty & 1) {
                e = Wt(l, r, s);
            } else if (l.dirty & 2) {
                e = Bt(l, r, i, t);
            } else if (l.dirty & 4) {
                e = Ht(l, r, i, t);
            } else if (l.dirty & 8) {
                e = Jt(l, r, i, t);
            } else if (l.dirty & 256) {
                e = tn(l, r, i, t);
            } else if (l.dirty & 16) {
                Gt(l, i);
            } else if (l.dirty & 32) {
                e = Zt(l, r);
            } else if (l.dirty & 64) {
                const n = cn(r, s, l, t);
                if (n !== null) {
                    l = n;
                    continue;
                }
            } else {
                l.dirty & 512 && zt(l, i);
            }
        } catch (t) {
            r.handleError(t, l);
        }
        if (e && As(e)) {
            R(s, l);
            const n = e;
            s.promise = n;
            c(t, r);
            const o = l;
            n.catch(t => {
                s.promise === n && r.handleError(t, o);
            }).finally(() => {
                if (s.promise !== n) {
                    return;
                }
                s.promise = null;
                f(t, r);
                en();
            });
            return;
        }
        if (performance.now() >= n) {
            return !0;
        }
    }
    ln(r, t, s, e);
}

function ln(t, n, e, s) {
    if (!(n.dirty & 1023)) {
        h(n, t);
        s || function o(t, n) {
            const e = y(t);
            const s = e.journal;
            if (s && s.length > 0) {
                nn(s);
                e.journal = null;
            }
            (function o(t, n) {
                const e = n.afterFlushTasks;
                if (!e || e.length === 0) {
                    n.afterFlushTasks = null;
                    return;
                }
                for (let n = 0; n < e.length; n++) {
                    const s = e[n];
                    uu(s, t, s.ft);
                }
                n.afterFlushTasks = null;
            })(n, e);
        }(n, t);
        (function r(t) {
            if (!__EXPERIMENTAL__.suspense) {
                return;
            }
            const n = t.boundaries;
            if (!n) {
                return;
            }
            t.boundaries = null;
            for (let t = 0; t < n.length; t++) {
                const e = n[t];
                e.pending.value = Math.max(0, e.pending.value - 1);
                e.version.value++;
            }
        })(e);
        if (e.extraPromises) {
            Promise.all(e.extraPromises).then(() => {
                un(t);
            });
            return;
        }
        un(t);
    }
}

function un(t) {
    t.ht();
}

function cn(t, n, e, s) {
    const o = e.dirtyChildren;
    if (!o || o.length === 0) {
        e.dirty &= -65;
        T(e);
        return null;
    }
    (function r(t, n) {
        let e = 0;
        for (let s = 0; s < t.length; s++) {
            const o = t[s];
            if (o.parent === n) {
                if (e !== s) {
                    const n = t[e];
                    t[e] = o;
                    t[s] = n;
                }
                e++;
            }
        }
    })(o, e);
    e.nextDirtyChildIndex = 0;
    const i = fn(o[0], s, t);
    p(t, n, i);
    return i;
}

function fn(t, n, e) {
    if (t === n) {
        if (n.dirty & 1023) {
            return n;
        }
        return null;
    }
    let s = null;
    t.slotParent && t.slotParent.dirty & 64 ? s = t.slotParent : t.parent && t.parent.dirty & 64 && (s = t.parent);
    if (!s) {
        if (n.dirty & 1023) {
            return n;
        }
        return null;
    }
    const o = s.dirtyChildren;
    let r = s.nextDirtyChildIndex;
    const i = o.length;
    let c = i;
    for (;c-- > 0; ) {
        const t = o[r];
        if (t.dirty & 1023) {
            if (e && an(e, t)) {
                r++;
                r === i && (r = 0);
                continue;
            }
            s.nextDirtyChildIndex = (r + 1) % i;
            return t;
        }
        r++;
        r === i && (r = 0);
    }
    s.dirty &= -65;
    s.dirtyChildren = null;
    s.nextDirtyChildIndex = 0;
    __EXPERIMENTAL__.suspense && T(s);
    return fn(s, n, e);
}

function an(t, n) {
    if (!__EXPERIMENTAL__.suspense) {
        return !1;
    }
    if (!n.props || !(us in n.props) || !t.getHostProp(n, us)) {
        return !1;
    }
    dn(n) || hn(t, n, 0);
    return !0;
}

function hn(t, n, e) {
    if (dn(n)) {
        en();
        return n;
    }
    const s = {
        afterFlushTasks: null,
        extraPromises: null,
        journal: null,
        container: t,
        position: n,
        priority: e,
        promise: null,
        boundaries: null
    };
    (function o(t, n) {
        Lr.set(t, n);
    })(n, s);
    const r = n;
    r.flags |= 256;
    l(t, r);
    en();
    return r;
}

function dn(t) {
    return (t.flags & 256) !== 0;
}

function pn(t, n) {
    if (!(n.flags & 1)) {
        n.dirty & 16 && function e(t, n) {
            n.dirty &= -17;
            const e = n.getProp(Fr);
            if (!e || e.size === 0) {
                return;
            }
            for (const [o, r] of e.entries()) {
                let e = r.value;
                hu(e) && (e = e.value);
                const i = s(o, e, r.scopedStyleIdPrefix);
                t.addBackpatchEntry(n.id, o, i);
            }
        }(t, n);
        n.dirty & 32 && Zt(n, t);
        n.dirty &= -1024;
        return;
    }
    let e = null;
    if (n.dirty & 1) {
        const s = function o(t, n) {
            n.dirty &= -2;
            const e = n.getProp(ws);
            if (!e || e.length === 0) {
                return null;
            }
            let s = null;
            for (let o = 0; o < e.length; o++) {
                const r = e[o];
                if (r instanceof cu) {
                    const e = r;
                    if (!(e.h & 4)) {
                        continue;
                    }
                    const o = uu(e, t, n);
                    s = s ? s.then(() => o) : o;
                }
            }
            return s;
        }(t, n);
        As(s) && (e = s);
    }
    if (n.dirty & 256) {
        const s = async function o(t, n) {
            n.dirty &= -257;
            const e = n;
            const s = t.getHostProp(e, ms) || null;
            if (!s) {
                return;
            }
            let o = di(s, "items");
            hu(o) && (o = $f(o));
            const r = await di(s, "key$").resolve();
            const i = await di(s, "item$").resolve();
            const c = [];
            for (let t = 0; t < o.length; t++) {
                const n = o[t];
                const e = i(n, t);
                const s = r(n, t);
                e.key = s;
                c.push(e);
            }
            await t.renderJSX(c, {
                currentStyleScoped: null,
                parentComponentFrame: t.getComponentFrame(0)
            });
        }(t, n);
        e = e ? e.then(() => s) : s;
    }
    n.dirty &= -1020;
    if (e) {
        return e;
    }
}

const Uo = [];

function $n(t) {
    for (let n = 0; n < Uo.length; n++) {
        const e = Uo[n];
        const s = Uo[n + 1] || t;
        s.dirty |= 64;
        s.dirtyChildren ||= [];
        s.dirtyChildren.includes(e) || s.dirtyChildren.push(e);
    }
}

function yn(t, n, e, s = null) {
    const o = n.dirty;
    n.dirty |= e;
    if (function r() {
        return be;
    }()) {
        const e = pn(t, n);
        As(e) && (t.l = t.l ? t.l.then(() => e) : e);
        return;
    }
    const i = e & 1023;
    if ((i ? o & 1023 : o) || n === s) {
        return;
    }
    const c = n.slotParent || n.parent;
    if (s && i && c && !c.dirty) {
        (function e(t, n, s) {
            Uo.push(n);
            let o = P(t, n);
            let r = n.slotParent || n.parent;
            for (;r; ) {
                const e = r.dirty & 1023;
                const i = dn(r);
                __EXPERIMENTAL__.suspense && (o ||= P(t, r) || (e ? q(t, r) : null));
                if (r === s || e) {
                    M(n, o);
                    $n(r);
                    if (i) {
                        const t = y(r);
                        t.position !== r && (t.position = n);
                    }
                    Uo.length = 0;
                    return;
                }
                if (i) {
                    const t = y(r);
                    t.position !== r && (t.position = n);
                }
                Uo.push(r);
                r = r.slotParent || r.parent;
            }
            Uo.length = 0;
            ((t, ...n) => {
                const e = Ee(!1, t, ...n);
                debugger;
                throw e;
            })("Cursor root not found in current path!");
        })(t, n, s);
        return;
    }
    if (c && c.dirty & 1023) {
        M(n, P(t, n) || q(t, c));
        i && (c.dirty |= 64);
        c.dirtyChildren ||= [];
        c.dirtyChildren.includes(n) || c.dirtyChildren.push(n);
        if (i && n.dirtyChildren) {
            const t = function e(t) {
                for (;t; ) {
                    if (dn(t)) {
                        return t;
                    }
                    t = t.parent || t.slotParent;
                }
                return null;
            }(n);
            if (t) {
                const e = y(t);
                let s = e.position;
                if (s) {
                    for (;s !== t; ) {
                        s = s.slotParent || s.parent;
                        if (s === n) {
                            e.position = n;
                            break;
                        }
                    }
                }
            }
        }
    } else {
        dn(n) ? M(n, P(t, n)) : function l(t, n) {
            Uo.push(n);
            let e = __EXPERIMENTAL__.suspense ? P(t, n) : null;
            let s = n.slotParent || n.parent;
            for (;s; ) {
                const o = dn(s);
                __EXPERIMENTAL__.suspense && (e ||= P(t, s) || (o ? q(t, s) : null));
                if (o) {
                    M(n, e);
                    $n(s);
                    Uo.length = 0;
                    return !0;
                }
                Uo.push(s);
                s = s.slotParent || s.parent;
            }
            M(n, e);
            Uo.length = 0;
            return !1;
        }(t, n) || hn(t, n, 0);
    }
}

function mn(t, n) {
    t.push(n);
}

const zo = (t, n) => {
    let e;
    for (;t && !(e = Object.getOwnPropertyDescriptor(t, n)?.get); ) {
        t = Object.getPrototypeOf(t);
    }
    return e || function() {
        return this[n];
    };
};

const Bo = t => {
    let n = null;
    return e => {
        n || (n = zo(e, t));
        return n.call(e);
    };
};

const Ho = (t, n, e = null) => {
    const s = new Nr(e, -4087, null, null, null, null, null, null, t, n);
    t.vNode = s;
    return s;
};

const Jo = t => {
    const n = new Nr(null, -4095, null, null, null, null, void 0, void 0, t, void 0);
    t.vNode = n;
    return n;
};

const Qo = (t, n) => {
    const e = new Cr(-4084, null, null, null, null, t, n);
    return e;
};

const Yo = () => {
    const t = new Ir(null, -4094, null, null, null, null, null, null);
    return t;
};

const Go = t => t instanceof xr;

const Ko = t => (t.flags & 1) === 1;

const Zo = t => {
    const n = t.flags;
    return (n & 5) !== 0;
};

const tl = t => {
    const n = t.flags;
    return (n & 1) === 1 && t.firstChild !== void 0 && t.lastChild !== void 0;
};

const nl = t => (t.flags & 4) === 4;

const el = t => (t.flags & 2) === 2;

const sl = t => {
    const n = t.flags;
    return (n & 2) === 2 && rl(t, ze, null) !== null;
};

const Vh = t => t;

const rl = (t, n, e) => {
    if (Ko(t) || el(t)) {
        const s = t.props?.[n] ?? null;
        if (typeof s === "string" && e) {
            const o = e(s);
            t.props[n] = o;
            return o;
        }
        return s;
    }
    return null;
};

const il = (t, n, e) => {
    if (e == null && t.props) {
        delete t.props[n];
    } else {
        t.props ||= {};
        t.props[n] = e;
    }
};

const ol = (t, n, e, s, o = null) => {
    if (Ko(n)) {
        il(n, e, s);
        mn(t, So(n.node, e, s, o, (n.flags & 512) !== 0));
    }
};

const ll = t => {
    if (t.key) {
        return;
    }
    const n = Ll(t.node, Ps);
    n && (t.key = n);
};

const ul = (t, n) => {
    if ((n.flags & 15) === 1) {
        const e = n;
        e.flags ^= 8;
        const s = e.node;
        const o = s.attributes;
        let r = !1;
        for (let n = 0; n < o.length; n++) {
            const i = o[n];
            const c = i.name;
            if (Ls(c)) {
                wn(i, c, t, s);
                continue;
            }
            if (r) {} else if (c !== Ps && c) {
                if (c.startsWith(os)) {
                    const t = i.value;
                    t === "html" ? il(e, "dangerouslySetInnerHTML", s.innerHTML) : t === "text" && "value" in s && il(e, "value", s.value);
                } else {
                    const t = i.value;
                    il(e, c, t);
                }
            } else {
                const t = i.value;
                t && (e.key = t);
                r = !0;
            }
        }
        rl(e, vs, null) === null && rl(e, _s, null) === null || (n.flags |= 64);
    }
};

const cl = t => {
    if (t.vt === "_run") {
        const n = t.getCaptured()?.[0];
        if (Ce(n)) {
            return n;
        }
    }
    return t;
};

function wn(t, n, e, s) {
    const o = t.value;
    const r = n.slice(2);
    const i = o.split("|");
    const c = [];
    for (let t = 0; t < i.length; t++) {
        const n = cl(Ln(i[t], e));
        c.push(x.bind(null, n));
    }
    (s._qDispatch ||= {})[r] = c.length === 1 ? c[0] : c;
}

function bn(t, n, e) {
    let s = Il(n);
    for (;s; ) {
        if (nl(s)) {
            al(t, s);
            e(s, n);
        } else {
            Ko(s) ? e(s, n) : bn(t, s, e);
        }
        s = s.nextSibling;
    }
}

function vn(t) {
    let n = t;
    if (nl(t)) {
        return;
    }
    let e = null;
    for (;;) {
        const s = Il(n);
        if (s) {
            n = s;
            continue;
        }
        if (n === t) {
            return;
        }
        const o = n.nextSibling;
        if (o) {
            n = o;
            continue;
        }
        e = n.parent;
        for (;e; ) {
            if (e === t) {
                return;
            }
            const s = e.nextSibling;
            if (s) {
                n = s;
                break;
            }
            e = e.parent;
        }
        if (e == null) {
            return;
        }
    }
}

const fl = (t, n, e) => {
    let s = t;
    for (;e && s && el(s); ) {
        const t = n ? s.firstChild : s.lastChild;
        if (!t) {
            break;
        }
        if (t.flags & 5) {
            return t;
        }
        s = t;
    }
    for (;s; ) {
        let t = n ? s.nextSibling : s.previousSibling;
        if (t && t.flags & 5) {
            return t;
        }
        if (!t) {
            let e = s.parent;
            if (e && !el(e)) {
                return null;
            }
            for (;e && !(t = n ? e.nextSibling : e.previousSibling); ) {
                e = e.parent;
                if (e && !el(e)) {
                    return null;
                }
            }
            if (!t) {
                return null;
            }
            if (nl(t) && e && Ko(e)) {
                return null;
            }
        }
        for (;t; ) {
            s = t;
            if (s.flags & 5 && tu(s)) {
                return s;
            }
            t = n ? s.firstChild : s.lastChild;
        }
    }
    return null;
};

const al = (t, n) => {
    const e = (t => t)(n);
    const s = e.flags;
    if ((s & 8) === 0) {
        const s = Rl(n, !0);
        const o = e.node;
        const r = Jl(s);
        let i = fl(n, !1, !0);
        const c = fl(n, !0, !0);
        const l = o || (c && Ko(c) ? c.node : c?.node) || null;
        let u = l;
        for (;i && nl(i); ) {
            if ((i.flags & 8) === 0) {
                const n = r.createTextNode(i.text);
                mn(t, Eo(n, s, u));
                u = n;
                i.node = n;
                i.flags |= 8;
            }
            i = fl(i, !1, !0);
        }
        i = n;
        for (;i && nl(i); ) {
            const n = fl(i, !0, !0);
            const e = !n || !nl(n);
            if ((i.flags & 8) === 0) {
                if (e && o) {
                    mn(t, go(o, i.text));
                } else {
                    const n = r.createTextNode(i.text);
                    mn(t, Eo(n, s, l));
                    i.node = n;
                }
                i.flags |= 8;
            }
            i = n;
        }
    }
};

const hl = (t, n) => {
    let e = t;
    const s = t.node;
    const o = s.qVNodeRefs;
    let r = -1;
    let i;
    const c = typeof n === "string" ? n : "";
    if (typeof n === "string") {
        r = parseInt(c);
        i = o.get(r);
    } else {
        i = n;
        const t = i;
        const s = t.vNode;
        if (s) {
            return s;
        }
        if (__EXPERIMENTAL__.suspense && t._qSegment) {
            e = Jo(i);
            ll(e);
            t.vNode = e;
            return e;
        }
    }
    if (Go(i)) {
        e = i;
    } else {
        if (__EXPERIMENTAL__.suspense && i._qSegment) {
            e = i.vNode || Jo(i);
            ll(e);
        } else {
            let t = i;
            const n = [ i ];
            for (;t && t !== s && !t.vNode; ) {
                t = t.parentElement;
                n.push(t);
            }
            t.vNode && (e = t.vNode);
            for (let t = n.length - 2; t >= 0; t--) {
                e = $l(e, n[t]);
            }
        }
        if (r != -1) {
            i.vNode = e;
            o.set(r, e);
        }
    }
    if (typeof n === "string") {
        const t = c.length;
        let n = yl(c, t);
        let s = 0;
        for (;n < t; ) {
            const t = c.charCodeAt(n);
            s *= 26;
            if (t >= 97) {
                s += t - 97;
            } else {
                s += t - 65;
                e = dl(e, s);
                s = 0;
            }
            n++;
        }
    }
    return e;
};

const dl = (t, n) => {
    let e = Il(t);
    for (;e.flags >>> 12 !== n; ) {
        e = e.nextSibling;
    }
    return e;
};

const pl = [];

const $l = (t, n) => {
    let e = Il(t);
    for (;e && (!(e instanceof Nr) || e.node !== n); ) {
        if (el(e)) {
            const t = e.nextSibling;
            const n = Il(e);
            if (n) {
                t && pl.push(t);
                e = n;
            } else {
                e = t || (pl.length ? pl.pop() : null);
            }
        } else {
            const t = e.nextSibling;
            e = t || t || pl.pop();
        }
    }
    for (;pl.length; ) {
        pl.pop();
    }
    return e;
};

const yl = (t, n) => {
    let e = t.charCodeAt(0) === 45 ? 1 : 0;
    for (;e < n; ) {
        const n = t.charCodeAt(e);
        if (!(n >= 48 && n <= 57)) {
            return e;
        }
        e++;
    }
    return n;
};

const ml = (t, n, e, s) => {
    const o = n.createElement("errored-host");
    s && s instanceof Error && (o.props = {
        error: s
    });
    o.setAttribute("q:key", "_error_");
    const r = Ho(o, "errored-host");
    if (Zo(e)) {
        kl(t, r, e, null);
    } else {
        const n = [];
        bn(t, e, t => {
            n.push(t);
        });
        for (let e = 0; e < n.length; e++) {
            kl(t, r, n[e], null);
        }
    }
    return r;
};

const wl = nn;

const bl = (t, n, e, s) => {
    const o = Ko(n);
    o && Nl(n);
    const r = e.parent;
    if (e === s) {
        if (r) {
            return;
        }
        s = null;
    }
    El(t, r, n, e);
    const i = e.node;
    const c = n.flags & 32;
    const l = o ? n.node : Rl(n, !1);
    l && !c && mn(t, Eo(i, l, _l(t, n, s)?.node ?? null));
    gl(n, e, s);
    c && (e.flags |= 32);
};

const vl = (t, n, e, s) => {
    const r = Ko(n);
    r && Nl(n);
    const c = e.parent;
    if (e === s) {
        if (c) {
            return;
        }
        s = null;
    }
    El(t, c, n, e);
    const l = n.flags & 32;
    const u = !r && n.flags & 2048 ? n.props?.[We] : null;
    const f = u ? null : r ? n : Pl(n, !1);
    const a = u || f?.node;
    const h = _l(t, n, s);
    const d = h?.node ?? null;
    const p = sl(e);
    if (p && f && (f.flags & 1536) !== 0) {
        const r = Pl(n, !1);
        const c = _l(t, n, s)?.node ?? null;
        const {elementNamespace: l, elementNamespaceFlag: u} = o(r, e);
        bn(t, e, n => {
            if (nl(n)) {
                mn(t, Eo(n.node, a, c));
            } else {
                if ((n.flags & 1536) !== u) {
                    const t = function e(t, n, s, r) {
                        let c = t;
                        let l = null;
                        let u = null;
                        let f = null;
                        for (;c; ) {
                            let e = null;
                            let a = null;
                            if (Ko(c)) {
                                e = c.node;
                                const t = Ml(c);
                                const l = c.parent;
                                const h = u == null ? n : l && Pl(l, !0);
                                if (h) {
                                    const t = o(h, Ml(c));
                                    s = t.elementNamespace;
                                    r = t.elementNamespaceFlag;
                                }
                                const d = Il(c);
                                a = i(e, t, s, !d);
                                e.remove();
                                u == null && (u = a);
                                f && f.appendChild(a);
                                c.node = a;
                                c.flags &= -1537;
                                c.flags |= r;
                                if (d) {
                                    c = d;
                                    f = a;
                                    continue;
                                }
                                if (Ol(e)) {
                                    const t = ue(e);
                                    if (t) {
                                        const n = Il(t.rootVNode);
                                        if (n) {
                                            c = n;
                                            f = a;
                                            continue;
                                        }
                                    }
                                }
                            }
                            if (c === t) {
                                return u;
                            }
                            const h = c.nextSibling;
                            if (h) {
                                c = h;
                                continue;
                            }
                            l = c.parent;
                            for (;l; ) {
                                if (l === t) {
                                    return u;
                                }
                                const n = l.nextSibling;
                                if (n) {
                                    c = n;
                                    return u;
                                }
                                l = l.parent;
                            }
                            if (l == null) {
                                return u;
                            }
                        }
                        return u;
                    }(n, r, l, u);
                    t && (n.node = t);
                }
                mn(t, Eo(n.node, a, c));
            }
        });
    } else {
        a && !l && bn(t, e, n => {
            mn(t, Eo(n.node, a, d));
        });
    }
    gl(n, e, s);
    l && (e.flags |= 32);
};

const _l = (t, n, e) => {
    let s = null;
    e == null ? el(n) && (s = fl(n, !0, !1)) : s = el(e) ? fl(e, !0, !0) : e;
    s && nl(s) && al(t, s);
    return s;
};

const gl = (t, n, e) => {
    const s = e ? e.previousSibling : t.lastChild;
    e ? e.previousSibling = n : t.lastChild = n;
    s ? s.nextSibling = n : t.firstChild = n;
    n.previousSibling = s;
    n.nextSibling = e;
    n.parent = t;
};

const El = (t, n, e, s) => {
    n && (s.previousSibling || s.nextSibling || n !== e) && Tl(t, n, s, !1);
};

const Sl = (t, n) => {
    let e = n;
    for (;e && el(e); ) {
        e = e.lastChild;
    }
    e && nl(e) && (e.flags & 8) === 0 && al(t, e);
};

const kl = (t, n, e, s) => {
    Zo(e) ? bl(t, n, e, s) : vl(t, n, e, s);
};

const Rl = (t, n) => {
    for (;t && !Ko(t); ) {
        if (t.flags & 2048) {
            return t.props?.[We];
        }
        t = t.parent || (n ? t.slotParent : null);
    }
    return t ? t.node : null;
};

const Pl = (t, n) => {
    for (;t && !Ko(t); ) {
        t = t.parent || (n ? t.slotParent : null);
    }
    return t;
};

const Tl = (t, n, e, s) => {
    nl(e) && al(t, e);
    if (s) {
        const s = rl(n, Ts, null) !== null;
        if (s) {
            return;
        }
        Zo(e) ? mn(t, vo(e.node)) : bn(t, e, n => {
            mn(t, vo(n.node));
        });
    }
    const o = e.previousSibling;
    const r = e.nextSibling;
    o ? o.nextSibling = r : n.firstChild = r;
    r ? r.previousSibling = o : n.lastChild = o;
    e.previousSibling = null;
    e.nextSibling = null;
};

const ql = (t, n, e, s = !0) => {
    const o = Rl(n, !0);
    if (o && s) {
        if (Zo(n)) {
            mn(t, _o(n.node));
        } else {
            const e = Pl(n, !1);
            e && e.firstChild === n && e.lastChild === n ? mn(t, _o(o)) : bn(t, n, n => {
                mn(t, vo(n.node));
            });
        }
    }
    const r = e.previousSibling;
    r ? r.nextSibling = null : n.firstChild = null;
    n.lastChild = r;
};

const Ml = t => {
    const n = Vh(t);
    let e = n.elementName;
    if (e === void 0) {
        const t = n.node;
        const s = Hl(t).toLowerCase();
        e = n.elementName = s;
        n.flags |= (t => {
            const n = Bl(t);
            switch (n) {
              case hs:
                return 512;

              case ds:
                return 1024;

              default:
                return 0;
            }
        })(t);
    }
    return e;
};

const Al = t => {
    let n = t.text;
    n === void 0 && (n = t.text = t.node.nodeValue);
    return n;
};

const xl = (t, n, e) => {
    al(t, n);
    n.text = e;
    mn(t, go(n.node, e));
};

const Il = t => {
    if (nl(t)) {
        return null;
    }
    let n = t.firstChild;
    if (__EXPERIMENTAL__.suspense && n === void 0 && Ko(t) && function e(t) {
        const n = t.getAttribute(Lh);
        if (n === null) {
            return !1;
        }
        const e = zl(t);
        return iu(e) && e.localName === "template" && e.getAttribute(jh) === n && Vl(e) === null;
    }(t.node)) {
        return null;
    }
    n === void 0 && (n = Nl(t));
    return n;
};

const Nl = n => {
    const e = Vh(n);
    let s = e.firstChild;
    if (s === void 0) {
        const n = e.node;
        s = e.parent && Ol(n) ? e.firstChild = e.lastChild = null : (n => {
            const e = n.node;
            const s = zl(e);
            const o = Jl(e)?.qVNodeData?.get(e);
            const r = ((n, e, s, o) => {
                ll(n);
                __EXPERIMENTAL__.suspense && e._qSegment;
                if (o) {
                    if (o.charCodeAt(0) === Xe && o.charCodeAt(1) === Xe) {
                        const t = (t => {
                            const n = t.indexOf("||", 2);
                            const e = t.substring(2, n);
                            const s = t.substring(n + 2);
                            return {
                                elementVNodeData: e,
                                virtualVNodeData: s
                            };
                        })(o);
                        const e = t.elementVNodeData;
                        o = t.virtualVNodeData;
                        const r = Ql(n, s, e);
                        if (!o) {
                            return r;
                        }
                    }
                    return function r(n, e, s, o) {
                        let r = 0;
                        let i = null;
                        let c = null;
                        let l = null;
                        const u = t => {
                            t.flags = t.flags & 4095 | r << 12;
                            r++;
                            c && (c.nextSibling = t);
                            t.previousSibling = c;
                            t.parent = n;
                            i || (n.firstChild = i = t);
                            c = t;
                        };
                        let f = 0;
                        let a = null;
                        let h = null;
                        const d = t => {
                            const n = iu(t);
                            return !n || n && Sn(t);
                        };
                        let p = null;
                        Yl(e, ($, y, m, w, b) => {
                            if (nu($())) {
                                for (;d(o); ) {
                                    o = Vl(o);
                                    if (!o) {
                                        throw Ie(27, [ e, $(), b ]);
                                    }
                                }
                                a = null;
                                l = null;
                                let t = 0;
                                for (;nu($()); ) {
                                    t *= 10;
                                    t += m() - 48;
                                }
                                for (;t--; ) {
                                    const n = Jo(o);
                                    ll(n);
                                    u(n);
                                    o = Vl(o);
                                    for (;iu(o) && Sn(o); ) {
                                        o = Vl(o);
                                        if (!o && t > 0) {
                                            throw Ie(27, [ e, $(), b ]);
                                        }
                                    }
                                }
                            } else if ($() === 59) {
                                il(n, Ge, y());
                            } else if ($() === 60) {
                                (p ||= []).push(n);
                                il(n, Ve, y());
                            } else if ($() === 61) {
                                h || (h = le(s));
                                const t = y();
                                h.xn(parseInt(t, 10), n);
                            } else if ($() === 62) {
                                il(n, ms, y());
                            } else if ($() === 64) {
                                const e = w(b + 1) === Xe;
                                let s;
                                if (e) {
                                    m();
                                    s = decodeURIComponent(t(y()));
                                    m();
                                } else {
                                    s = y();
                                }
                                n.key = s;
                            } else if ($() === 91) {
                                il(n, ws, y());
                            } else if ($() === 94) {
                                il(n, bs, y());
                            } else if ($() === 96) {
                                h || (h = le(s));
                                gn(n, y(), h);
                            } else if ($() === 63) {
                                h || (h = le(s));
                                n.slotParent = hl(h.rootVNode, y());
                            } else if ($() === 93) {
                                il(n, Ke, y());
                            } else if ($() === 123) {
                                m();
                                u(Yo());
                                su.push(n, i, c, l, r);
                                r = 0;
                                n = c;
                                i = c = null;
                            } else if ($() === Xe) {
                                const e = y();
                                const s = t(e);
                                const o = b + e.length + 1;
                                const r = w(o + 1) === Xe;
                                let i;
                                if (r) {
                                    m();
                                    i = decodeURI(t(y()));
                                    m();
                                } else {
                                    i = t(y());
                                }
                                il(n, s, i);
                            } else if ($() === 125) {
                                m();
                                n.lastChild = c;
                                r = su.pop();
                                l = su.pop();
                                c = su.pop();
                                i = su.pop();
                                n = su.pop();
                            } else if ($() === 126) {
                                const e = t(y());
                                il(n, ze, e);
                            } else {
                                for (;iu(o) && Sn(o); ) {
                                    o = Vl(o);
                                }
                                const t = o && Fl(o) === 3 ? o : null;
                                if (a === null) {
                                    a = t ? t.nodeValue : null;
                                    f = 0;
                                }
                                let n = 0;
                                for (;eu($()); ) {
                                    n += m() - 97;
                                    n *= 26;
                                }
                                n += m() - 65;
                                const e = a === null ? "" : a.substring(f, f + n);
                                u(l = ((t, n, e) => {
                                    const s = new Cr(-4092, null, t, null, null, n, e);
                                    return s;
                                })(l, t, e));
                                f += n;
                            }
                        });
                        if (p) {
                            h || (h = le(s));
                            for (let t = 0; t < p.length; t++) {
                                h.ensureProjectionResolved(p[t]);
                            }
                            p = null;
                        }
                        n.lastChild = c;
                        return i;
                    }(n, o, e, s);
                }
                return Ql(n, s, void 0);
            })(n, e, s, o);
            return r;
        })(e);
    }
    return s;
};

let Cl = null;

const Ol = t => {
    Cl || (Cl = t.hasAttribute);
    return Cl.call(t, os);
};

let jl = null;

const Ll = (t, n) => {
    jl || (jl = t.getAttribute);
    return jl.call(t, n);
};

const Fl = Bo("nodeType");

const Xl = t => {
    const n = Fl(t);
    return n === 3 || n === 1;
};

let Dl = null;

const Vl = t => {
    Dl || (Dl = zo(t, "nextSibling"));
    Ul || (Ul = zo(t, "firstChild"));
    for (;t; ) {
        t = Dl.call(t);
        if (t !== null) {
            const n = Fl(t);
            if (n === 3 || n === 1) {
                break;
            }
            if (n === 8) {
                const n = t.nodeValue;
                if (n?.startsWith(rs)) {
                    return _n(t, es, Dl, Ul);
                }
                if (t.nodeValue?.startsWith(ss)) {
                    return _n(t, [ es, is ], Dl, Ul);
                }
                if (n?.startsWith(os)) {
                    for (;t && (t = Dl.call(t)) && (Fl(t) !== 8 || !t.nodeValue?.startsWith(ls)); ) {}
                }
            }
        }
    }
    return t;
};

function _n(t, n, e, s) {
    const o = typeof n === "string";
    const r = n.length;
    for (;t; ) {
        const i = t.nodeValue;
        let c;
        if (o) {
            c = i?.startsWith(n);
        } else {
            for (let t = 0; t < r; t++) {
                if (i?.startsWith(n[t])) {
                    c = !0;
                    break;
                }
            }
        }
        if (c) {
            t = e.call(t) || null;
            return t;
        }
        let l = s.call(t);
        l || (l = e.call(t));
        for (;!l; ) {
            l = Wl(t);
            if (!l) {
                break;
            }
            t = l;
            l = e.call(l);
        }
        t = l;
    }
    return null;
}

const Wl = Bo("parentNode");

let Ul = null;

const zl = t => {
    Ul || (Ul = zo(t, "firstChild"));
    t = t && Ul.call(t);
    if (t && Fl(t) === 8) {
        Dl || (Dl = zo(t, "nextSibling"));
        if (t.nodeValue?.startsWith(rs)) {
            return _n(t, es, Dl, Ul);
        }
    }
    for (;t && !Xl(t); ) {
        t = Vl(t);
    }
    return t;
};

const Bl = Bo("namespaceURI");

const Hl = Bo("nodeName");

const Jl = Bo("ownerDocument");

const Ql = (t, n, e) => {
    let s = null;
    let o = 0;
    const r = () => {
        for (;iu(i) && Sn(i); ) {
            i = Vl(i);
        }
    };
    let i = n;
    r();
    let c = null;
    for (;i; ) {
        const n = Fl(i);
        let e = null;
        if (n === 3) {
            e = Qo(i, i.textContent ?? void 0);
        } else if (n === 1) {
            e = Jo(i);
            ll(e);
        }
        if (e) {
            e.flags = e.flags & 4095 | o << 12;
            o++;
            e.parent = t;
            c && (c.nextSibling = e);
            e.previousSibling = c;
            c = e;
        }
        s || (t.firstChild = s = c);
        i = Vl(i);
        r();
    }
    t.lastChild = c || null;
    t.firstChild = s;
    if (e) {
        let n = null;
        Yl(e, (e, s) => {
            if (e() === 61) {
                n || (n = le(t.node));
                const e = s();
                n.xn(parseInt(e, 10), t);
            } else if (e() === 96) {
                n || (n = le(t.node));
                gn(t, s(), n);
            } else {
                s();
            }
        });
    }
    return s;
};

function gn(t, n, e) {
    if (t[Rr]) {
        const s = t[Rr];
        ((t, n) => {
            for (const [e, s] of n) {
                t.set(e, s);
            }
        })(s, e._(n));
    } else {
        Object.defineProperty(t, Rr, {
            get() {
                const s = e._(n);
                t[Rr] = s;
                return s;
            },
            set(n) {
                Object.defineProperty(t, Rr, {
                    value: n,
                    writable: !0,
                    enumerable: !0,
                    configurable: !0
                });
            },
            enumerable: !0,
            configurable: !0
        });
    }
}

const Yl = (t, n) => {
    let e = 0;
    let s = 0;
    let o = 0;
    const r = n => n < t.length ? t.charCodeAt(n) : 0;
    const i = () => o !== 0 ? o : o = r(e);
    const c = () => {
        s = i();
        o = 0;
        e++;
        return s;
    };
    const l = () => {
        c();
        const n = e;
        for (;i() <= 58 && o !== 0 || o === 92 || o === 95 || o >= 65 && o <= 90 || o >= 97 && o <= 122; ) {
            c();
        }
        return t.substring(n, e);
    };
    for (;i() !== 0; ) {
        n(i, l, c, r, e);
    }
};

const Gl = (t, n) => {
    const e = n.flags;
    if ((e & 3) !== 0) {
        ul(t, n);
        const e = [];
        const s = n.props;
        if (s) {
            for (const t in s) {
                t.startsWith(Ps) || e.push(t);
            }
        }
        return e;
    }
    return [];
};

const Kl = (t, n) => {
    let e = Zl(t);
    for (;e; ) {
        if (e === n) {
            return !0;
        }
        e = Zl(e);
    }
    return !1;
};

const Zl = t => t.parent || t.slotParent;

const tu = t => {
    if (t === null || el(t)) {
        return null;
    }
    return t.node;
};

function En(t = 20, n = "", e = !1, s = !1, o = !0, r = null) {
    if (this && !r) {
        try {
            r = function t(n) {
                let e = n;
                for (;e; ) {
                    if (Ko(e)) {
                        const t = ce(e.node);
                        if (!t) {
                            return null;
                        }
                        return ue(t);
                    }
                    e = e.parent;
                }
                return null;
            }(this);
        } catch {}
    }
    let i = this;
    if (t === 0) {
        return "...";
    }
    if (i === null) {
        return "null";
    }
    if (i === void 0) {
        return "undefined";
    }
    const c = [];
    do {
        if (nl(i)) {
            c.push(An(Al(i)));
        } else if (el(i)) {
            const e = i.flags >>> 12;
            const s = [ "[" + e + "]" ];
            i.dirty && s.push(" dirty:" + i.dirty);
            if (r) {
                const t = Gl(r, i);
                for (let n = 0; n < t.length; n++) {
                    const e = t[n];
                    if (e !== Oe && e !== "__scopedStyleIdPrefix__") {
                        const t = rl(i, e, null);
                        s.push(" " + e + "=" + An(t));
                    }
                }
                i.slotParent && s.push(" slotParent=(C)");
            }
            const l = (o ? "[34m" : "") + (je[rl(i, Oe, null) || "V"] || je.V) + (o ? "[0m" : "");
            c.push("<" + l + s.join("") + ">");
            const u = Il(i);
            u && c.push("  " + En.call(u, t - 1, n + "  ", !0, !0, o));
            c.push("</" + l + ">");
        } else if (Ko(i)) {
            const s = Ml(i);
            const l = [];
            dn(i) && l.push(" cursor");
            i.dirty && l.push(" dirty:" + i.dirty);
            i.dirtyChildren && l.push(` dirtyChildren[${i.dirtyChildren.length}]`);
            const u = r ? Gl(r, i) : [];
            for (let t = 0; t < u.length; t++) {
                const n = u[t];
                const e = rl(i, n, null);
                l.push(" " + n + "=" + An(e));
            }
            const f = tu(i);
            if (f) {
                const t = Jl(f).qVNodeData?.get(f);
                t && l.push(" q:vnodeData=" + An(t));
            }
            const a = f.attributes;
            for (let t = 0; t < a.length; t++) {
                const n = a[t];
                u.indexOf(n.name) === -1 && l.push(" " + n.name + (n.value ? "=" + An(n.value) : ""));
            }
            c.push("<" + s + l.join("") + ">");
            if (tl(i) || e) {
                const e = Il(i);
                e && c.push("  " + En.call(e, t - 1, n + "  ", !0, !0, o));
            } else {
                c.push("  \x3c!-- not materialized --!>");
            }
            c.push("</" + s + ">");
        }
        i = s && i.nextSibling || null;
    } while (i);
    return c.join("\n" + n);
}

const nu = t => 48 <= t && t <= 57;

const eu = t => 97 <= t && t <= 122;

function Sn(t) {
    return !t.hasAttribute(Ps) || t.nodeName === "STYLE" && (t.hasAttribute(Ge) || t.hasAttribute(Je));
}

const su = [];

const ru = t => {
    const n = t.flags;
    if (n & 1) {
        return 1;
    }
    if (n & 2) {
        return 11;
    }
    if (n & 4) {
        return 3;
    }
    throw Ie(26, [ n ]);
};

const iu = t => t && typeof t == "object" && Fl(t) === 1;

const ou = t => {
    let n = 1;
    for (;n--; ) {
        for (;t && (!el(t) || rl(t, Ve, null) === null); ) {
            const e = t.slotParent;
            const s = el(t) && e;
            s && n++;
            t = s || t.parent;
        }
        n > 0 && (t = t.parent);
    }
    return t;
};

function kn(t, n) {
    Go(n) && Ko(n) && Nl(n);
    const e = n[Rr];
    if (!e) {
        return;
    }
    for (const [, n] of e) {
        Rn(t, n);
    }
    e.clear();
}

function Rn(t, n) {
    const e = n.backRef;
    if (!e) {
        return;
    }
    for (const s of e) {
        if (s instanceof Zr) {
            Tn(s, n);
        } else if (s instanceof Yr) {
            Pn(t, s, n);
        } else if (yi(s)) {
            const t = s[ri];
            qn(t, n);
        } else if (t.dt.has(s)) {
            const e = t.dt.get(s);
            const o = Eu(e);
            qn(o, n);
        }
    }
    e.clear();
}

function Pn(t, n, e) {
    const s = n.ct;
    s && s.has(e) && s.delete(e);
    if (n instanceof xi && !s?.size) {
        n.m = void 0;
        kn(t, n);
    }
}

function Tn(t, n) {
    const e = t.ct;
    e && e.has(n) && e.delete(n);
    const s = t.$t;
    s && s.has(n) && s.delete(n);
    const o = t.yt;
    o && o.has(n) && o.delete(n);
    t.wt();
}

function qn(t, n) {
    const e = t?.ct;
    if (e) {
        for (const [t, s] of e.entries()) {
            if (s.has(n)) {
                s.delete(n);
                s.size === 0 && e.delete(t);
            }
        }
    }
}

const lu = (t, n) => {
    const {val: e, set: s, iCtx: o, i: r} = ko();
    if (e) {
        return;
    }
    s(1);
    const i = n?.deferUpdates === !1 ? 0 : 8;
    const c = new cu(6 | i, r, o.m, t, void 0, null);
    s(c);
    const l = o.$;
    const {Xt: u} = o;
    const f = Is(u, () => uu(c, l, o.m));
    As(f) && (o.Xt = f);
};

const uu = (t, n, e) => {
    const s = t.In;
    if (s) {
        return s;
    }
    t.h &= -5;
    const o = t => n.handleError(t, e);
    let r = null;
    const i = Is(((t, n) => {
        const e = t.Nn;
        if (e) {
            return e;
        }
        const s = t.Tn;
        if (!s) {
            return;
        }
        t.Tn = null;
        try {
            const e = s();
            if (As(e)) {
                const s = Promise.resolve(e).then(() => {}, t => {
                    n(t);
                }).finally(() => {
                    t.Nn === s && (t.Nn = void 0);
                });
                t.Nn = s;
                return s;
            }
        } catch (t) {
            n(t);
        }
        return;
    })(t, o), () => {
        const s = ye(n.jt, e, "qTask");
        s.$ = n;
        const i = t.bt.getFn(s, () => kn(n, t));
        const c = Qr(t, n);
        const [l] = ((t, n) => {
            let e = null;
            return [ s => {
                if (typeof s == "function") {
                    if (!e) {
                        e = [];
                        t.Tn = () => {
                            t.Tn = null;
                            let s = null;
                            for (let t = 0; t < e.length; t++) {
                                const o = e[t];
                                try {
                                    const t = o();
                                    As(t) && (s ||= []).push(t.catch(n));
                                } catch (t) {
                                    n(t);
                                }
                            }
                            e = null;
                            if (s?.length) {
                                return Promise.all(s).then(() => {});
                            }
                        };
                    }
                    e.push(s);
                }
            }, e ?? [] ];
        })(t, o);
        const u = {
            track: c,
            cleanup: l
        };
        return xs(() => i(u), l, s => {
            if (As(s)) {
                return s.then(() => {
                    t.In === r && (t.In = null);
                    return uu(t, n, e);
                });
            }
            o(s);
        });
    });
    if (As(i)) {
        r = i.finally(() => {
            t.In === r && (t.In = null);
        });
        t.In = r;
        return r;
    }
    return i;
};

class cu extends Pr {
    h;
    Qt;
    ft;
    bt;
    Ot;
    Tn;
    Nn;
    In=null;
    constructor(t, n, e, s, o, r) {
        super();
        this.h = t;
        this.Qt = n;
        this.ft = e;
        this.bt = s;
        this.Ot = o;
        this.Tn = r;
    }
}

const fu = t => t instanceof cu;

function Mn(t, n) {
    const e = le(n);
    typeof this === "string" && If(Nf(e, this));
    const s = xf[0];
    s.h |= 4;
    yn(e, s.ft, 1);
}

const au = t => {
    const n = t.resolved;
    if (!n) {
        throw t.resolve();
    }
};

const hu = t => t instanceof Yr;

const du = (t, n) => {
    t.add(n);
};

const pu = (t, n) => {
    (t.backRef ||= new Set).add(n);
};

const $u = (t, n) => {
    if (n?.serializationCtx) {
        const e = t.consumer;
        const s = t.property;
        let o = null;
        fu(e) ? o = e.bt : e instanceof Gr ? o = e.en : s === ":" && (o = n.getHostProp(e, Ve));
        o && n.serializationCtx.xt.add(o);
    }
};

const yu = (t, n) => {
    if (t && (!n || t === n || Wh(t))) {
        return t;
    }
    return n;
};

const mu = (t, n, e) => {
    const s = ve;
    if (e) {
        const o = e => {
            const o = e.consumer;
            const r = e.property;
            if (fu(o)) {
                o.h |= 4;
                yn(t, o.ft, 1);
            } else if (o instanceof Yr) {
                o.invalidate();
            } else if (r === ":") {
                yn(t, o, 4);
            } else if (r === ".") {
                if (s) {
                    Ut(o, n);
                    yn(t, o, 2);
                }
            } else {
                const i = e.data;
                if (i instanceof Ii) {
                    const e = i.data;
                    const c = {
                        isConst: e.et,
                        scopedStyleIdPrefix: e.O,
                        value: n
                    };
                    if (s) {
                        (function l(t, n, e) {
                            const s = t.props ||= {};
                            let o = s[Fr];
                            if (!o) {
                                o = new Map;
                                s[Fr] = o;
                            }
                            o.set(n, e);
                        })(o, r, c);
                    } else {
                        const t = o;
                        let n = t.getProp(Fr);
                        if (!n) {
                            n = new Map;
                            t.setProp(Fr, n);
                        }
                        n.set(r, c);
                    }
                    yn(t, o, 16);
                }
            }
        };
        const r = Array.from(e);
        for (let t = 0; t < r.length; t++) {
            o(r[t]);
        }
    }
};

const wu = t => qe(t) && typeof t[zc] === "function";

const bu = t => {
    let n = 1;
    switch (t) {
      case "never":
        n |= 8;
        break;

      case "always":
        n |= 16;
        break;
    }
    return n;
};

const vu = t => {
    t.h |= 4;
};

const _u = [];

function An(t) {
    try {
        if (t === null) {
            return "null";
        }
        if (t === void 0) {
            return "undefined";
        }
        if (typeof t === "string") {
            return '"' + t + '"';
        }
        if (typeof t === "number" || typeof t === "boolean") {
            return t + "";
        }
        if (fu(t)) {
            return `Task(${An(t.bt)})`;
        }
        if (Ce(t)) {
            return `Qrl(${t.vt})`;
        }
        if (typeof t === "object" || typeof t === "function") {
            if (_u.includes(t)) {
                return "*";
            }
            _u.length;
            try {
                _u.push(t);
                if (Array.isArray(t)) {
                    return Go(t) ? "(" + (rl(t, Oe, null) || "vnode") + ")" : t.map(An);
                }
                if (hu(t)) {
                    return t instanceof xi ? "WrappedSignal" : t instanceof Gr ? "ComputedSignal" : "Signal";
                }
                if (Tu(t)) {
                    return "Store";
                }
                if (Oi(t)) {
                    return gu(t);
                }
                if (Go(t)) {
                    return "(" + (rl(t, Oe, null) || "vnode") + ")";
                }
            } finally {
                _u.pop();
            }
        }
    } catch (t) {
        console.error("ERROR in qwikDebugToString", t);
        return "*error*";
    }
    return t;
}

const gu = t => {
    if (Oi(t)) {
        if (typeof t.type === "function") {
            const n = t.type[Gf];
            if (n) {
                const [t] = n;
                return "Component(" + t.vt + ")";
            }
            return "Function(" + t.type.name + ")";
        }
        let n = "<" + t.type;
        if (t.props) {
            const e = Object.entries(t.props);
            for (let t = 0; t < e.length; t++) {
                const [s, o] = e[t];
                n += " " + s + "=" + An(o);
            }
            const s = t.children;
            if (s != null) {
                n += ">";
                if (Array.isArray(s)) {
                    for (let t = 0; t < s.length; t++) {
                        const e = s[t];
                        n += gu(e);
                    }
                } else {
                    n += gu(s);
                }
                n += "</" + t.type + ">";
            } else {
                n += "/>";
            }
        }
        return n;
    }
    return t + "";
};

const Eu = t => t[Hr];

const Su = t => t?.[Br] || null;

const ku = (t, n) => {
    const e = Eu(t);
    e && e.force(n);
};

const Ru = (t, n) => {
    const e = Eu(t);
    if (e) {
        return (e.ct?.get(n)?.size ?? 0) > 0;
    }
    return !1;
};

const Pu = t => Su(t) || t;

const Tu = t => Br in t;

function xn(t, n, e) {
    return new Proxy(n, new Mu(e, t || null));
}

const qu = (t, n, e) => {
    if (Te(t) && e) {
        let s = e.dt.get(t);
        if (!s) {
            s = xn(e, t, n);
            e.dt.set(t, s);
        }
        return s;
    }
    return t;
};

class Mu {
    h;
    $;
    ct=void 0;
    constructor(t, n) {
        this.h = t;
        this.$ = n;
    }
    toString() {
        return "[Store]";
    }
    force(t) {
        const n = Su(this);
        mu(this.$, this, Cn(n, t, this.ct));
    }
    get(t, n) {
        if (typeof n === "symbol") {
            if (n === Br) {
                return t;
            }
            if (n === Hr) {
                return this;
            }
            return t[n];
        }
        const e = af();
        const s = t[n];
        if (e) {
            if (this.$ === null) {
                if (!e.$) {
                    return s;
                }
                this.$ = e.$;
            }
            const o = e.Ft;
            o && In(t, Array.isArray(t) ? Jr : n, this, o, e.$);
        }
        if (n === "toString" && s === Object.prototype.toString) {
            return this.toString;
        }
        const o = this.h;
        if (o & 1 && qe(s) && !Object.isFrozen(s) && !Tu(s) && !Object.isFrozen(t)) {
            return qu(s, this.h, this.$);
        }
        return s;
    }
    set(t, n, e) {
        if (typeof n === "symbol") {
            t[n] = e;
            return !0;
        }
        const s = this.h & 1 ? Pu(e) : e;
        if (n in t) {
            const e = t[n];
            s !== e && Nn(n, s, t, this);
        } else {
            Nn(n, s, t, this);
        }
        return !0;
    }
    deleteProperty(t, n) {
        if (typeof n != "string" || !delete t[n]) {
            return !1;
        }
        Array.isArray(t) || mu(this.$, this, Cn(t, n, this.ct));
        return !0;
    }
    has(t, n) {
        if (n === Br) {
            return !0;
        }
        if (typeof n === "string") {
            const e = af();
            if (e) {
                const s = e.Ft;
                s && In(t, Array.isArray(t) ? Jr : n, this, s, e.$);
            }
        }
        return Object.prototype.hasOwnProperty.call(t, n);
    }
    ownKeys(t) {
        const n = af();
        const e = n?.Ft;
        e && In(t, Jr, this, e, n.$);
        return Reflect.ownKeys(t);
    }
    getOwnPropertyDescriptor(t, n) {
        const e = Reflect.getOwnPropertyDescriptor(t, n);
        if (Array.isArray(t) || typeof n === "symbol") {
            return e;
        }
        if (e && !e.configurable) {
            return e;
        }
        return {
            enumerable: !0,
            configurable: !0
        };
    }
}

function In(t, n, e, s, o) {
    const r = e.ct ||= new Map;
    let i = r.get(n);
    if (!i) {
        i = new Set;
        r.set(n, i);
    }
    const c = be;
    const l = __EXPERIMENTAL__.suspense && e instanceof Mu && c;
    du(i, s);
    pu(s, t);
    if (c) {
        const i = yu(o, e.$);
        l && i?.nn?.(t, s, n, r);
        $u(s, i);
    }
}

function Nn(t, n, e, s) {
    e[t] = n;
    const o = Cn(e, t, s.ct);
    o && mu(s.$, s, o);
}

function Cn(t, n, e) {
    let s;
    if (e) {
        if (Array.isArray(t)) {
            for (const t of e.values()) {
                s ||= new Set;
                for (const n of t) {
                    s.add(n);
                }
            }
        } else {
            s = e.get(n);
        }
    }
    const o = e?.get(Jr);
    if (o) {
        s ||= new Set;
        for (const t of o) {
            s.add(t);
        }
    }
    return s;
}

const Au = Symbol();

const xu = [ void 0, null, !0, !1, "", li, ui, Ur, Jr, oi, so, no, NaN, Infinity, -Infinity, Number.MAX_SAFE_INTEGER, Number.MAX_SAFE_INTEGER - 1, Number.MIN_SAFE_INTEGER ];

const Iu = [ "undefined", "null", "true", "false", "''", "EMPTY_ARRAY", "EMPTY_OBJ", "NEEDS_COMPUTATION", "STORE_ALL_PROPS", "_UNINITIALIZED", "Slot", "Fragment", "NaN", "Infinity", "-Infinity", "MAX_SAFE_INTEGER", "MAX_SAFE_INTEGER-1", "MIN_SAFE_INTEGER" ];

const Nu = [ "Plain", "RootRef", "ForwardRef", "Constant", "Array", "Object", "URL", "Date", "Regex", "QRL", "VNode", "RefVNode", "BigInt", "URLSearchParams", "ForwardRefs", "TemporalDuration", "TemporalInstant", "TemporalPlainDate", "TemporalPlainDateTime", "TemporalPlainMonthDay", "TemporalPlainTime", "TemporalPlainYearMonth", "TemporalZonedDateTime", "Error", "Promise", "Set", "Map", "Uint8Array", "Task", "Component", "Signal", "WrappedSignal", "ComputedSignal", "AsyncSignal", "SerializerSignal", "Store", "FormData", "JSXNode", "PropsProxy", "SubscriptionData", "EffectSubscription", "SubscriptionPatch" ];

function On(t, n, e) {
    let s = n.vt;
    let o = n._t;
    const r = Zs();
    if (r) {
        const t = r.chunkForSymbol(s, o);
        if (t) {
            o = t[1];
            s = t[0];
        }
    }
    const i = (t => Ce(t) && t.vt == Ne)(n);
    if (i) {
        const e = n.resolved;
        o = "";
        s = t.gt(null, 0, e) + "";
    } else {
        o || (o = t.Et(n.it));
        if (!o) {
            throw Ie(14, [ n.vt ]);
        }
        o.startsWith("./") && (o = o.slice(2));
    }
    const c = n.getCaptured();
    let l = null;
    c && c.length > 0 && (l = c.map(n => "" + t.St(n)).join(" "));
    if (e) {
        return [ o, s, l ];
    }
    let u = `${o}#${s}`;
    l && (u += "#" + l);
    return u;
}

function jn(t, n, e, s) {
    return Lf(t, n, null, null, e, s);
}

function Ln(t, n) {
    const [e, s, o] = t.split("#");
    return jn(e, s, o || null, n);
}

class Cu {
    rootId;
    subscriptions;
    constructor(t = 0, n = new Set) {
        this.rootId = t;
        this.subscriptions = n;
    }
}

class Ou {
    On;
    jn=0;
    Rt=[];
    Ln=0;
    Fn=new Set;
    Xn=new Map;
    Dn;
    Vn=new Map;
    Wn=0;
    Nt;
    Un=typeof Temporal !== "undefined";
    constructor(t) {
        this.On = t;
        this.Nt = t.Nt;
    }
    async serialize() {
        const t = this.Wn;
        this.Wn = 0;
        try {
            await this.outputRoots();
        } finally {
            this.Wn = t;
        }
    }
    async serializePatch(t, n, e, s = t) {
        const o = this.Wn;
        this.Wn = s;
        this.Nt.write(_r);
        this.On.zn = 0;
        try {
            this.Nt.write(t + "");
            this.Nt.write(Er);
            this.Nt.write(_r);
            await this.outputSelectedRoots(n);
            this.Nt.write(gr);
            const s = this.getForwardRefsPayload();
            this.On.zn = s?.length ?? 0;
            if (s || e !== void 0) {
                this.Nt.write(Er);
                s ? this.outputForwardRefsArray(s) : this.Nt.write("0");
            }
            if (e !== void 0) {
                this.Nt.write(Er);
                if (typeof e === "number") {
                    this.writeRootRef(e);
                } else if (typeof e === "string") {
                    this.outputString(e);
                } else {
                    this.Nt.write(vr);
                    this.writeRootRefPath(e);
                    this.Nt.write(vr);
                }
            }
        } finally {
            this.Wn = o;
        }
        this.Nt.write(gr);
    }
    Bn(t) {
        this.Nt = t;
    }
    outputArray(t, n, e) {
        this.Nt.write(_r);
        let s = !1;
        let o;
        if (n) {
            o = t.length;
        } else {
            o = t.length - 1;
            for (;o >= 0 && t[o] === void 0; ) {
                o--;
            }
            o++;
        }
        for (let n = 0; n < o; n++) {
            s ? this.Nt.write(Er) : s = !0;
            e(t[n], n);
        }
        this.Nt.write(gr);
    }
    stringNeedsJsonEscape$(t) {
        for (let n = 0; n < t.length; n++) {
            const e = t.charCodeAt(n);
            if (e < 32 || e === 34 || e === 92) {
                return !0;
            }
        }
        return !1;
    }
    maybeNumericObjectKey$(t) {
        if (t.length === 0 || t.length >= 8) {
            return t;
        }
        let n = 0;
        if (t.charCodeAt(0) === 45) {
            if (t.length === 1) {
                return t;
            }
            n = 1;
        }
        const e = t.charCodeAt(n);
        if (e < 49 || e > 57) {
            return t;
        }
        for (n++; n < t.length; n++) {
            const e = t.charCodeAt(n);
            if (e < 48 || e > 57) {
                return t;
            }
        }
        return +t;
    }
    outputString(t) {
        const n = this.stringNeedsJsonEscape$(t) ? JSON.stringify(t) : vr + t + vr;
        let e = -1;
        let s = 0;
        for (;(e = n.indexOf("</", s)) !== -1; ) {
            this.Nt.write(n.slice(s, e));
            this.Nt.write("<\\/");
            s = e + 2;
        }
        this.Nt.write(s === 0 ? n : n.slice(s));
    }
    writeRootRef(t) {
        this.Nt.writeRootRef(t);
    }
    writeRootRefPath(t) {
        this.Nt.writeRootRefPath(t);
    }
    outputStringChunks(t) {
        this.Nt.write(vr);
        for (let n = 0; n < t.length; n++) {
            const e = t[n];
            typeof e === "string" ? this.Nt.write(e) : typeof e === "number" ? this.writeRootRef(e) : this.writeRootRefPath(e.path);
        }
        this.Nt.write(vr);
    }
    output(t, n, e) {
        if (t === 1) {
            this.Nt.write(t + Er);
            if (typeof n === "number") {
                this.writeRootRef(n);
            } else if (typeof n === "string") {
                this.outputString(n);
            } else {
                this.Nt.write(vr);
                this.writeRootRefPath(n);
                this.Nt.write(vr);
            }
        } else if (t === 9 && Array.isArray(n)) {
            this.Nt.write(t + Er);
            this.outputStringChunks(n);
        } else if (typeof n === "number") {
            this.Nt.write(t + Er + n);
        } else if (typeof n === "string") {
            this.Nt.write(t + Er);
            this.outputString(n);
        } else {
            this.Nt.write(t + Er);
            this.outputArray(n, !!e, (t, n) => {
                this.writeValue(t, n);
            });
        }
    }
    getSeenRefOrOutput(t, n, e) {
        let s = this.On.getSeenRef(t);
        const o = !e && this.Xn.get(t);
        if (s) {
            s.Dn && this.isSeenInStreamedRoot(s) && (s = this.On.Hn(t));
        } else {
            if (e) {
                return !0;
            }
            if (typeof o !== "number") {
                return this.On.Jn(t, this.Dn, n);
            }
            s = this.On.St(t, !0);
        }
        if (s.Dn) {
            if (this.Dn) {
                this.On.Qn(s, t);
            } else {
                this.On.Qn(s, t, n);
                t = this.On.Yn[n];
            }
        }
        if (typeof o === "number") {
            this.Rt[o] = s.Qt;
            this.Xn.delete(t);
        }
        const r = t instanceof Wu ? t.Gn : s.Qt;
        if (!this.Dn && r === n) {
            return s;
        }
        this.output(1, r);
    }
    isSeenInStreamedRoot(t) {
        for (;t.Dn; ) {
            t = t.Dn;
        }
        return t.Qt < this.Wn;
    }
    writeValue(t, n) {
        if (Vc(t)) {
            this.output(3, 0);
        } else {
            switch (typeof t) {
              case "undefined":
                this.output(3, 0);
                break;

              case "boolean":
                this.output(3, t ? 2 : 3);
                break;

              case "number":
                Number.isNaN(t) ? this.output(3, 12) : Number.isFinite(t) ? t === Number.MAX_SAFE_INTEGER ? this.output(3, 15) : t === Number.MAX_SAFE_INTEGER - 1 ? this.output(3, 16) : t === Number.MIN_SAFE_INTEGER ? this.output(3, 17) : this.output(0, t) : this.output(3, t < 0 ? 14 : 13);
                break;

              case "string":
                t.length === 0 ? this.output(3, 4) : (t.length < 4 || this.getSeenRefOrOutput(t, n)) && this.output(0, t);
                break;

              case "bigint":
                (t < 1e4 && t > -1e3 || this.getSeenRefOrOutput(t, n)) && this.output(12, t.toString());
                break;

              case "symbol":
                if (t === Ur) {
                    this.output(3, 7);
                } else if (t === Jr) {
                    this.output(3, 8);
                } else if (t === oi) {
                    this.output(3, 9);
                } else {
                    if (t !== Au) {
                        throw Ie(20, [ typeof t ]);
                    }
                    this.output(3, 0);
                }
                break;

              case "function":
                if (t === so) {
                    this.output(3, 10);
                } else if (t === no) {
                    this.output(3, 11);
                } else if (Ce(t)) {
                    if (this.getSeenRefOrOutput(t, n)) {
                        const [n, e, s] = On(this.On, t, !0);
                        let o;
                        if (n !== "") {
                            o = [ this.On.St(n), "#", this.On.St(e) ];
                            if (s) {
                                const t = s.split(" ");
                                o.push("#");
                                for (let n = 0; n < t.length; n++) {
                                    n > 0 && o.push(" ");
                                    o.push(+t[n]);
                                }
                            }
                            const r = o.join("");
                            const i = this.Vn.get(r);
                            if (i) {
                                const t = this.On.St(i);
                                this.output(1, t);
                                return;
                            }
                            this.Vn.set(r, t);
                        } else {
                            o = +e;
                        }
                        this.output(9, o);
                    }
                } else {
                    if (!Kf(t)) {
                        throw Ie(34, [ t.toString() ]);
                    }
                    {
                        const [n] = t[Gf];
                        this.On.Kn.add(n.vt);
                        this.output(29, [ n ]);
                    }
                }
                break;

              case "object":
                if (t === li) {
                    this.output(3, 5);
                } else if (t === ui) {
                    this.output(3, 6);
                } else if (t === null) {
                    this.output(3, 1);
                } else if (t instanceof Wu) {
                    this.output(1, t.Gn);
                } else {
                    const e = this.getSeenRefOrOutput(t, n);
                    if (e) {
                        const n = this.Dn;
                        this.Dn = e;
                        this.writeObjectValue(t);
                        this.Dn = n;
                    }
                }
                break;

              default:
                throw Ie(20, [ typeof t ]);
            }
        }
    }
    writeObjectValue(t) {
        if (yi(t)) {
            const n = t[si];
            this.output(38, [ Du(n), n.varProps, n.constProps, t[ri].ct ]);
        } else if (t instanceof Ii) {
            this.output(39, [ t.data.O, t.data.et ]);
        } else if (t instanceof zr) {
            this.output(40, [ t.consumer, t.property, t.data ]);
        } else if (t instanceof Cu) {
            this.output(41, [ t.rootId, t.subscriptions ]);
        } else if (Tu(t)) {
            const n = Eu(t);
            const e = Su(t);
            const s = n.h;
            const o = n.ct;
            const r = [];
            for (const t in e) {
                const n = e[t];
                const s = this.On.dt.get(n);
                s && r.push(s);
            }
            const i = [ e, s, o, ...r ];
            for (;i[i.length - 1] === void 0; ) {
                i.pop();
            }
            this.output(35, i);
        } else if (wu(t)) {
            const n = t[zc](t);
            if (As(n)) {
                const t = this.resolvePromise(n, (t, n) => new ju(34, t, n, void 0, void 0));
                this.output(2, t);
            } else {
                const t = this.Dn.Qt;
                this.Dn = this.Dn.Dn;
                this.writeValue(n, t);
            }
        } else if (function n(t) {
            const n = Object.getPrototypeOf(t);
            return n == null || n === Object.prototype || n === Array.prototype;
        }(t)) {
            if (Array.isArray(t)) {
                this.output(4, t);
            } else {
                const n = [];
                for (const e in t) {
                    if (Object.prototype.hasOwnProperty.call(t, e)) {
                        const s = t[e];
                        Vc(s) || n.push(this.maybeNumericObjectKey$(e), s);
                    }
                }
                this.output(5, n.length ? n : 0);
            }
        } else if (this.On.Zn(t)) {
            this.On.te(t.ne, 16);
            this.output(11, t.ne.id);
        } else if (t instanceof Yr) {
            if (t instanceof wi) {
                const n = function e(t, n) {
                    if (n === Ur) {
                        return n;
                    }
                    return Is(t.en.resolved || t.en.resolve(), t => {
                        let e;
                        typeof t === "function" && (t = t());
                        t.serialize ? e = t.serialize(n) : typeof n === "object" && zc in n && (e = n[zc](n));
                        e === void 0 && (e = Ur);
                        return e;
                    });
                }(t, t.Zt);
                if (As(n)) {
                    const e = this.resolvePromise(n, (n, e) => new ju(34, n, e, t.ct, t.en));
                    this.output(2, e);
                } else {
                    this.output(34, [ t.en, t.ct, n ]);
                }
                return;
            }
            if (t instanceof xi) {
                this.output(31, [ ...Fn(this.On, t), t.h, t.m, ...t.ct || [] ]);
            } else if (t instanceof Gr) {
                let n = t.Zt;
                const e = t.h & 16;
                const s = t.h & 8;
                const o = t.h & 1;
                const r = Vc(t.Zt);
                const i = t instanceof Zr;
                const c = i && t.Pt !== 0 ? t.Pt : void 0;
                const l = i && t.yn !== 1 ? t.yn : void 0;
                const u = i && t.wn !== 0 ? t.wn : void 0;
                const f = i && t.h & -25 || void 0;
                o || r ? n = Ur : e ? n = t.Zt : s && (n = Ur);
                const a = [ t.en, t.ct ];
                if (i) {
                    a.push(t.$t, t.yt, t.pn);
                    a.push(f || void 0);
                }
                n === Ur && c === void 0 && l === void 0 && u === void 0 || a.push(n === void 0 ? Au : n);
                if (i) {
                    a.push(c);
                    a.push(l);
                    a.push(u);
                }
                this.output(i ? 33 : 32, a);
            } else {
                const n = t.Zt;
                const e = [ n === void 0 ? Au : n ];
                t.ct && e.push(...t.ct);
                this.output(30, e);
            }
        } else if (t instanceof URL) {
            this.output(6, t.href);
        } else if (t instanceof Date) {
            this.output(7, Number.isNaN(t.valueOf()) ? "" : t.valueOf());
        } else if (this.Un && t instanceof Temporal.Duration) {
            this.output(15, t.toJSON());
        } else if (this.Un && t instanceof Temporal.Instant) {
            this.output(16, t.toJSON());
        } else if (this.Un && t instanceof Temporal.PlainDate) {
            this.output(17, t.toJSON());
        } else if (this.Un && t instanceof Temporal.PlainDateTime) {
            this.output(18, t.toJSON());
        } else if (this.Un && t instanceof Temporal.PlainMonthDay) {
            this.output(19, t.toJSON());
        } else if (this.Un && t instanceof Temporal.PlainTime) {
            this.output(20, t.toJSON());
        } else if (this.Un && t instanceof Temporal.PlainYearMonth) {
            this.output(21, t.toJSON());
        } else if (this.Un && t instanceof Temporal.ZonedDateTime) {
            this.output(22, t.toJSON());
        } else if (t instanceof RegExp) {
            this.output(8, t.toString());
        } else if (t instanceof Error) {
            const n = [ t.message ];
            n.push(...Object.entries(t).flat());
            this.output(23, n);
        } else if (this.On.ee(t)) {
            const n = this.On.St(t);
            this.On.se(t, $s, n);
            this.output(10, t.id);
            const e = t.vnodeData;
            if (e) {
                Lu(e, t => {
                    this.On.St(t);
                });
                this.On.te(t, 16);
            }
            if (t.children) {
                const n = t.children.length;
                for (let e = 0; e < n; e++) {
                    const n = t.children[e];
                    this.On.te(n, 16);
                }
            }
        } else if (typeof FormData !== "undefined" && t instanceof FormData) {
            const n = [];
            for (const [e, s] of t.entries()) {
                typeof s === "string" && n.push(e, s);
            }
            this.output(36, n);
        } else if (t instanceof URLSearchParams) {
            this.output(13, t.toString());
        } else if (t instanceof Set) {
            this.output(25, [ ...t.values() ]);
        } else if (t instanceof Map) {
            const n = [];
            for (const [e, s] of t.entries()) {
                n.push(e, s);
            }
            this.output(26, n);
        } else if (Oi(t)) {
            const n = [ t.type, t.key, t.varProps, t.constProps, t.children, t.toSort || void 0 ];
            for (;n[n.length - 1] === void 0; ) {
                n.pop();
            }
            this.output(37, n);
        } else if (t instanceof cu) {
            const n = [ t.bt, t.h, t.Qt, t.ft, t.Ot ];
            for (;n[n.length - 1] === void 0; ) {
                n.pop();
            }
            this.output(28, n);
        } else if (As(t)) {
            const n = this.resolvePromise(t, (t, n) => new ju(24, t, n));
            this.output(2, n);
        } else if (t instanceof ju) {
            if (t.re === 34) {
                if (t.bt) {
                    this.output(34, [ t.bt, t.ct, t.ie ]);
                } else {
                    if (!t.oe) {
                        console.error(t.ie);
                        throw Ie(33);
                    }
                    {
                        const n = this.Dn.Qt;
                        this.Dn = this.Dn.Dn;
                        this.writeValue(t.ie, n);
                    }
                }
            } else {
                this.output(24, [ t.oe, t.ie ]);
            }
        } else if (t instanceof Uint8Array) {
            let n = "";
            const e = t.length;
            for (let s = 0; s < e; s++) {
                n += String.fromCharCode(t[s]);
            }
            const s = btoa(n).replace(/=+$/, "");
            this.output(27, s);
        } else if (t instanceof Xu) {
            const n = t.le;
            if (this.getSeenRefOrOutput(n, this.Dn.Qt, !0)) {
                let t = this.Xn.get(n);
                if (t === void 0) {
                    t = this.Ln++;
                    this.Xn.set(n, t);
                    this.Rt[t] = -1;
                }
                this.output(2, this.getForwardRefId(t));
            }
        } else {
            if (!Go(t)) {
                throw Ie(20, [ typeof t ]);
            }
            this.output(3, 0);
        }
    }
    resolvePromise(t, n) {
        const e = this.Ln++;
        t.then(s => {
            this.Fn.delete(t);
            this.Rt[e] = this.On.St(n(!0, s));
        }).catch(s => {
            this.Fn.delete(t);
            this.Rt[e] = this.On.St(n(!1, s));
        });
        this.Fn.add(t);
        return this.getForwardRefId(e);
    }
    getForwardRefId(t) {
        return this.On.ue + t;
    }
    async outputPendingRoots() {
        let t = 0;
        const {Yn: n} = this.On;
        for (;this.jn < n.length || this.Fn.size; ) {
            let e = t > 0;
            for (;this.jn < n.length; this.jn++) {
                e ? this.Nt.write(Er) : e = !0;
                this.writeValue(n[this.jn], this.jn);
                t++;
            }
            if (this.Fn.size) {
                try {
                    await Promise.race(this.Fn);
                } catch {}
            }
        }
        return t;
    }
    async outputSelectedRoots(t) {
        let n = !1;
        let e = 0;
        for (;e < t.length || this.Fn.size; ) {
            if (e < t.length) {
                n ? this.Nt.write(Er) : n = !0;
                const s = t[e++];
                this.writeValue(this.On.Yn[s], s);
                continue;
            }
            try {
                await Promise.race(this.Fn);
            } catch {}
        }
    }
    getForwardRefsPayload() {
        let t = this.Rt.length - 1;
        for (;t >= 0 && this.Rt[t] === -1; ) {
            t--;
        }
        if (t < 0) {
            return null;
        }
        return t === this.Rt.length - 1 ? this.Rt : this.Rt.slice(0, t + 1);
    }
    outputForwardRefsArray(t) {
        this.outputArray(t, !0, t => {
            if (typeof t === "string") {
                this.outputString(t);
            } else if (Array.isArray(t)) {
                this.Nt.write(vr);
                this.writeRootRefPath(t);
                this.Nt.write(vr);
            } else {
                this.writeRootRef(t);
            }
        });
    }
    async outputRoots() {
        this.Nt.write(_r);
        const t = await this.outputPendingRoots();
        const n = this.getForwardRefsPayload();
        this.On.ce = this.On.Yn.length;
        this.On.fe = !!n;
        const e = n?.length ?? 0;
        if (n) {
            t > 0 && this.Nt.write(Er);
            this.Nt.write(14 + Er);
            this.outputForwardRefsArray(n);
        }
        this.Nt.write(gr);
        this.On.ae = this.On.Yn.length + (this.On.fe ? 1 : 0);
        this.On.zn = e;
    }
}

class ju {
    re;
    oe;
    ie;
    ct;
    bt;
    constructor(t, n, e, s, o) {
        this.re = t;
        this.oe = n;
        this.ie = e;
        this.ct = s;
        this.bt = o;
    }
}

const Lu = (t, n) => {
    const e = t.length;
    for (let s = 0; s < e; s++) {
        const e = t[s];
        if (Fu(e)) {
            for (const t in e) {
                const s = e[t];
                if (s == null || typeof s === "string" || typeof s === "number" && t === $s || t === ms && wr(s)) {
                    continue;
                }
                n(s);
            }
        }
    }
};

const Fu = t => typeof t === "object" && t !== null && !wr(t);

function Fn(t, n) {
    n.kt && n.kt[0] === "{" && (n.kt = `(${n.kt})`);
    const e = t.gt(n.kt, n.lt.length, n.ot);
    return [ e, n.lt ];
}

class Xu {
    le;
    constructor(t) {
        this.le = t;
    }
}

const Du = t => new Xu(t);

let Vu = () => !1;

class Wu {
    Gn;
    constructor(t) {
        this.Gn = t;
    }
}

class Uu {
    NodeConstructor;
    DomRefConstructor;
    Et;
    se;
    dt;
    Nt;
    he=new Map;
    de=new Map;
    pe=0;
    $e=[];
    Yn=[];
    ye=[];
    me;
    ue=0;
    ae=0;
    zn=0;
    ce=0;
    fe=!1;
    Tt=new Set;
    xt=new Set;
    At=new Set;
    Kn=new Set;
    we;
    te=(t, n) => {
        t.vnodeData[0] |= n;
    };
    constructor(t, n, e, s, o, r) {
        this.NodeConstructor = t;
        this.DomRefConstructor = n;
        this.Et = e;
        this.se = s;
        this.dt = o;
        this.Nt = r;
        this.we = new Ou(this);
    }
    async It() {
        await this.we.serialize();
    }
    async be(t, n, e, s) {
        await this.we.serializePatch(t, n, e, s);
    }
    Bn(t) {
        this.Nt = t;
        this.we.Bn(t);
    }
    getSeenRef(t) {
        return this.he.get(t);
    }
    Jn(t, n, e) {
        const s = {
            Qt: e,
            Dn: n
        };
        this.he.set(t, s);
        return s;
    }
    ve(t) {
        const n = [];
        for (;t.Dn; ) {
            n.unshift(t.Qt);
            t = t.Dn;
        }
        n.unshift(t.Qt);
        return n;
    }
    Qn(t, n, e) {
        const s = this.ve(t);
        const o = e === void 0;
        e === void 0 && (e = this.Yn.length);
        this.Yn[e] = new Wu(s);
        o && (this.ye[e] = n);
        t.Dn = null;
        t.Qt = e;
        o && this.me?.(e, this.Yn[e], n);
    }
    St(t, n = !1) {
        let e = this.he.get(t);
        let s;
        if (e) {
            e.Dn && this.Qn(e, t);
            s = e.Qt;
        } else {
            s = this.Yn.length;
            e = {
                Qt: s
            };
            this.he.set(t, e);
            this.Yn.push(t);
            this.ye.push(t);
            this.me?.(s, t, t);
        }
        return n ? e : s;
    }
    Hn(t) {
        const n = this.Yn.length;
        const e = {
            Qt: n
        };
        this.he.set(t, e);
        this.Yn.push(t);
        this.ye.push(t);
        this.me?.(n, t, t);
        return e;
    }
    _e(t, n) {
        const e = this.Yn.length;
        const s = {
            Qt: e
        };
        this.he.set(n, s);
        this.Yn.push(t);
        this.ye.push(n);
        return e;
    }
    ee(t) {
        return !!this.NodeConstructor && t instanceof this.NodeConstructor;
    }
    Zn(t) {
        return !!this.DomRefConstructor && t instanceof this.DomRefConstructor;
    }
    ge(t) {
        const n = this.he.get(t);
        return n && (n.Dn ? void 0 : n.Qt);
    }
    gt(t, n, e) {
        const s = t == null;
        s && (t = e.serialized || e.toString());
        let o = this.de.get(t);
        if (o === void 0) {
            o = this.pe + this.$e.length;
            this.de.set(t, o);
            if (s) {
                this.$e.push(t);
            } else {
                let e = "(";
                for (let t = 0; t < n; t++) {
                    e += (t == 0 ? "p" : ",p") + t;
                }
                this.$e.push(e += ")=>" + t);
            }
        }
        return o;
    }
    Ee(t, n) {
        this.pe = t;
        if (n) {
            this.de.clear();
            for (let t = 0; t < n.length; t++) {
                this.de.set(n[t], t);
            }
        }
    }
}

const zu = (t, n, e, s, o, r) => {
    if (!r) {
        const t = [];
        r = Object.assign(br(n => {
            t.push(n);
        }), {
            toString: () => t.join("")
        });
    }
    Vu = n ? t => t instanceof n : () => !1;
    return new Uu(t, n, e, s, o, r);
};

const Bu = (t, n) => t[n];

const Hu = (t, n = new WeakSet) => {
    const e = typeof Temporal !== "undefined";
    if (t == null || typeof t === "string" || typeof t === "number" || typeof t === "boolean" || typeof t === "bigint") {
        return !0;
    }
    if (typeof t === "object") {
        if (n.has(t)) {
            return !0;
        }
        n.add(t);
        const s = Object.getPrototypeOf(t);
        Tu(t) && (t = Su(t));
        if (s == Object.prototype) {
            for (const e in t) {
                if (!Hu($f(Bu, t, e), n)) {
                    return !1;
                }
            }
            return !0;
        }
        if (s == Array.prototype) {
            for (let e = 0; e < t.length; e++) {
                if (!(e in t)) {
                    return !1;
                }
                if (!Hu(t[e], n)) {
                    return !1;
                }
            }
            return !0;
        }
        if (fu(t)) {
            return !0;
        }
        if (yi(t)) {
            return !0;
        }
        if (As(t)) {
            return !0;
        }
        if (Oi(t)) {
            return !0;
        }
        if (wu(t)) {
            return !0;
        }
        if (t instanceof Error) {
            return !0;
        }
        if (t instanceof URL) {
            return !0;
        }
        if (t instanceof Date) {
            return !0;
        }
        if (e && t instanceof Temporal.Duration) {
            return !0;
        }
        if (e && t instanceof Temporal.Instant) {
            return !0;
        }
        if (e && t instanceof Temporal.PlainDate) {
            return !0;
        }
        if (e && t instanceof Temporal.PlainDateTime) {
            return !0;
        }
        if (e && t instanceof Temporal.PlainMonthDay) {
            return !0;
        }
        if (e && t instanceof Temporal.PlainTime) {
            return !0;
        }
        if (e && t instanceof Temporal.PlainYearMonth) {
            return !0;
        }
        if (e && t instanceof Temporal.ZonedDateTime) {
            return !0;
        }
        if (t instanceof RegExp) {
            return !0;
        }
        if (t instanceof URLSearchParams) {
            return !0;
        }
        if (t instanceof FormData) {
            return !0;
        }
        if (t instanceof Set) {
            return !0;
        }
        if (t instanceof Map) {
            return !0;
        }
        if (t instanceof Uint8Array) {
            return !0;
        }
        if (t instanceof Ii) {
            return !0;
        }
        if (Vu?.(t)) {
            return !0;
        }
    } else if (typeof t === "function") {
        if (Ce(t) || Kf(t) || t === so || t === no) {
            return !0;
        }
    } else if (t === oi || t === Ur || t === Jr) {
        return !0;
    }
    return !1;
};

const Ju = (t, n) => {
    let e = Go(t) ? En.call(t, 1, "", !0).replaceAll(/\n.*/gm, "") : typeof t === "function" ? t + "" : (t => {
        const n = new WeakSet;
        return JSON.stringify(t, (t, e) => {
            if (qe(e)) {
                if (n.has(e)) {
                    return `[Circular ${e.constructor.name}]`;
                }
                n.add(e);
            }
            return e;
        }, 2);
    })(t);
    e.length > 500 && (e = e.slice(0, 500) + '"...');
    e = e.replace(/\n/g, "\n" + n);
    return e.includes("\n") ? e = `\n${n}${e}` : e;
};

let Qu = !1;

const Yu = (t, n = !1, e = "", s = 20) => {
    const o = n ? "[31m" : "";
    const r = n ? "[0m" : "";
    const i = e === "";
    const c = [];
    for (let i = 0; i < t.length; i++) {
        if (s && i > 2 * s) {
            c.push("...");
            break;
        }
        const l = t[i];
        let u = t[++i];
        if (l === 0) {
            const t = typeof u !== "number" && typeof u !== "string";
            t && (Qu = !0);
            const n = `{${qe(u) ? u.constructor.name : typeof u}}`;
            c.push(`${o}${n}${r} ${Ju(u, e + "  ")}`);
        } else {
            if (l === 3) {
                u = Ku(u);
            } else if (typeof u === "string") {
                u = JSON.stringify(u);
                u.length > 120 && (u = u.slice(0, 120) + '"...');
            } else {
                l === 14 ? u = `[\n${e}  ${u.join(`\n${e}  `)}\n${e}]` : Array.isArray(u) && (u = u.length ? `[\n${Yu(u, n, e + "  ")}\n${e}]` : "[]");
            }
            c.push(`${o}${Gu(l)}${r} ${u}`);
        }
    }
    const l = c.map((t, n) => `${e}${i ? n + " " : ""}${t}`).join("\n");
    if (i) {
        const n = Qu ? "" : `(${JSON.stringify(t).length} chars)`;
        Qu = !1;
        return `\n${l}\n${n}`;
    }
    return l;
};

const Gu = t => Nu[t] || `Unknown(${t})`;

const Ku = t => Iu[t] || `Unknown(${t})`;

function Xn(t, n, e, s = 0) {
    const o = (t, n) => t === 1 && typeof n === "string" && n.indexOf(" ") !== -1;
    const r = t => t === 14;
    const i = n => {
        const e = t[n + 1].split(" ");
        const s = parseInt(e[0], 10);
        let o = t;
        let r = 1;
        let i = 0;
        let c = 0;
        let l = null;
        for (let n = 0; n < e.length; n++) {
            l = o;
            i = (n === 0 ? s : parseInt(e[n], 10)) * 2;
            c = i + 1;
            const u = o;
            r = u[i];
            o = u[c];
            if (r === 1) {
                const n = typeof o === "string" ? parseInt(o, 10) : o;
                const e = n * 2;
                r = t[e];
                o = t[e + 1];
            }
        }
        if (l) {
            l[i] = 1;
            l[c] = n / 2;
        }
        t[n] = r;
        t[n + 1] = o;
    };
    for (let e = s; e < t.length; e += 2) {
        o(t[e], t[e + 1]) ? i(e) : r(t[e]) && (n.Rt = t[e + 1]);
    }
}

const Zu = new WeakMap;

const tc = new Map;

const nc = (t, n, e) => {
    switch (n) {
      case 0:
        return e;

      case 1:
        return t._(e);

      case 2:
        const s = t.Ct(e);
        return s === -1 || s === void 0 ? oi : t._(s);

      case 14:
        return e;

      case 3:
        return xu[e];

      case 4:
        return Array(e.length / 2);

      case 5:
        return {};

      case 9:
        {
            let n;
            if (typeof e === "string") {
                const [s, o, r] = e.split("#");
                const i = t._(s);
                const c = t._(o);
                n = jn(i, c, r || null, t);
            } else {
                n = jn("", e + "", null, t);
            }
            return n;
        }

      case 28:
        return new cu(-1, -1, null, null, null, null);

      case 6:
        return new URL(e);

      case 7:
        return new Date(e);

      case 15:
        return Temporal.Duration.from(e);

      case 16:
        return Temporal.Instant.from(e);

      case 17:
        return Temporal.PlainDate.from(e);

      case 18:
        return Temporal.PlainDateTime.from(e);

      case 19:
        return Temporal.PlainMonthDay.from(e);

      case 20:
        return Temporal.PlainTime.from(e);

      case 21:
        return Temporal.PlainYearMonth.from(e);

      case 22:
        return Temporal.ZonedDateTime.from(e);

      case 8:
        const o = e.lastIndexOf("/");
        return RegExp(e.slice(1, o), e.slice(o + 1));

      case 23:
        return Error();

      case 29:
        return Yf(null);

      case 30:
        return new Yr(t, 0);

      case 31:
        return new xi(t, null, null, null);

      case 32:
        return new Gr(t, null);

      case 33:
        return new Zr(t, null, void 0, {});

      case 34:
        return new wi(t, null);

      case 35:
        {
            const n = e;
            const s = n[0];
            const o = n[1];
            const r = nc(t, s, o);
            const i = qu(r, 0, t);
            Ic(s) && tc.set(r, {
                t: s,
                v: o
            });
            n[0] = 0;
            n[1] = r;
            return i;
        }

      case 13:
        return new URLSearchParams(e);

      case 36:
        return new FormData;

      case 37:
        return new Ni(null, null, null, null, 0, null);

      case 12:
        return BigInt(e);

      case 25:
        return new Set;

      case 26:
        return new Map;

      case 24:
        let r;
        let i;
        const c = new Promise((t, n) => {
            r = t;
            i = n;
        });
        Zu.set(c, [ r, i ]);
        c.catch(() => {});
        return c;

      case 27:
        const l = e.length;
        const u = l >>> 2;
        const f = l & 3;
        const a = u * 3 + (f ? f - 1 : 0);
        return new Uint8Array(a);

      case 38:
        return w(null);

      case 10:
        return Dn(t, e);

      case 11:
        const h = Dn(t, e);
        if (Go(h)) {
            Nl(h);
            return tu(h);
        }
        throw Ie(17, [ typeof h ]);

      case 39:
        return new Ii({});

      case 40:
        return new zr(null, null, null, null);

      case 41:
        return new Cu;

      default:
        throw Ie(18, [ n ]);
    }
};

function Dn(t, n) {
    return n ? t.rootVNode ? hl(t.rootVNode, n) : void 0 : t.element?.ownerDocument;
}

const ec = (t, n, e) => {
    let s = null;
    let o = null;
    if (xe(t)) {
        o = t;
    } else {
        if (!Ae(t)) {
            throw Ie(7, [ t ]);
        }
        s = t;
    }
    return Lf(s, n, null, o, e);
};

const sc = (t, n, e) => Lf(null, n, t, null, e);

const rc = (t, n) => Lf(null, t, null, null, n);

const ic = (t, n, e) => {
    const s = rc(t, e);
    return s;
};

const oc = (t, n, e, s) => Lf(t, e, null, n, s);

const lc = (t, n, e, s, o) => {
    const r = oc(t, n, e, o);
    r.Se(s);
    return r;
};

const uc = (t, n, e, s) => {
    const o = ec(t, n, s);
    return o;
};

const cc = (t, n, e, s) => {
    const o = sc(t, n, s);
    return o;
};

const fc = (t, n) => {
    typeof globalThis.__qwik_reg_symbols === "undefined" && (globalThis.__qwik_reg_symbols = new Map);
    globalThis.__qwik_reg_symbols.set(n, t);
    return t;
};

const ac = () => {
    const t = globalThis.process;
    return t?.getBuiltinModule?.("node:async_hooks")?.AsyncLocalStorage;
};

function Vn(t) {
    return t === null || typeof t === "string" || typeof t === "number" || typeof t === "boolean";
}

const hc = (t, n, e) => new xi(null, t, n, e || null);

class dc {
    ke;
    dt;
    Re=null;
    Cn=!1;
    jt;
    _;
    Dt;
    Pe=0;
    Te=null;
    qe=null;
    l=null;
    u=null;
    o=0;
    constructor(t, n) {
        this.Dt = t;
        this.jt = n;
        this.ke = Sr;
        this.dt = new WeakMap;
        this._ = () => {
            throw Error("Not implemented");
        };
    }
    trackSignalValue(t, n, e, s) {
        return wf(t, n, e, this, s);
    }
    serializationCtxFactory(t, n, e, s) {
        return zu(t, n, e, this.setHostProp.bind(this), this.dt, s);
    }
    ht() {
        if (this.o === 0) {
            this.u?.();
            this.l = null;
        }
    }
}

const pc = Symbol();

const Uh = t => {
    const n = () => {
        throw Error("Internal server component must be handled by the SSR renderer.");
    };
    n[pc] = t;
    return n;
};

class $c {}

function Wn(t, n, e) {
    return () => {
        t.currentStyleScoped = n;
        t.parentComponentFrame = e;
    };
}

async function Un(t, e, s) {
    const o = [ e ];
    const r = t => o.push(t);
    await (async () => {
        for (;o.length; ) {
            try {
                const e = o.pop();
                if (e === $c) {
                    const t = o.pop();
                    await n(() => o.push(t()));
                    continue;
                }
                if (typeof e === "function") {
                    if (e === Promise) {
                        o.push(await o.pop());
                    } else {
                        const n = e.apply(t);
                        As(n) && await n;
                    }
                    continue;
                }
                zn(t, r, e, s);
            } finally {
                const n = t.streamHandler.waitForPendingFlush();
                As(n) && await n;
            }
        }
    })();
}

function zn(t, n, e, s) {
    if (e == null) {
        t.textNode("");
    } else if (typeof e === "boolean") {
        t.textNode("");
    } else if (typeof e === "number") {
        t.textNode(e + "");
    } else if (typeof e === "string") {
        t.textNode(e);
    } else if (typeof e === "object") {
        if (Array.isArray(e)) {
            for (let t = e.length - 1; t >= 0; t--) {
                n(e[t]);
            }
        } else if (hu(e)) {
            (function s(t, n) {
                const e = n instanceof xi ? n.rt() : n;
                if (e instanceof Zr) {
                    const n = e.Pt;
                    if (n && !(e.h & 256)) {
                        t.St(e);
                        t.Tt.add(e);
                    }
                }
            })(t.serializationCtx, e);
            t.openFragment(ui);
            const o = t.getOrCreateLastNode();
            const r = e instanceof xi ? e.rt() : e;
            n(t.closeFragment);
            n(() => wf(r, o, ".", t));
            n($c);
        } else if (As(e)) {
            t.openFragment(ui);
            n(t.closeFragment);
            n(e);
            n(Promise);
            n(() => t.streamHandler.flush());
        } else if (function o(t) {
            return !!t[Symbol.asyncIterator];
        }(e)) {
            n(async () => {
                for await (const n of e) {
                    await Un(t, n, {
                        currentStyleScoped: s.currentStyleScoped,
                        parentComponentFrame: s.parentComponentFrame
                    });
                    await t.streamHandler.flush();
                }
            });
        } else {
            const o = e;
            const r = o.type;
            if (typeof r === "string") {
                (function e(t, n) {
                    const e = hi(t, "class") != null;
                    if (!e && n) {
                        t.constProps || (t.constProps = {});
                        t.constProps.class = "";
                    }
                })(o, s.currentStyleScoped);
                let i = null;
                const c = t.openElement(r, o.key, o.varProps, o.constProps, s.currentStyleScoped, i, !!(o.flags & 4));
                c && t.htmlNode(c);
                n(t.closeElement);
                if (r === "head") {
                    t.emitQwikLoaderAtTopIfNeeded();
                    t.emitPreloaderPre();
                    n(t.additionalHeadNodes);
                } else if (r === "body") {
                    n(t.additionalBodyNodes);
                } else {
                    const n = t;
                    if (!t.isHtml && !n._didAddQwikLoader && !t.qt) {
                        t.emitQwikLoaderAtTopIfNeeded();
                        t.emitPreloaderPre();
                        n._didAddQwikLoader = !0;
                    }
                }
                const l = o.children;
                l != null && n(l);
            } else if (xe(r)) {
                if (__EXPERIMENTAL__.suspense && (t => typeof t === "function" && pc in t)(r)) {
                    n(() => (t => t[pc])(r)(t, o, s, n));
                    return;
                }
                if (r === no) {
                    const e = o.key != null ? {
                        [ys]: o.key
                    } : {};
                    t.openFragment(e);
                    n(t.closeFragment);
                    const s = o.children;
                    s != null && n(s);
                } else if (r === so) {
                    const e = s.parentComponentFrame;
                    if (e) {
                        const r = e.componentNode.id || "";
                        const i = {};
                        const c = hi(o, us);
                        c && (i[us] = c);
                        i["q:sparent"] = r;
                        t.openProjection(i);
                        const l = e.componentNode;
                        const u = t.getOrCreateLastNode();
                        const f = k(l, o, t);
                        i[ze] = f;
                        n(Wn(s, s.currentStyleScoped, s.parentComponentFrame));
                        n(t.closeProjection);
                        const a = o.children || null;
                        const h = e.consumeChildrenForSlot(u, f) || a;
                        a && h !== a && t.addUnclaimedProjection(e, "", a);
                        n(h);
                        n(Wn(s, e.projectionScopedStyle, e.projectionComponentFrame));
                    } else {
                        let n = ui;
                        t.openFragment(n);
                        t.closeFragment();
                    }
                } else if (r === oo) {
                    t.commentNode(hi(o, "data") || "");
                } else if (r === uo) {
                    t.streamHandler.flush();
                    const e = o.children;
                    let r;
                    r = xe(e) ? e({
                        async write(n) {
                            await Un(t, n, {
                                currentStyleScoped: s.currentStyleScoped,
                                parentComponentFrame: s.parentComponentFrame
                            });
                            await t.streamHandler.flush();
                        }
                    }) : e;
                    n(r);
                    As(r) && n(Promise);
                } else if (r === io) {
                    t.htmlNode(hi(o, "data"));
                } else if (r === lo) {
                    t.streamHandler.streamBlockStart();
                    n(() => t.streamHandler.streamBlockEnd());
                    n(o.children);
                } else if (Kf(r)) {
                    const e = {};
                    t.openComponent(e);
                    const i = t.getOrCreateLastNode();
                    const c = t.getParentComponentFrame();
                    c.distributeChildrenIntoSlots(o.children, s.currentStyleScoped, s.parentComponentFrame);
                    const l = ((t, n, e) => {
                        const s = t.getOrCreateLastNode();
                        const [o] = e[Gf];
                        const r = n.props;
                        r && r.children && delete r.children;
                        s.setProp(Ve, o);
                        s.setProp(ms, r);
                        n.key !== null && s.setProp(ys, n.key);
                        return Co(t, s, s, o, r);
                    })(t, o, r);
                    n(Wn(s, s.currentStyleScoped, s.parentComponentFrame));
                    n(() => t.closeComponent());
                    if (As(l)) {
                        n(async () => {
                            const t = await l;
                            const e = js(i.getProp(Ge));
                            n(t);
                            n(Wn(s, e, c));
                        });
                    } else {
                        n(l);
                        const t = js(i.getProp(Ge));
                        n(Wn(s, t, c));
                    }
                } else {
                    const e = {
                        [ys]: o.key
                    };
                    t.openFragment(e);
                    n(t.closeFragment);
                    const s = t.getParentComponentFrame();
                    const i = ((t, n, e, s) => {
                        const o = t.getOrCreateLastNode();
                        return Co(t, o, n, e, s.props);
                    })(t, s && s.componentNode, r, o);
                    n(i);
                    As(i) && n(Promise);
                }
            }
        }
    }
}

const yc = () => xf;

const mc = async t => {
    const [n, e] = xf;
    const s = await n(t);
    s && typeof s === "object" ? e.r ? Object.assign(e.r, s) : e.r = xn(n.$, s, 1) : e.r = s;
    return {
        r: e.r
    };
};

const wc = (t, n) => {
    const {val: e, set: s, iCtx: o} = ko();
    if (e) {
        return e;
    }
    const r = Lf(null, "_rsc", mc, null, [ t, {} ], o.$);
    const i = vi(r, {
        timeout: n?.timeout,
        container: o.$,
        concurrency: 0
    });
    i.p();
    const c = {
        __brand: "resource",
        signal: i,
        get value() {
            return i.promise().then(() => i.error ? Promise.reject(i.error) : i.value.r);
        },
        get loading() {
            return i.loading;
        }
    };
    s(c);
    return c;
};

const bc = ({value: t, onResolved: n, onPending: e, onRejected: s}) => {
    if (As(t)) {
        return t.then(n, s);
    }
    const o = vc(t);
    const r = o ? t.signal : t;
    if (e && r.loading) {
        return e();
    }
    if (s && r.error) {
        return s(r.error);
    }
    const i = o ? r.value?.r : r.value;
    return As(i) ? i.then(n, s) : n(i);
};

const vc = t => t && t.__brand === "resource";

function Bn(t, n, e, s) {
    let o = null;
    const r = e;
    const i = t => {
        o == null ? o = t : typeof o === "string" && typeof t === "string" ? o += "|" + t : o = [ ...typeof o === "string" ? [ o ] : o, "|", ...typeof t === "string" ? [ t ] : t ];
    };
    const c = n => {
        n.vt.startsWith("_") || !n.Mt?.length && !s || (n = Lf(null, "_run", I, null, [ n ]));
        return function e(t, n) {
            const [e, s, o] = On(t, n, !0);
            const r = `${e}#${s}`;
            if (!o) {
                return r;
            }
            const i = [ r, "#" ];
            const c = o.split(" ");
            for (let t = 0; t < c.length; t++) {
                t > 0 && i.push(" ");
                i.push(+c[t]);
            }
            return i;
        }(t, n);
    };
    if (Array.isArray(r)) {
        for (let e = 0; e < r.length; e++) {
            const o = r[e];
            if (Ce(o)) {
                i(c(o));
                Hn(t, n, o);
            } else if (o != null) {
                const e = Bn(t, n, o, s);
                e && i(e);
            }
        }
    } else if (Ce(r)) {
        o = c(r);
        Hn(t, n, r);
    }
    return o;
}

function Hn(t, n, e) {
    const s = Ds(n);
    if (s) {
        const [n, o] = s;
        const r = ((t, n) => t + ":" + n)(n, o);
        t.At.add(r);
        t.xt.add(e);
    }
}

const _c = (t, n, e) => {
    Sc(e?.passive ? "q-ep:" : "q-e:", t, n, e);
};

const gc = (t, n, e) => {
    Sc(e?.passive ? "q-dp:" : "q-d:", t, n, e);
};

const Ec = (t, n, e) => {
    Sc(e?.passive ? "q-wp:" : "q-w:", t, n, e);
};

const Sc = (t, n, e, s) => {
    const {isAdded: o, addEvent: r} = kc();
    if (o) {
        return;
    }
    if (e) {
        if (Array.isArray(n)) {
            for (let o = 0; o < n.length; o++) {
                const i = n[o];
                r(t + Xs(i), e, s);
            }
        } else {
            r(t + Xs(n), e, s);
        }
    }
};

const kc = () => {
    const t = df();
    const n = t.m;
    const e = n;
    let s = t.$.getHostProp(e, Es);
    if (s === null) {
        s = {};
        t.$.setHostProp(e, Es, s);
    }
    let o = t.$.getHostProp(e, Ss);
    o === null && (o = 0);
    t.$.setHostProp(e, Ss, o + 1);
    let r = t.$.getHostProp(e, ks);
    if (r === null) {
        r = [];
        t.$.setHostProp(e, ks, r);
    }
    for (;r.length <= o; ) {
        r.push(!1);
    }
    return {
        isAdded: r[o],
        addEvent: (t, n, e) => {
            r[o] = !0;
            let i = s[t];
            i || (s[t] = i = {
                qrls: [],
                capture: !1,
                preventdefault: !1,
                stoppropagation: !1
            });
            i.qrls.push(n);
            e?.capture && (i.capture = !0);
            e?.preventdefault && (i.preventdefault = !0);
            e?.stoppropagation && (i.stoppropagation = !0);
        }
    };
};

const Rc = function(t, n) {
    const e = le(n);
    typeof this === "string" && If(Nf(e, this));
    const s = xf?.[1];
    const o = s ?? n.getAttribute("data-qwik-inspector");
    if (!o || !t.detail.files.some(t => o.startsWith(t))) {
        return;
    }
    const r = xf?.[0];
    if (!r || r.flags & 32) {
        return;
    }
    yn(e, r, 4);
    const i = n.ownerDocument;
    i.__hmrDone = i.__hmrT;
};

let Pc;

function Jn(t) {
    const n = af();
    if (!n) {
        return;
    }
    Pc ||= sc(Rc, "_hmr");
    const e = n.m;
    const s = Pc.w([ e, t ]);
    gc("qHmr", s);
}

function Qn(t, n, e, s, o) {
    const r = Yo();
    il(r, ze, o);
    r.parent = n;
    il(n, o, r);
    il(r, Ve, e);
    il(r, ms, s);
    r.dirty = 4;
    hn(t, r, 1);
    return r;
}

function Yn(t, n) {
    il(t, We, n);
    t.flags |= 2048;
}

function Gn(t, n, e) {
    il(n, ms, e);
    yn(t, n, 4);
}

function Kn(t, n, e, s) {
    il(n, s, null);
    const o = [];
    Et(t, o, e);
    wl(o);
    if (e.flags & 2048) {
        const t = rl(e, We, null);
        t && t.replaceChildren();
        il(e, We, null);
        e.flags &= -2049;
    }
}

let Tc = Promise.resolve();

const qc = new Set([ "constructor", "prototype", "toString", "valueOf", "toJSON", "then" ]);

const Mc = (t, n) => {
    if (typeof t === "number") {
        return !0;
    }
    return typeof t === "string" && t !== "__proto__" && (typeof n !== "function" || !qc.has(t));
};

const Ac = (t, n, e, s) => {
    if (e === 0) {
        return;
    }
    e !== 4 && Array.isArray(s) && (s = xc(t, s));
    switch (e) {
      case 4:
        xc(t, s, n);
        break;

      case 5:
        if (s === 0) {
            break;
        }
        for (let t = 0; t < s.length; t += 2) {
            const e = s[t];
            const o = s[t + 1];
            if (!Mc(e, o)) {
                continue;
            }
            n[e] = o;
        }
        break;

      case 28:
        const o = n;
        const r = s;
        o.bt = r[0];
        o.h = r[1];
        o.Qt = r[2];
        o.ft = r[3];
        o.Ot = r[4];
        break;

      case 29:
        n[Gf][0] = s[0];
        break;

      case 35:
        {
            const e = Pu(n);
            const o = tc.get(e);
            if (o) {
                tc.delete(e);
                Ac(t, e, o.t, o.v);
            }
            const [, r, i] = s;
            const c = Eu(n);
            c.h = r;
            c.ct = i;
            ne(c.ct, e);
            break;
        }

      case 30:
        {
            const t = n;
            const e = s;
            t.Zt = e[0];
            t.ct = new Set(e.slice(1));
            te(t.ct, t);
            break;
        }

      case 31:
        {
            const e = n;
            const o = s;
            e.ot = t.getSyncFn(o[0]);
            e.lt = o[1];
            e.Zt = Ur;
            e.h = o[2];
            e.h |= 1;
            e.m = o[3];
            e.ct = new Set(o.slice(4));
            (function r(t) {
                if (t.m !== null && Go(t.m)) {
                    const n = t.m;
                    const e = t.ct;
                    let s = !1;
                    if (e) {
                        for (const o of e) {
                            const e = o.property;
                            if (Ae(e)) {
                                const o = rl(n, e, null);
                                if (o !== null) {
                                    t.Zt = o;
                                    s = !0;
                                    break;
                                }
                            }
                        }
                    }
                    if (!s) {
                        const e = Il(n);
                        e && n.firstChild === n.lastChild && nl(e) && (t.Zt = Al(e));
                    }
                }
            })(e);
            te(e.ct, e);
            break;
        }

      case 33:
        {
            const t = n;
            const e = s;
            t.en = e[0];
            e[1] && (t.ct = new Set(e[1]));
            e[2] && (t.$t = new Set(e[2]));
            e[3] && (t.yt = new Set(e[3]));
            e[4] && (t.pn = e[4]);
            t.h = e[5] ?? 0;
            t.h & 64 && (t.dn = !0);
            const o = e.length > 6;
            o && (t.Zt = e[6]);
            t.Zt === Ur && (t.h |= 1);
            const r = e[7] ?? 0;
            t.expires = Math.abs(r);
            r < 0 && (t.h |= 256);
            if (e[8] !== void 0 && e[8] !== 1) {
                t.yn = e[8] ?? 1;
                t.mn = [];
            }
            t.wn = e[9] ?? 0;
            te(t.ct, t);
            te(t.$t, t);
            te(t.yt, t);
            break;
        }

      case 34:
      case 32:
        {
            const o = n;
            const r = s;
            o.en = r[0];
            const i = o.en.resolve(t).catch(() => {});
            Tc = Tc.finally(() => i);
            r[1] && (o.ct = new Set(r[1]));
            const c = r.length > 2;
            c && (o.Zt = r[2]);
            e !== 34 && o.Zt !== Ur && (o.h &= -2);
            te(o.ct, o);
            break;
        }

      case 23:
        {
            const t = s;
            n.message = t[0];
            for (let e = 1; e < t.length; e += 2) {
                n[t[e]] = t[e + 1];
            }
            break;
        }

      case 36:
        {
            const t = n;
            const e = s;
            for (let n = 0; n < e.length; n++) {
                t.append(e[n++], e[n]);
            }
            break;
        }

      case 37:
        {
            const t = n;
            const [e, o, r, i, c, l] = s;
            t.type = e;
            t.key = o;
            t.varProps = r;
            t.constProps = i || null;
            t.children = c;
            t.toSort = !!l;
            break;
        }

      case 25:
        {
            const t = n;
            const e = s;
            for (let n = 0; n < e.length; n++) {
                t.add(e[n]);
            }
            break;
        }

      case 26:
        {
            const t = n;
            const e = s;
            for (let n = 0; n < e.length; n++) {
                t.set(e[n++], e[n]);
            }
            break;
        }

      case 24:
        {
            const t = n;
            const [e, o] = s;
            const [r, i] = Zu.get(t);
            e ? r(o) : i(o);
            break;
        }

      case 27:
        const i = n;
        const c = atob(s);
        let l = 0;
        for (let t = 0; t < c.length; t++) {
            const n = c[t];
            i[l++] = n.charCodeAt(0);
        }
        break;

      case 38:
        const u = n;
        const f = s;
        let a = f[0];
        if (a === oi) {
            a = new Ni(no, f[1], f[2], null, 0, null);
            a._proxy = u;
        }
        u[si] = a;
        const h = u[ri];
        h.ct = f[3];
        ne(h.ct, u);
        break;

      case 39:
        {
            const t = n;
            t.data.O = s[0];
            t.data.et = s[1];
            break;
        }

      case 40:
        {
            const t = n;
            const e = s;
            t.consumer = e[0];
            t.property = e[1];
            t.data = e[2];
            (function o(t) {
                const n = be;
                const e = t.consumer;
                if (n && !e) {
                    return;
                }
                e[Rr] ||= new Map;
                e[Rr].set(t.property, t);
            })(t);
            break;
        }

      case 41:
        {
            const t = n;
            const e = s;
            t.rootId = e[0];
            t.subscriptions = e[1];
            break;
        }

      default:
        throw Ie(16, [ e ]);
    }
};

const xc = (t, n, e = Array(n.length / 2)) => {
    for (let s = 0; s < n.length; s += 2) {
        e[s / 2] = Zn(t, n[s], n[s + 1]);
    }
    return e;
};

function Zn(t, n, e) {
    if (n === 0) {
        return e;
    }
    const s = nc(t, n, e);
    Ic(n) && Ac(t, s, n, e);
    return s;
}

function te(t, n) {
    if (t) {
        for (const e of t) {
            e.backRef ||= new Set;
            e.backRef.add(n);
        }
    }
}

function ne(t, n) {
    if (t) {
        for (const [, e] of t) {
            te(e, n);
        }
    }
}

const Ic = t => t >= 23 || t === 4 || t === 5;

const Nc = new WeakMap;

const Cc = Symbol();

const Oc = (t, n) => {
    if (!Array.isArray(n) || Go(n) || (t => qe(t) && Cc in t)(n)) {
        return n;
    }
    let e = Nc.get(n);
    if (!e) {
        const s = Array(n.length / 2).fill(void 0);
        e = new Proxy(s, new jc(t, n));
        Nc.set(n, e);
    }
    return e;
};

class jc {
    $;
    Me;
    constructor(t, n) {
        this.$ = t;
        this.Me = n;
    }
    get(t, n, e) {
        if (n === Cc) {
            return t;
        }
        const s = typeof n === "number" ? n : typeof n === "string" ? parseInt(n, 10) : NaN;
        if (Number.isNaN(s) || s < 0 || s >= this.Me.length / 2) {
            return Reflect.get(t, n, e);
        }
        const o = s * 2;
        const r = this.Me[o];
        const i = this.Me[o + 1];
        if (r === 0) {
            return i;
        }
        const c = this.$;
        const l = nc(c, r, i);
        Reflect.set(t, n, l);
        this.Me[o] = 0;
        this.Me[o + 1] = l;
        Ic(r) && Ac(c, l, r, i);
        return l;
    }
    has(t, n) {
        if (n === Cc) {
            return !0;
        }
        return Object.prototype.hasOwnProperty.call(t, n);
    }
    set(t, n, e, s) {
        if (n === Cc) {
            return !1;
        }
        const o = Reflect.set(t, n, e, s);
        const r = typeof n === "number" ? n : parseInt(n, 10);
        if (Number.isNaN(r) || r < 0 || r >= this.Me.length / 2) {
            return o;
        }
        const i = r * 2;
        this.Me[i] = 0;
        this.Me[i + 1] = e;
        return !0;
    }
}

async function ee(t) {
    const n = zu(null, null, () => "", () => {}, new WeakMap);
    n.St(t);
    await n.It();
    return n.Nt.toString();
}

function se(t) {
    if (t == null) {
        throw Error("No state data to deserialize");
    }
    const n = JSON.parse(t);
    if (!Array.isArray(n) || n.length < 2 || typeof n[0] !== "number") {
        throw Error("Invalid state data");
    }
    const e = ie(n);
    return Zn(e, n[0], n[1]);
}

function re(t, n) {
    if (typeof t === "string") {
        t = parseInt(t, 10);
        return n[t];
    }
    return n[t];
}

function ie(t) {
    let n;
    const e = {
        _: t => re(t, n),
        Ct: t => e.Rt?.[+t],
        getSyncFn: () => () => {},
        dt: new WeakMap,
        element: null,
        Rt: null
    };
    Xn(t, e);
    n = Oc(e, t);
    e.Ot = n;
    return e;
}

const Lc = (t, n) => {
    const e = new WeakSet;
    return $f(Fc, t, e, "_", n);
};

const Fc = (t, n, e, s) => {
    const o = Pu(t);
    if (o == null) {
        return t;
    }
    if (Dc(o)) {
        if (typeof o === "object") {
            if (n.has(o)) {
                return t;
            }
            n.add(o);
        }
        if (hu(o)) {
            return t;
        }
        if (Hu(o)) {
            return t;
        }
        if (o.__brand || o.__brand__) {
            return t;
        }
        const r = typeof o;
        switch (r) {
          case "object":
            if (As(o)) {
                return t;
            }
            if ((t => t && typeof t.nodeType === "number")(o)) {
                return t;
            }
            if (Me(o)) {
                let s = 0;
                for (let t = 0; t < o.length; t++) {
                    if (!(t in o)) {
                        throw Ie(3, [ o ]);
                    }
                    const r = o[t];
                    if (t !== s) {
                        throw Ie(3, [ o ]);
                    }
                    Fc(r, n, e + "[" + t + "]");
                    s = t + 1;
                }
                return t;
            }
            if (o instanceof xr) {
                return t;
            }
            if (Te(o)) {
                for (const [t, s] of Object.entries(o)) {
                    Fc(s, n, e + "." + t);
                }
                return t;
            }
            break;
        }
        let i;
        i = s || "Value cannot be serialized";
        e !== "_" && (i += ` in ${e},`);
        if (r === "object") {
            i += ` because it's an instance of "${t?.constructor.name}". You might need to use 'noSerialize()' or use an object literal instead. Check out https://qwik.dev/docs/advanced/dollar/`;
        } else if (r === "function") {
            const n = t.name;
            i += ` because it's a function named "${n}". You might need to convert it to a QRL using $(fn):\n\nconst ${n} = $(${t + ""});\n\nPlease check out https://qwik.dev/docs/advanced/qrl/ for more information.`;
        }
        throw Ie(3, [ i ]);
    }
    return t;
};

const Xc = /*#__PURE__*/ new WeakSet;

const Dc = t => {
    if (qe(t) || xe(t)) {
        return !Xc.has(t) && !(Uc in t);
    }
    return !0;
};

const Vc = t => !!t && (qe(t) || typeof t === "function") && (Xc.has(t) || Uc in t);

const Wc = t => {
    (qe(t) && t !== null || typeof t === "function") && Xc.add(t);
    return t;
};

const Uc = Symbol();

const zc = Symbol();

const Bc = t => /*#__PURE__*/ Object.freeze({
    id: Xs(t)
});

const Hc = (t, n) => {
    const {val: e, set: s, iCtx: o} = ko();
    if (e !== void 0) {
        return;
    }
    o.$.setContext(o.m, t, n);
    s(1);
};

const Jc = (t, n) => {
    const {val: e, set: s, iCtx: o} = ko();
    if (e !== void 0) {
        return e;
    }
    const r = o.$.resolveContext(o.m, t);
    if (typeof n === "function") {
        return s(de(void 0, n, r));
    }
    if (r !== void 0) {
        return s(r);
    }
    if (n !== void 0) {
        return s(n);
    }
    throw Ie(8, [ t.id ]);
};

const Qc = t => {
    const n = hf();
    const e = n.m;
    if (!e) {
        return;
    }
    return n.$?.resolveContext(e, t);
};

const Yc = /*#__PURE__*/ Bc("qk-error");

const zh = (t, n = t => t.boundary.pending.untrackedValue > 0) => {
    if (t === null) {
        return !0;
    }
    const e = t.reveal;
    const s = t.item;
    const o = e.items;
    switch (e.order) {
      case "together":
        for (let t = 0; t < o.length; t++) {
            if (n(o[t])) {
                return !1;
            }
        }
        return !0;

      case "sequential":
        for (let t = 0; t < o.length; t++) {
            const e = o[t];
            if (e === s) {
                return !0;
            }
            if (n(e)) {
                return !1;
            }
        }
        return !0;

      case "reverse":
        for (let t = o.length - 1; t >= 0; t--) {
            const e = o[t];
            if (e === s) {
                return !0;
            }
            if (n(e)) {
                return !1;
            }
        }
        return !0;

      default:
        return !0;
    }
};

const Bh = new WeakMap;

class Hh {
    id;
    collapsed;
    count=0;
    pendingItems=new Set;
    orderCode;
    constructor(t, n, e) {
        this.id = t;
        this.collapsed = e;
        this.orderCode = Jh(n);
    }
    register(t) {
        this.pendingItems.add(t.item);
        const n = this.count++;
        return {
            attrs: ` q:g="${this.id}" q:i="${n}" q:o="${this.orderCode}"` + (this.collapsed ? " q:c" : ""),
            showFallback: this.canReveal(t) || !this.collapsed,
            resolve: () => {
                this.pendingItems.delete(t.item);
            }
        };
    }
    canReveal(t) {
        return zh(t, t => this.pendingItems.has(t));
    }
    script() {
        return this.count === 0 ? "" : `qO.g(${this.id},${this.count},"${this.orderCode}");`;
    }
}

const Jh = t => {
    switch (t) {
      case "sequential":
        return "s";

      case "reverse":
        return "r";

      case "together":
        return "t";

      default:
        return "p";
    }
};

const Qh = () => {
    if (!__EXPERIMENTAL__.suspense) {
        return !1;
    }
    const t = af()?.$;
    return t?.outOfOrderStreaming === !0 && !Wh(t);
};

const Gc = (t, n, e, s, o) => {
    let r;
    for (const t of o) {
        if (!s.has(t)) {
            s.add(t);
            (r ||= new Set).add(t);
        }
        (t.backRef ||= new Set).add(e);
    }
    r && mu(t, n, r);
};

const Kc = new WeakMap;

const Zc = (t, n) => {
    if (!__EXPERIMENTAL__.suspense) {
        return;
    }
    const e = t;
    const s = e.element.querySelectorAll(`${nf(e.Te)}${He}`);
    const o = tf(t);
    for (let r = 0; r < s.length; r++) {
        const i = s[r];
        if (n !== void 0 && i.getAttribute(jh) !== n) {
            continue;
        }
        if (o.has(i)) {
            continue;
        }
        o.add(i);
        ef(t, e, i.textContent);
    }
};

const tf = t => {
    let n = Kc.get(t);
    if (!n) {
        n = new WeakSet;
        Kc.set(t, n);
    }
    return n;
};

const nf = t => `script[type="qwik/state"][q\\:instance="${t}"]`;

const ef = (t, n, e) => {
    if (e) {
        const [s, o, r, i] = JSON.parse(e);
        sf(t, n, s, o);
        rf(n, r || void 0);
        ((t, n) => {
            if (!__EXPERIMENTAL__.suspense || !n) {
                return;
            }
            for (let e = 0; e < n.length; e++) {
                const s = n[e];
                const o = t._(s.rootId);
                const r = s.subscriptions;
                if (o instanceof Yr) {
                    r instanceof Set && Gc(t, o, o, o.ct ||= new Set, r);
                } else {
                    if (!(r instanceof Map)) {
                        continue;
                    }
                    const n = Eu(o);
                    const e = Su(o);
                    if (!n || !e) {
                        continue;
                    }
                    const s = n.ct ||= new Map;
                    for (const [o, i] of r) {
                        let r = s.get(o);
                        if (!r) {
                            r = new Set;
                            s.set(o, r);
                        }
                        Gc(t, n, e, r, i);
                    }
                }
            }
        })(t, i === void 0 ? void 0 : n._(i));
    }
};

const sf = (t, n, e, s) => {
    const o = n.Ae.length / 2;
    if (e !== o) {
        return;
    }
    for (let t = 0; t < s.length; t++) {
        n.Ae[e * 2 + t] = s[t];
    }
    Xn(n.Ae, t, 0, e * 2);
    n.xe = Oc(t, n.Ae);
    n.xe.length = n.Ae.length / 2;
    n.Ie = n.Rt;
};

const rf = (t, n) => {
    if (!n) {
        return;
    }
    const e = t.Ie ||= [];
    for (let t = 0; t < n.length; t++) {
        const s = n[t];
        s !== void 0 && e.push(s);
    }
    t.Rt = e;
};

function oe(t, n, e, s, o) {
    const r = "q:container";
    const i = "/" + r;
    const c = "q:ignore";
    const l = "/" + c;
    const u = "q:container-island";
    const f = "/" + u;
    const a = "q:rp";
    const h = t;
    const d = h.qVNodeData ||= new WeakMap;
    const p = t.body;
    const $ = p.getAttribute;
    const y = p.hasAttribute;
    const m = ((t, n) => {
        let e;
        for (;t && !(e = Object.getOwnPropertyDescriptor(t, n)?.get); ) {
            t = Object.getPrototypeOf(t);
        }
        return e || function() {
            return this[n];
        };
    })(p, "nodeType");
    const w = t => {
        const n = t.querySelectorAll('script[type="qwik/vnode"]');
        for (let t = 0; t < n.length; t++) {
            const e = n[t];
            const s = e.closest("[q\\:container]");
            s.qVNodeRefs ||= new Map;
            if (e.hasAttribute("q:patch")) {
                h.qProcessVNodeDataPatch?.(e);
                continue;
            }
            const o = e.textContent;
            const r = __EXPERIMENTAL__.suspense && e.getAttribute("q:r");
            r ? (s.qSegmentVnodeData ||= new Map).set(r, o) : s.qVnodeData = o;
        }
        const e = t.querySelectorAll("[q\\:shadowroot]");
        for (let t = 0; t < e.length; t++) {
            const n = e[t];
            const s = n.shadowRoot;
            s && w(s);
        }
    };
    const b = t => {
        const n = m.call(t);
        if (n === 1) {
            if ($.call(t, r) !== null) {
                return 3;
            }
            if (y.call(t, "q:shadowroot")) {
                return 6;
            }
            if (__EXPERIMENTAL__.suspense && $.call(t, a) !== null) {
                return 130;
            }
            return y.call(t, ":") ? 2 : 0;
        }
        if (n === 8) {
            const n = t.nodeValue || "";
            if (n.startsWith(u)) {
                return 65;
            }
            if (n.startsWith(c)) {
                return 16;
            }
            if (n.startsWith(r)) {
                return 9;
            }
            if (n.startsWith(f)) {
                return 64;
            }
            if (n.startsWith(l)) {
                return 32;
            }
            if (n.startsWith(i)) {
                return 8;
            }
        }
        return 0;
    };
    const _ = t => {
        for (;t && (t = t.nextSibling) && b(t) === 0; ) {}
        return t;
    };
    const v = (n, e, s, o, r, i, c, l) => {
        const u = __EXPERIMENTAL__.suspense && l !== void 0;
        const f = r.length;
        let h = 0;
        let p = -1;
        let y = 0;
        let m = 0;
        let w = 0;
        let g = -1;
        let S = null;
        const k = () => {
            let t = 0;
            for (;of(w = r.charCodeAt(y)); ) {
                t += 1 << w - 33;
                y++;
                if (y >= f) {
                    break;
                }
            }
            return t;
        };
        do {
            if (s === o) {
                return;
            }
            S = null;
            const R = s == e ? 2 : b(s);
            if (R === 3) {
                const t = s;
                let e = s;
                for (;e && !(S = _(e)); ) {
                    e = e.parentNode;
                }
                v(n, t, s, S, t.qVnodeData || "", t.qVNodeRefs, t);
            } else if (R === 16) {
                let t = s;
                do {
                    t = n.nextNode();
                    if (!t) {
                        throw Error(`Island inside \x3c!--${s?.nodeValue}--\x3e not found!`);
                    }
                } while (b(t) !== 65);
            } else if (R === 64) {
                S = s;
                let t;
                do {
                    S = n.nextNode();
                    if (!S) {
                        throw Error("Ignore block not closed!");
                    }
                    t = b(S);
                } while (t !== 32 && t !== 65);
                S = null;
            } else if (R === 9) {
                S = s;
                do {
                    S = _(S);
                    if (!S) {
                        throw Error(`\x3c!--${s?.nodeValue}--\x3e not closed!`);
                    }
                } while (b(S) !== 8);
                v(n, s, s, S, "", null, c);
            } else if (R === 6) {
                S = _(s);
                const n = s;
                const e = n?.shadowRoot;
                e && v(t.createTreeWalker(e, 129), null, e, null, "", null, null);
            }
            if ((R & 2) === 2) {
                if (u && s !== e) {
                    const t = s;
                    t._qSegment = l;
                }
                if (p < h) {
                    p === -1 && (p = 0);
                    y = m;
                    if (y < f) {
                        p += k();
                        if (w === 126) {
                            g = p;
                            y++;
                            w = y < f ? r.charCodeAt(m) : 33;
                        }
                        m = lf(r, y, f);
                    } else {
                        p = Number.MAX_SAFE_INTEGER;
                    }
                }
                const t = __EXPERIMENTAL__.suspense && !u && R === 130 ? $.call(s, a) : null;
                if (h === p) {
                    g !== h || u && s === e || i.set(u ? De(l, h) : h, s);
                    const t = r.substring(y, m);
                    if (u && s === e) {
                        const n = d.get(s);
                        n === void 0 || n === "" ? d.set(s, t) : n.charCodeAt(0) !== Xe || n.charCodeAt(1) !== Xe || n.endsWith(t) || d.set(s, n + t);
                    } else {
                        d.set(s, t);
                    }
                }
                h++;
                if (__EXPERIMENTAL__.suspense && t !== null) {
                    E(c, s, t);
                    S = _(s);
                    S && (n.currentNode = S);
                }
            }
        } while (s = S || n.nextNode());
    };
    const g = (n, e, s, o) => {
        n.qVNodeRefs ||= new Map;
        const r = t.createTreeWalker(t, 129);
        r.currentNode = e;
        v(r, e, e, _(e), s, n.qVNodeRefs, n, o);
    };
    const E = __EXPERIMENTAL__.suspense ? (t, n, e, s) => {
        s ||= t?.qSegmentVnodeData?.get(e);
        t && s && g(t, n, s, e);
    } : null;
    h.qProcessVNodeDataPatch = t => {
        const n = t?.closest("[q\\:container]");
        const e = t?.getAttribute("q:r");
        const s = n && (e ? n.querySelector(`[q\\:rp="${e}"]`) : n);
        n && s && g(n, s, t.textContent, e || void 0);
    };
    if (__EXPERIMENTAL__.suspense && n !== void 0) {
        if (e && s && o) {
            e.qVNodeRefs ||= new Map;
            E(e, s, n, o);
        }
        return;
    }
    w(t);
    const S = t.createTreeWalker(t, 129);
    v(S, null, S.firstChild(), null, "", null, null);
}

const of = t => 33 <= t && t <= 46;

const lf = (t, n, e) => {
    let s = 0;
    for (;n < e; ) {
        const e = t.charCodeAt(n);
        if (e === 92) {
            n += 2;
        } else {
            if (s === 0 && of(e)) {
                break;
            }
            e === 123 ? s++ : e === 125 && s--;
            n++;
        }
    }
    return n;
};

function le(t) {
    const n = ce(t);
    if (!n) {
        throw Ie(24);
    }
    return ue(n);
}

function ue(t) {
    const n = t;
    return n.qContainer ||= new uf(n);
}

function ce(t) {
    return t.closest(fs);
}

function fe(t, n) {
    const e = t + "";
    const s = n?.closest(fs);
    const o = s?.qContainer;
    if (o) {
        (function t(n, e, s) {
            if (!__EXPERIMENTAL__.suspense || !s) {
                return;
            }
            const o = s.closest("[q\\:container]");
            const r = o?.querySelector(`script[type="qwik/vnode"][q\\:r="${e}"]:not([q\\:patch])`);
            oe(n, e, o, s, r?.textContent || void 0);
            const i = o?.querySelectorAll(`script[type="qwik/vnode"][q\\:r="${e}"][q\\:patch]`);
            for (let t = 0; i && t < i.length; t++) {
                n.qProcessVNodeDataPatch?.(i[t]);
            }
        })(o.element.ownerDocument, e, n);
        Zc(o, e);
    }
}

class uf extends dc {
    element;
    qContainer;
    qManifestHash;
    rootVNode;
    document;
    dt=new WeakMap;
    Ne;
    Te;
    Rt=null;
    vNodeLocate=t => hl(this.rootVNode, t);
    Ae;
    xe;
    Ie=null;
    Ce=null;
    constructor(t) {
        super({}, t.getAttribute("q:locale"));
        this.qContainer = t.getAttribute(os);
        if (!this.qContainer) {
            throw Ie(25);
        }
        this.document = t.ownerDocument;
        this.element = t;
        this.qe = t.getAttribute(ns);
        this.Te = t.getAttribute("q:instance");
        this.qManifestHash = t.getAttribute("q:manifest-hash");
        this.rootVNode = Jo(this.element);
        this.Ae = [];
        this.xe = [];
        const n = this.element.ownerDocument;
        n.qVNodeDataProcessed || function e(t) {
            oe(t);
            t.qVNodeDataProcessed = !0;
        }(n);
        __EXPERIMENTAL__.suspense && n.querySelector("template[q\\:r]") && (n.qProcessOOOS ||= fe);
        this.Ne = ts(n, this.Te) || li;
        this.Oe();
        t.setAttribute(os, "resumed");
        t.qContainer = this;
        t.qDestroy = () => this.Tn();
        this.je();
        __EXPERIMENTAL__.suspense && Zc(this);
        this.Le();
        t.isConnected && t.dispatchEvent(new CustomEvent("qresume", {
            bubbles: !0
        }));
    }
    Tn() {
        this.vNodeLocate = () => null;
        this.Ae.length = 0;
        this.xe.length = 0;
        this._ = () => {};
        const t = this.element;
        t.qContainer = void 0;
        t.qVnodeData = void 0;
        t.qVNodeRefs = void 0;
        __EXPERIMENTAL__.suspense && (t.qSegmentVnodeData = void 0);
        t.removeAttribute(os);
        const n = t.ownerDocument;
        const e = n.querySelector(fs) !== null;
        if (!e) {
            n.qVNodeData = void 0;
            n.qVNodeDataProcessed = void 0;
            n.qProcessVNodeDataPatch = void 0;
        }
        __EXPERIMENTAL__.suspense && (e || (n.qProcessOOOS = void 0));
    }
    je() {
        const t = this.element.querySelector(`${this.Fe()}:not(${He})`);
        if (t) {
            this.Ae = JSON.parse(t.textContent);
            Xn(this.Ae, this);
            this.Ie = this.Rt;
            this.xe = Oc(this, this.Ae);
        }
    }
    Fe() {
        return `script[type="qwik/state"][q\\:instance="${this.Te}"]`;
    }
    Le() {
        const t = this.element.ownerDocument;
        const n = t.head;
        const e = t.body.querySelectorAll(Ye);
        const s = e.length;
        if (s) {
            const o = t.createDocumentFragment();
            for (let t = 0; t < s; t++) {
                o.appendChild(e[t]);
            }
            n.appendChild(o);
        }
    }
    xn(t, n) {
        this.xe[t] = n;
    }
    parseQRL(t) {
        const n = Ln(t, this);
        return n;
    }
    handleError(t, n) {
        const e = n && this.resolveContext(n, Yc);
        if (!e) {
            throw t;
        }
        e.error = t;
    }
    setContext(t, n, e) {
        let s = this.getHostProp(t, Ke);
        s == null && this.setHostProp(t, Ke, s = []);
        ke(s, n.id, e, 0, !0);
    }
    resolveContext(t, n) {
        for (;t; ) {
            const e = this.getHostProp(t, Ke);
            if (e != null && Pe(e, n.id, 0)) {
                return Re(e, n.id, 0);
            }
            t = this.getParentHost(t);
        }
        return;
    }
    getParentHost(t) {
        let n = t.parent;
        for (;n; ) {
            if (el(n)) {
                if (rl(n, Ve, null) !== null) {
                    return n;
                }
                n = n.parent || n.slotParent;
            } else {
                n = n.parent;
            }
        }
        return null;
    }
    setHostProp(t, n, e) {
        const s = t;
        il(s, n, e);
    }
    getHostProp(t, n) {
        const e = t;
        let s = null;
        switch (n) {
          case ws:
          case ms:
          case Ve:
          case Ke:
          case Ze:
          case us:
            s = this._;
            break;

          case bs:
          case Ss:
            s = parseInt;
            break;
        }
        return rl(e, n, s);
    }
    ensureProjectionResolved(t) {
        if ((t.flags & 16) === 0) {
            t.flags |= 16;
            const n = t.props;
            if (n) {
                const t = Object.keys(n);
                for (let e = 0; e < t.length; e++) {
                    const s = t[e];
                    if (S(s)) {
                        const t = n[s];
                        if (typeof t == "string") {
                            const e = this.vNodeLocate(t);
                            n[s] = e;
                        }
                    }
                }
            }
        }
    }
    _=t => re(t, this.xe);
    Ct(t) {
        return this.Ie?.[t];
    }
    getSyncFn(t) {
        const n = this.Ne[t];
        return n;
    }
    Xe(t, n, e, s) {
        if (s) {
            const t = this.getHostProp(e, Ge);
            const s = new Set(function o(t) {
                return t?.split(" ") ?? null;
            }(t));
            s.add(n);
            this.setHostProp(e, Ge, function r(t) {
                return Array.from(t).join(" ");
            }(s));
        }
        if (this.Ce == null) {
            this.Ce = new Set;
            const t = this.document.querySelectorAll(Qe);
            for (let n = 0; n < t.length; n++) {
                const e = t[n];
                this.Ce.add(e.getAttribute(Je));
            }
        }
        if (!this.Ce.has(n)) {
            this.Ce.add(n);
            const e = this.document.createElement("style");
            e.setAttribute(Je, n);
            e.textContent = t;
            this.document.head.appendChild(e);
        }
    }
    Oe() {
        const t = {};
        const n = this.element.attributes;
        if (n) {
            for (let e = 0; e < n.length; e++) {
                const s = n[e];
                if (s.name === Ps) {
                    continue;
                }
                t[s.name] = s.value;
            }
        }
        this.Dt = {
            containerAttributes: t
        };
    }
}

let cf;

let Yh;

if (be) {
    const t = ac();
    t && (Yh = new t);
}

function ae(t) {
    if (Yh) {
        const t = Yh.getStore();
        if (t) {
            return t;
        }
    }
    if (cf === void 0) {
        const n = af();
        if (n && n.jt) {
            return n.jt;
        }
        if (t !== void 0) {
            return t;
        }
        throw Error("Reading `locale` outside of context.");
    }
    return cf;
}

function he(t, n) {
    if (Yh) {
        return Yh.run(t, n);
    }
    const e = cf;
    try {
        cf = t;
        return n();
    } finally {
        cf = e;
    }
}

let ff;

const af = () => ff;

const hf = () => {
    const t = af();
    if (!t) {
        throw Ie(9);
    }
    return t;
};

const df = () => {
    const t = af();
    if (!t || t.Lt !== ps) {
        throw Ie(10);
    }
    return t;
};

function de(t, n, ...e) {
    return pe.call(this, t, n, e);
}

function pe(t, n, e) {
    const s = ff;
    try {
        ff = t;
        return n.apply(this, e);
    } finally {
        ff = s;
    }
}

const pf = (t, n) => {
    const e = le(n);
    const s = hl(e.rootVNode, n);
    const o = e.jt;
    o && function r(t) {
        if (Yh) {
            Yh.enterWith(t);
            return;
        }
        cf = t;
    }(o);
    const i = ye(o, s, t);
    i.$ = e;
    return i;
};

function $e(t, n, e) {
    const s = {
        m: n,
        Lt: ps,
        Ft: void 0,
        jt: t,
        $: e,
        Xt: void 0
    };
    return s;
}

function ye(t, n, e) {
    const s = t || (e && qe(e) && "locale" in e ? e.locale : void 0);
    const o = {
        m: n,
        Lt: e,
        Ft: void 0,
        jt: s,
        $: void 0
    };
    return o;
}

const $f = (t, ...n) => {
    if (typeof t === "function") {
        if (!ff) {
            return t(...n);
        }
        {
            const e = ff.Ft;
            try {
                ff.Ft = void 0;
                return t(...n);
            } finally {
                ff.Ft = e;
            }
        }
    }
    if (hu(t)) {
        return t.untrackedValue;
    }
    return Pu(t);
};

const yf = /*#__PURE__*/ $e(void 0, void 0, void 0);

const mf = (t, n, e, s, o) => {
    const r = yf.Ft;
    const i = yf.$;
    try {
        yf.Ft = m(n, e, o);
        yf.$ = s;
        return pe(yf, t);
    } finally {
        yf.Ft = r;
        yf.$ = i;
    }
};

const wf = (t, n, e, s, o) => {
    t instanceof xi && t.m !== n && n && (t.m = n);
    return mf(() => t.value, n, e, s, o);
};

const bf = () => af()?.m;

const vf = () => {
    const t = af();
    if (t) {
        return t.Lt;
    }
};

const _f = () => {
    const t = af();
    if (t) {
        return t.$;
    }
};

const gf = t => t;

const Ef = t => t.l || Promise.resolve();

let Sf = (t, n, e, s, o) => new kf(t, n, e, s, o);

class kf {
    _t;
    vt;
    De;
    Ve;
    $;
    constructor(t, n, e, s, o) {
        this._t = t;
        this.vt = n;
        this.De = e;
        this.Ve = s;
        s && this.We(s);
        !o || s || typeof t !== "string" || e || (this.$ = o);
        ve && t && we(t, .8);
    }
    get it() {
        return Oh(this.vt);
    }
    We(t) {
        this.Ve = t;
        As(t) && t.then(t => this.Ve = t, t => {
            console.error(`qrl ${this.vt} failed to load`, t);
            this.Ve = null;
        });
    }
    Ue() {
        if (this.Ve != null) {
            return this.Ve;
        }
        if (this._t === "") {
            const t = this.$.Te;
            const n = this.$.element?.ownerDocument || document;
            const e = ts(n, t);
            return this.Ve = e[+this.vt];
        }
        ve && this._t && we(this._t, 1);
        const t = this.vt;
        const n = this.De ? this.De().then(n => n[t]) : Zs().importSymbol(this.$?.element, this._t, t);
        this.We(n);
        return this.Ve;
    }
}

ve && import.meta.hot && (t => {
    if (!ve || !import.meta.hot) {
        return;
    }
    const n = new Map;
    (() => {
        Sf = (e, s, o, r, i) => {
            let c = n.get(s);
            if (!c) {
                c = new t(e, s, o, r, i);
                e !== "" && n.set(s, c);
            }
            return c;
        };
    })();
    const e = (t, n) => {
        const [e, s] = t.split("?", 2);
        if (!s) {
            return `${e}?t=${n}`;
        }
        const o = s.split("&").filter(t => !t.startsWith("t="));
        o.push("t=" + n);
        return `${e}?${o.join("&")}`;
    };
    document.addEventListener("qHmr", t => {
        const s = t.detail.files;
        const o = t.detail.t || document.__hmrT || Date.now();
        let r = !1;
        for (const t of n.values()) {
            const n = t.dev?.file || t._t;
            if (!n || !s.some(t => n.startsWith(t))) {
                continue;
            }
            const i = t._t;
            if (i) {
                t._t = e(i, o);
                r = !0;
            }
            const c = t.De?.toString();
            if (c) {
                const n = c.replace(/import\((['"])(.+?)\1\)/, (t, n, s) => {
                    const r = e(s, o);
                    return `import(${n}${r}${n})`;
                });
                if (n !== c) {
                    try {
                        t.De = Function(`return (${n})`)();
                        r = !0;
                    } catch (n) {
                        console.error("Failed to update symbolFn for " + t.vt, n);
                    }
                } else {
                    console.warn(`Couldn't find import() in symbolFn for ${t.vt}, cannot update it for HMR`, c);
                }
            }
            if (r) {
                t.Ve = void 0;
                if (t.qrls) {
                    for (const n of t.qrls) {
                        const e = n.deref();
                        e ? e.resolved && (e.resolved = void 0) : t.qrls.delete(n);
                    }
                }
            }
        }
    }, !0);
})(kf);

const Rf = Symbol();

const Pf = t => t?.[Rf] ?? t;

class Tf {
    ze;
    resolved=void 0;
    Mt;
    $;
    constructor(t, n, e) {
        this.ze = t;
        if (n) {
            this.Mt = n;
            typeof n === "string" && (this.$ = e);
        }
        t.Ve == null || typeof this.Mt === "string" || As(t.Ve) || (this.resolved = Of(this, t.Ve));
    }
}

const qf = function(t, ...n) {
    const e = Pf(this);
    if (e.resolved) {
        return e.resolved.apply(t, n);
    }
    const s = af();
    return Mf.call(e, s?.$).then(() => pe.call(t, s, e.resolved, n));
};

const Mf = async function(t) {
    const n = Pf(this);
    return Is(jf(n, t), () => n.resolved);
};

const Af = Object.create(Function.prototype, {
    resolved: {
        get() {
            return this[Rf].resolved;
        },
        set(t) {
            this[Rf].resolved = t;
        }
    },
    Mt: {
        get() {
            return this[Rf].Mt;
        },
        set(t) {
            this[Rf].Mt = t;
        }
    },
    $: {
        get() {
            return this[Rf].$;
        },
        set(t) {
            this[Rf].$ = t;
        }
    },
    ze: {
        get() {
            return this[Rf].ze;
        }
    },
    _t: {
        get() {
            return this[Rf].ze._t;
        }
    },
    vt: {
        get() {
            return this[Rf].ze.vt;
        }
    },
    it: {
        get() {
            return this[Rf].ze.it;
        }
    },
    dev: {
        get() {
            return this[Rf].ze.dev;
        }
    },
    Be: {
        value: qf
    },
    w: {
        value: function(t) {
            const n = Pf(this);
            const e = new Tf(n.ze, t, n.Mt ? n.$ : void 0);
            return Ff(e);
        }
    },
    s: {
        value: function(t) {
            const n = Pf(this);
            n.ze.We(t);
            n.resolved = Of(n, t);
        }
    },
    resolve: {
        value: Mf
    },
    getSymbol: {
        value: function() {
            return Pf(this).ze.vt;
        }
    },
    getHash: {
        value: function() {
            return Pf(this).ze.it;
        }
    },
    getCaptured: {
        value: function() {
            const t = Pf(this);
            Cf(t);
            return t.Mt;
        }
    },
    getFn: {
        value: function(t, n) {
            const e = Pf(this);
            const s = (...o) => {
                if (!e.resolved) {
                    return Mf.call(e).then(() => s(...o));
                }
                if (n && n() === !1) {
                    return;
                }
                return pe(t, e.resolved, o);
            };
            return s;
        }
    }
});

let xf = null;

const If = t => {
    xf = t;
};

const Nf = (t, n) => {
    const e = [];
    const s = n.split(" ");
    for (let n = 0; n < s.length; n++) {
        const o = s[n];
        e.push(t._(o));
    }
    return e;
};

const Cf = t => {
    xf = t.Mt;
    const n = t.$;
    if (typeof xf === "string") {
        if (!n) {
            throw Ie(13);
        }
        const e = Tc;
        xf = t.Mt = Nf(n, xf);
        if (Tc !== e) {
            return Tc;
        }
    }
};

const Of = (t, n) => {
    if (typeof n !== "function" || !t.Mt) {
        return n;
    }
    return function e(...s) {
        Cf(t);
        return n.apply(this, s);
    };
};

const jf = (t, n) => {
    const e = t.ze;
    const s = typeof t.Mt === "string";
    s && !t.$ && (t.$ = n || af()?.$);
    if (t.resolved) {
        return;
    }
    const o = Wf();
    const r = af();
    const i = e.Ue();
    const c = Is(i, n => {
        t.resolved = Of(t, n);
    });
    if (c) {
        const t = e.vt;
        Df(t, r?.m instanceof Nr ? r?.m.node : void 0, o);
    }
    const l = s && t.$ && Cf(t);
    if (l) {
        return l.then(() => c);
    }
    return c;
};

const Lf = (t, n, e, s, o, r) => {
    const i = Sf(t, n, s, e, r);
    const c = new Tf(i, o, r);
    return Ff(c);
};

const Ff = t => {
    const n = async function(...t) {
        return qf.call(n, this, ...t);
    };
    n[Rf] = t;
    Object.setPrototypeOf(n, Af);
    return n;
};

const Xf = /*#__PURE__*/ new Set;

const Df = (t, n, e) => {
    if (!Xf.has(t)) {
        Xf.add(t);
        Vf("qsymbol", {
            symbol: t,
            element: n,
            reqTime: e
        });
    }
};

const Vf = (t, n) => {
    Fh() || typeof document !== "object" || document.dispatchEvent(new CustomEvent(t, {
        bubbles: !1,
        detail: n
    }));
};

const Wf = () => {
    if (Fh()) {
        return 0;
    }
    if (typeof performance === "object") {
        return performance.now();
    }
    return 0;
};

let Uf = 0;

const zf = t => Lf(null, "s" + Uf++, t, null, null);

const Bf = zf;

const Hf = t => t;

const Jf = t => Lf("", Ne, t, null, null);

const Qf = (t, n) => {
    n === void 0 && (n = t.toString());
    t.serialized = n;
    return Lf("", Ne, t, null, null);
};

const Yf = t => {
    function n(n, e, s = 0) {
        const o = t.it.slice(0, 4);
        const r = o + ":" + (e || "");
        const i = () => {};
        i[Gf] = [ t ];
        return Hi(i, n, null, n.children, s, r);
    }
    n[Gf] = [ t ];
    return n;
};

const Gf = Symbol();

const Kf = t => typeof t == "function" && t[Gf] !== void 0;

const Zf = t => Yf(Bf(t));

const ta = mi(Hf);

const na = () => {
    const t = globalThis.__QWIK_MANIFEST__;
    if (!globalThis.__QWIK_MANIFEST__) {
        throw Error("Client manifest is not available. It should have been automatically injected during the build process. Make sure that @qwik.dev/core is internal to the build.");
    }
    return t;
};

const ea = async (t, n, e = {}) => {
    if ((t => t.nodeType === 9)(t)) {
        let n = t.firstChild;
        for (;n && !kr(n); ) {
            n = n.nextSibling;
        }
        t = n;
    }
    t.setAttribute(os, "resumed");
    const s = le(t);
    s.Dt = e.serverData || {};
    const o = s.rootVNode;
    il(o, Xr, n);
    yn(s, o, 2);
    await s.l;
    return {
        cleanup: () => {
            Et(s, [], s.rootVNode);
        }
    };
};

const sa = (t, n) => {
    const {val: e, set: s, iCtx: o} = ko();
    if (e != null) {
        return e;
    }
    const r = xe(t) ? de(void 0, t) : t;
    if (n?.reactive === !1) {
        s(r);
        return r;
    }
    {
        const t = o.$;
        const e = n?.deep ?? !0;
        const i = e ? 1 : 0;
        const c = qu(r, i, t);
        s(c);
        return c;
    }
};

const ra = () => {
    const {val: t, set: n, iCtx: e} = ko();
    if (t != null) {
        return t;
    }
    const s = e.$.qe || "";
    const o = s ? Ws(s).substring(0, 3) : "";
    const r = e.$.getHostProp(e.m, Ve);
    const i = r?.getHash().substring(0, 3) || "";
    const c = (t => {
        const n = (t => {
            const n = t.Re;
            return n || t;
        })(t);
        return (t => t.toString(36))(n.Pe++);
    })(e.$) || "";
    let l = `${o}${i}${c}`;
    let u = l.charCodeAt(0);
    if (u >= 48 && u <= 57) {
        u += 17;
        l = String.fromCharCode(u) + l.substring(1);
    }
    return n(l);
};

function me(t, n) {
    const e = af();
    return e?.$?.Dt[t] ?? n;
}

const ia = /*#__PURE__*/ new Map;

const oa = (t, n) => {
    let e = ia.get(n);
    e || ia.set(n, e = la(t, n));
    return e;
};

const la = (t, n) => {
    const e = t.length;
    const s = [];
    const o = [];
    let r = 0;
    let i = r;
    let c = ha;
    let l = 0;
    for (;r < e; ) {
        const n = r;
        let e = t.charCodeAt(r++);
        if (e === Fa) {
            r++;
            e = Oa;
        }
        const s = Ha[c];
        for (let d = 0; d < s.length; d++) {
            const p = s[d];
            const [$, y, m] = p;
            if (($ === l || $ === _a || $ === ga && ua(l) || $ === Sa && aa(l)) && (y === e || y === _a || y === ga && ua(e) || y === Ea && !ua(e) && e !== xa || y === Sa && aa(e)) && (p.length == 3 || a(p))) {
                p.length > 3 && (e = t.charCodeAt(r - 1));
                if (m === ba || m == va) {
                    if (m === va) {
                        if (c !== da || h()) {
                            if (!ca(e)) {
                                const t = y == Ea ? 1 : y == Ma ? 2 : 0;
                                f(r - t);
                            }
                        } else {
                            ca(e) ? u(r - 2) : f(r - 2);
                            i++;
                        }
                    }
                    if (y === Ea) {
                        r--;
                        e = l;
                    }
                    do {
                        c = o.pop() || ha;
                        if (c === pa) {
                            u(r - 1);
                            i++;
                        }
                    } while (fa(c));
                } else {
                    o.push(c);
                    if (c === pa && m === ha) {
                        u(r - 8);
                        i = r;
                    } else {
                        m === $a && f(n);
                    }
                    c = m;
                }
                break;
            }
        }
        l = e;
    }
    u(r);
    return s.join("");
    function u(n) {
        s.push(t.substring(i, n));
        i = n;
    }
    function f(t) {
        if (c === pa || h()) {
            return;
        }
        u(t);
        s.push(".", Ue, n);
    }
    function a(n) {
        let e = 0;
        if (t.charCodeAt(r) === Aa) {
            for (let n = 1; n < 10; n++) {
                if (t.charCodeAt(r + n) === Aa) {
                    e = n + 1;
                    break;
                }
            }
        }
        t: for (let s = 3; s < n.length; s++) {
            const o = n[s];
            for (let n = 0; n < o.length; n++) {
                if ((t.charCodeAt(r + n + e) | Da) !== o.charCodeAt(n)) {
                    continue t;
                }
            }
            r += o.length + e;
            return !0;
        }
        return !1;
    }
    function h() {
        return o.indexOf(pa) !== -1 || o.indexOf(ya) !== -1;
    }
};

const ua = t => t >= Ia && t <= Na || t >= Oa && t <= ja || t >= Va && t <= Wa || t >= 128 || t === Xa || t === Aa;

const ca = t => t === Ca || t === xa || t === La || t === qa || ua(t);

const fa = t => t === ma || t === ya || t === wa || t === pa;

const aa = t => t === Ta || t === ka || t === Ra || t === Pa;

const ha = 0;

const da = 2;

const pa = 5;

const $a = 6;

const ya = 10;

const ma = 11;

const wa = 12;

const ba = 17;

const va = 18;

const _a = 0;

const ga = 1;

const Ea = 2;

const Sa = 3;

const ka = 9;

const Ra = 10;

const Pa = 13;

const Ta = 32;

const qa = 35;

const Ma = 41;

const Aa = 45;

const xa = 46;

const Ia = 48;

const Na = 57;

const Ca = 58;

const Oa = 65;

const ja = 90;

const La = 91;

const Fa = 92;

const Xa = 95;

const Da = 32;

const Va = 97;

const Wa = 122;

const Ua = 123;

const za = 125;

const Ba = /*@__PURE__*/ (() => [ [ _a, 39, 14 ], [ _a, 34, 15 ], [ _a, 47, 16, "*" ] ])();

const Ha = /*@__PURE__*/ (() => [ [ [ _a, 42, da ], [ _a, La, 7 ], [ _a, Ca, $a, ":", "before", "after", "first-letter", "first-line" ], [ _a, Ca, pa, "global" ], [ _a, Ca, 3, "has", "host-context", "not", "where", "is", "matches", "any" ], [ _a, Ca, 4 ], [ _a, ga, 1 ], [ _a, xa, 1 ], [ _a, qa, 1 ], [ _a, 64, ya, "keyframe" ], [ _a, 64, ma, "media", "supports", "container" ], [ _a, 64, wa ], [ _a, Ua, 13 ], [ 47, 42, 16 ], [ _a, 59, ba ], [ _a, za, ba ], [ _a, Ma, ba ], ...Ba ], [ [ _a, Ea, va ] ], [ [ _a, Ea, va ] ], [ [ _a, 40, ha ], [ _a, Ea, va ] ], [ [ _a, 40, 8 ], [ _a, Ea, va ] ], [ [ _a, 40, ha ], [ _a, Ea, ba ] ], [ [ _a, Ea, ba ] ], [ [ _a, 93, va ], [ _a, 39, 14 ], [ _a, 34, 15 ] ], [ [ _a, Ma, ba ], ...Ba ], [ [ _a, za, ba ], ...Ba ], [ [ _a, za, ba ], [ Sa, ga, 1 ], [ _a, Ca, pa, "global" ], [ _a, Ua, 13 ], ...Ba ], [ [ _a, Ua, ha ], [ _a, 59, ba ], ...Ba ], [ [ _a, 59, ba ], [ _a, Ua, 9 ], ...Ba ], [ [ _a, za, ba ], [ _a, Ua, 13 ], [ _a, 40, 8 ], ...Ba ], [ [ _a, 39, ba ] ], [ [ _a, 34, ba ] ], [ [ 42, 47, ba ] ] ])();

const Ja = t => ({
    styleId: Ka(t, t => t, !1)
});

const Qa = /*#__PURE__*/ mi(Ja);

const Ya = t => ({
    scopeId: Ue + Ka(t, oa, !0)
});

const Ga = /*#__PURE__*/ mi(Ya);

const Ka = (t, n, e) => {
    let {val: s, set: o, iCtx: r, i} = ko();
    if (s) {
        return s;
    }
    const c = ((t, n) => `${Ws(t.it)}-${n}`)(t, i);
    const l = r.m;
    o(c);
    if (!t.resolved) {
        throw t.resolve().then(t => r.$.Xe(n(t, c), c, l, e));
    }
    r.$.Xe(n(t.resolved, c), c, l, e);
    return c;
};

const Za = (t, n) => {
    t.resolve();
    return bi(t, n);
};

const th = (t, n) => To(Za, t, n);

const nh = mi(th);

const eh = t => {
    t.resolve();
    return _i(t);
};

const sh = t => To(eh, t);

const rh = mi(sh);

const ih = (t, n) => {
    const {val: e, set: s, i: o, iCtx: r} = ko();
    const i = n?.strategy ?? "intersection-observer";
    if (e) {
        if (!(e.h & 32) && !Fh()) {
            e.h |= 32;
            oh(e, i);
        }
        return;
    }
    let c;
    if (Fh()) {
        c = 1;
    } else {
        c = 5;
        t.resolve();
        yn(r.$, r.m, 1);
    }
    const l = new cu(c, o, r.m, t, void 0, null);
    s(l);
    oh(l, i);
};

const oh = (t, n) => {
    n === "intersection-observer" ? _c("qvisible", lh(t)) : n === "document-ready" ? gc("qinit", lh(t)) : n === "document-idle" && gc("qidle", lh(t));
};

const lh = t => Lf(null, "_task", Mn, null, [ t ]);

const uh = mi(wc);

const ch = /*#__PURE__*/ mi(lu);

const fh = /*#__PURE__*/ mi(ih);

const ah = (t, n) => {
    t.resolve();
    return vi(t, n);
};

const hh = (t, n) => To(ah, t, n);

const dh = mi(hh);

const ph = () => {
    const t = sa({
        error: void 0
    });
    Hc(Yc, t);
    return t;
};

const $h = async ({track: t}) => {
    const n = xf[0];
    t(() => n.items);
    const e = af();
    const s = e.m;
    const o = e.$;
    yn(o, s, 256);
    const r = be;
    r && await o.l;
};

const yh = t => {
    if (!__EXPERIMENTAL__.each) {
        throw Error('Each is experimental and must be enabled with `experimental: ["each"]` in the `qwikVite` plugin.');
    }
    lu(/*#__PURE__*/ sc($h, "_eaT", [ t ]));
    return ro;
};

const mh = /*#__PURE__*/ Yf(
/*#__PURE__*/ sc(yh, "_eaC"));

const wh = (t, n, e) => Ce(t) ? t.getFn(n)(e) : t(e);

const bh = ({track: t}) => {
    const n = xf[0];
    const e = af();
    const s = e.m;
    const o = e.$;
    const r = be;
    return Is(t(() => wh(n.when$, af(), void 0)), t => {
        const i = t ? n.then$ : n.else$;
        return Is(i ? wh(i, e, t) : null, t => {
            const n = i ? [ t ] : [];
            if (r) {
                const t = o;
                return t.renderJSX(n, {
                    currentStyleScoped: null,
                    parentComponentFrame: t.getComponentFrame(0)
                });
            }
            Ut(s, n);
            yn(o, s, 2);
        });
    });
};

const vh = t => {
    if (!__EXPERIMENTAL__.show) {
        throw Error('Show is experimental and must be enabled with `experimental: ["show"]` in the `qwikVite` plugin.');
    }
    lu(/*#__PURE__*/ sc(bh, "_shT", [ t ]));
    return ro;
};

const _h = /*#__PURE__*/ Yf(
/*#__PURE__*/ sc(vh, "_shC"));

const gh = /*#__PURE__*/ Bc("qk-reveal");

const Eh = t => ({
    order: t.order ?? "parallel",
    collapsed: t.collapsed === !0,
    items: [],
    version: gi(0)
});

const Sh = () => {
    const t = xf[0];
    if (t !== null && t.reveal.version.value < 0) {
        return !1;
    }
    if (!ve) {
        const n = t?.reveal.ooos;
        if (n) {
            return n.canReveal(t);
        }
    }
    return zh(t);
};

const kh = ({cleanup: t}) => {
    const n = xf[0];
    t(() => {
        if (!ve) {
            return;
        }
        const t = n.reveal.items;
        const e = t.indexOf(n.item);
        if (e !== -1) {
            t.splice(e, 1);
            n.reveal.version.value++;
        }
    });
};

const Rh = t => {
    if (!__EXPERIMENTAL__.suspense) {
        throw Error('Reveal is experimental and must be enabled with `experimental: ["suspense"]` in the `qwikVite` plugin.');
    }
    const n = To(Eh, t);
    Hc(gh, n);
    const e = !ve;
    if (__EXPERIMENTAL__.suspense && e && Qh()) {
        const t = (t => {
            const n = t.ooos;
            if (n) {
                return n;
            }
            const e = ((t, n) => {
                if (!Qh()) {
                    return null;
                }
                const e = af()?.$;
                let s = 0;
                if (e) {
                    s = (Bh.get(e) || 0) + 1;
                    Bh.set(e, s);
                }
                return new Hh(s, t, n);
            })(t.order, t.collapsed);
            t.ooos = Wc(e);
            return e;
        })(n);
        /*#__PURE__*/
        return Bi(Gh, {
            coordinator: t
        }, null, null, 0, "u7_0");
    }
    /*#__PURE__*/
    return Bi(so, null, null, null, 0, "u7_0");
};

const Ph = /*#__PURE__*/ Yf(
/*#__PURE__*/ sc(Rh, "_reC"));

const Gh = __EXPERIMENTAL__.suspense ? /*#__PURE__*/ Uh((t, n, e, s) => {
    const o = n.varProps.coordinator;
    s(() => {
        const n = o.script();
        if (!n) {
            return;
        }
        t.emitOutOfOrderExecutorIfNeeded();
        t.emitInlineScript(n);
    });
    s(/*#__PURE__*/ Bi(so, null, null, null, 0, "u7_0"));
}) : null;

const Th = (t, n, e, s) => ({
    display: n.value !== "fallback" || t.fallback == null || t.fallback === !1 || e !== null && !e.value && s.reveal.collapsed ? "none" : "contents"
});

const Kh = '{display:p1.value==="fallback"&&p0.fallback!=null&&p0.fallback!==false&&(p2===null||p2.value||!p3.reveal.collapsed)?"contents":"none"}';

const qh = (t, n, e) => ({
    display: n.value !== "content" && !t.showStale || e !== null && !e.value ? "none" : "contents"
});

const Mh = ({track: t, cleanup: n}) => {
    const e = xf[0], s = xf[1], o = xf[2], r = xf[3];
    const i = t(e.pending);
    const c = ve;
    r !== null && c && r.reveal.version.value++;
    if (!c || i === 0) {
        o.value = "content";
        return;
    }
    const l = setTimeout(() => {
        e.pending.value > 0 && (o.value = "fallback");
    }, s.delay ?? 0);
    n(() => clearTimeout(l));
};

const Ah = t => {
    if (!__EXPERIMENTAL__.suspense) {
        throw Error('Suspense is experimental and must be enabled with `experimental: ["suspense"]` in the `qwikVite` plugin.');
    }
    const n = Po("content");
    const e = (() => {
        if (!__EXPERIMENTAL__.suspense) {
            throw Error('useCursorBoundary is experimental and must be enabled with `experimental: ["suspense"]` in the `qwikVite` plugin.');
        }
        return To(qo);
    })();
    const s = (t => {
        const n = Jc(gh, null);
        const e = To(() => {
            if (n === null) {
                return null;
            }
            const e = {
                boundary: t
            };
            n.items.push(e);
            return {
                reveal: n,
                item: e
            };
        });
        e !== null && lu(/*#__PURE__*/ sc(kh, "_reT", [ e ]), {
            deferUpdates: !1
        });
        return e;
    })(e);
    const o = th(
    /*#__PURE__*/ sc(Sh, "_reR", [ s ]));
    lu(
    /*#__PURE__*/ sc(Mh, "_suT", [ e, t, n, s ]));
    const r = !ve;
    const i = r && Qh();
    const c = i ? (() => {
        if (!__EXPERIMENTAL__.suspense) {
            return 0;
        }
        const t = af()?.$;
        if (t?.outOfOrderStreaming !== !0) {
            return 0;
        }
        return t?.nextOutOfOrderId?.() ?? 0;
    })() : 0;
    const l = i ? s?.reveal.ooos?.register(s) ?? null : null;
    const u = i && function f(t, n) {
        return t != null && t !== !1 && (n === null || n.showFallback);
    }(t.fallback, l);
    const a = u && nd(t.delay) ? {
        contentResolved: !1,
        delayTimer: null
    } : null;
    const h = i ? /*#__PURE__*/ hc(Th, [ t, n, o, s ], Kh) : null;
    const d = /*#__PURE__*/ hc(qh, [ t, n, o ], '{display:(p1.value==="content"||p0.showStale)&&(p2===null||p2.value)?"contents":"none"}');
    const p = i ? /*#__PURE__*/ Bi(Zh, {
        boundary: a,
        delay: t.delay,
        fallbackStyle: h,
        showFallback: u,
        state: n
    }, null, qi(t, "fallback"), 1, null) : /*#__PURE__*/ Bi("div", {
        style: hc(Th, [ t, n, o, s ], Kh)
    }, null, qi(t, "fallback"), 1, null);
    return [ p, 
    /*#__PURE__*/ Bi("div", null, i ? {
        [Lh]: c + "",
        style: d
    } : {
        style: d
    }, 
    /*#__PURE__*/ Bi(i ? td : so, i ? {
        [us]: e,
        boundary: a,
        boundaryId: c,
        contentStyle: d,
        reveal: l
    } : {
        [us]: e
    }, null, null, 3, "u6_0"), 1, null) ];
};

const xh = /*#__PURE__*/ Yf(
/*#__PURE__*/ sc(Ah, "_suC"));

const Zh = __EXPERIMENTAL__.suspense ? /*#__PURE__*/ Uh((t, n, e, s) => {
    const o = n.varProps.boundary;
    const r = n.varProps.delay;
    const i = n.varProps.fallbackStyle;
    const c = n.varProps.showFallback === !0;
    const l = n.varProps.state;
    c && !nd(r) ? l.value = "fallback" : o && c && nd(r) && s(() => function n(t, e, s, o) {
        e.delayTimer = setTimeout(() => {
            e.delayTimer = null;
            t.S(async () => {
                if (e.contentResolved) {
                    return;
                }
                s.value = "fallback";
                t.emitBackpatchDataAndExecutorIfNeeded();
                await t.streamHandler.flush();
            });
        }, o);
    }(t, o, l, r));
    s(
    /*#__PURE__*/ Bi("div", {
        style: i
    }, null, n.children, 1, null));
}) : null;

const td = __EXPERIMENTAL__.suspense ? /*#__PURE__*/ Uh(async (t, n, e) => {
    const s = n.varProps.boundaryId ?? t.nextOutOfOrderId();
    const o = "" + s;
    const r = n.varProps.boundary;
    const i = n.varProps.contentStyle;
    const c = n.varProps.reveal;
    const l = t.segment(o, function u(t, n, e) {
        const s = e.parentComponentFrame;
        if (!s) {
            /*#__PURE__*/
            return Bi(so, n.varProps, n.constProps, n.children, n.flags, n.key);
        }
        const o = k(s.componentNode, n, t);
        const r = n.children || null;
        const i = s.claimChildrenForSlot(o) || r;
        r && i !== r && t.addUnclaimedProjection(s, "", r);
        /*#__PURE__*/
        return Bi(so, n.varProps, n.constProps, i, n.flags, n.key);
    }(t, n, e), e);
    (function f(t, n) {
        t.write(`<template ${jh}="${n}"></template>`);
    })(t, s);
    t.emitOutOfOrderExecutorIfNeeded();
    t.queueOutOfOrderSegment(l.then(n => async function e(t, n, s, o, r, i, c) {
        (function l(t) {
            if (!t) {
                return;
            }
            t.contentResolved = !0;
            if (t.delayTimer) {
                clearTimeout(t.delayTimer);
                t.delayTimer = null;
            }
        })(c);
        i?.resolve();
        await t.S(async () => {
            t.addRoot(r);
            const e = await o.container.P(s, o);
            (function c(t, n, e, s) {
                t.write(`<template ${jh}="${n}"${s?.attrs ?? ""}>`);
                t.write(e);
                t.write("</template>");
            })(t, n, e.html, i);
            t.emitOutOfOrderSegmentScripts(e.scripts);
            t.emitInlineScript(`qO(${n})`);
            await t.streamHandler.flush();
        });
    }(t, s, o, n, i, c, r)));
}) : null;

function nd(t) {
    return typeof t === "number" && Number.isFinite(t) && t > 0;
}

const Ih = t => {
    const n = import.meta.env?.BASE_URL || "/";
    const e = {
        path: "qwik-prefetch-service-worker.js",
        ...t
    };
    t?.path?.startsWith?.("/") ? e.path = t.path : e.path = n + e.path;
    let s = Nh.replace('"_URL_"', JSON.stringify(e.path.split("/").pop()));
    s = s.replaceAll(/\s\s+/gm, "");
    const o = {
        dangerouslySetInnerHTML: "(" + s + ")(navigator.serviceWorker);",
        nonce: e.nonce
    };
    return Bi("script", null, o, null, 0, "prefetch-service-worker");
};

const Nh = /*#__PURE__*/ "" + (t => {
    "getRegistrations" in t && t.getRegistrations().then(t => {
        for (let n = 0; n < t.length; n++) {
            const e = t[n];
            e.active && e.active.scriptURL.endsWith("_URL_") && e.unregister().catch(console.error);
        }
    });
    "caches" in window && caches.keys().then(t => {
        const n = t.find(t => t.startsWith("QwikBundles"));
        n && caches.delete(n).catch(console.error);
    }).catch(console.error);
});

const Ch = () => null;

globalThis.__qwik && Ie(30, [ globalThis.__qwik, Sr ]);

globalThis.__qwik = Sr;

import.meta.hot && import.meta.hot.dispose(() => {
    globalThis.__qwik = void 0;
});

export { zf as $, mh as Each, no as Fragment, Uc as NoSerializeSymbol, Ch as PrefetchGraph, Ih as PrefetchServiceWorker, eo as RenderOnce, bc as Resource, Ph as Reveal, oo as SSRComment, io as SSRRaw, uo as SSRStream, lo as SSRStreamBlock, zc as SerializerSymbol, _h as Show, ro as SkipRender, so as Slot, xh as Suspense, ni as _CONST_PROPS, uf as _DomContainer, Rr as _EFFECT_BACK_REF, ws as _ELEMENT_SEQ, li as _EMPTY_ARRAY, ui as _EMPTY_OBJ, ii as _IMMUTABLE, dc as _SharedContainer, Ii as _SubscriptionData, Cu as _SubscriptionPatch, cu as _Task, oi as _UNINITIALIZED, ei as _VAR_PROPS, Qn as _addProjection, xf as _captures, v as _chk, ie as _createDeserializeContainer, Lf as _createQRL, xn as _createStore, Ns as _delay, se as _deserialize, Yu as _dumpState, yh as _eaC, $h as _eaT, pn as _executeSsrChores, hc as _fnSignal, ac as _getAsyncLocalStorage, $i as _getConstProps, _f as _getContextContainer, vf as _getContextEvent, bf as _getContextHostElement, le as _getDomContainer, ce as _getQContainerElement, m as _getSubscriber, pi as _getVarProps, Ru as _hasStoreEffects, Rc as _hmr, ti as _injectAsyncSignalValue, de as _invoke, Oi as _isJSXNode, Tu as _isStore, Vn as _isStringifiable, fu as _isTask, gf as _jsxBranch, Ji as _jsxC, Yi as _jsxQ, Qi as _jsxS, Bi as _jsxSorted, Hi as _jsxSplit, Se as _mapApp_findIndx, Re as _mapArray_get, ke as _mapArray_set, vu as _markSignalAsExternallyOwned, ye as _newInvokeContext, rc as _noopQrl, ic as _noopQrlDEV, Xn as _preprocessState, Qf as _qrlSync, On as _qrlToString, oc as _qrlWithChunk, lc as _qrlWithChunkDEV, Rh as _reC, Sh as _reR, kh as _reT, fc as _regSymbol, Kn as _removeProjection, _ as _res, Qc as _resolveContextWithoutSequentialScope, po as _restProps, n as _retryOnPromise, mc as _rsc, I as _run, ee as _serialize, Bn as _setEvent, Yn as _setProjectionTarget, vh as _shC, bh as _shT, Ah as _suC, Mh as _suT, Mn as _task, Gn as _updateProjectionProps, Jn as _useHmr, b as _val, Lc as _verifySerializable, ul as _vnode_ensureElementInflated, Gl as _vnode_getAttrKeys, Ml as _vnode_getElementName, Il as _vnode_getFirstChild, rl as _vnode_getProp, $l as _vnode_getVNodeForChildNode, kl as _vnode_insertBefore, Ko as _vnode_isElementVNode, tl as _vnode_isMaterialized, nl as _vnode_isTextVNode, el as _vnode_isVirtualVNode, Yo as _vnode_newVirtual, Tl as _vnode_remove, il as _vnode_setProp, En as _vnode_toString, Ef as _waitUntilRendered, Un as _walkJSX, qi as _wrapProp, Ai as _wrapSignal, Zf as component$, Yf as componentQrl, Si as createAsync$, vi as createAsyncQrl, Ei as createComputed$, bi as createComputedQrl, Bc as createContextId, g as createElement, ki as createSerializer$, _i as createSerializerQrl, gi as createSignal, ta as event$, Hf as eventQrl, ku as forceStoreEffects, na as getClientManifest, le as getDomContainer, ae as getLocale, Zs as getPlatform, g as h, mi as implicit$FirstArg, sc as inlinedQrl, cc as inlinedQrlDEV, _e as isDev, hu as isSignal, Ki as jsx, Zi as jsxDEV, to as jsxs, Wc as noSerialize, ec as qrl, uc as qrlDEV, ea as render, Ks as setPlatform, Jf as sync$, $f as untrack, Pu as unwrapStore, dh as useAsync$, hh as useAsyncQrl, nh as useComputed$, th as useComputedQrl, To as useConstant, Jc as useContext, Hc as useContextProvider, ph as useErrorBoundary, ra as useId, yc as useLexicalScope, _c as useOn, gc as useOnDocument, Ec as useOnWindow, uh as useResource$, wc as useResourceQrl, rh as useSerializer$, sh as useSerializerQrl, me as useServerData, Po as useSignal, sa as useStore, Qa as useStyles$, Ja as useStylesQrl, Ga as useStylesScoped$, Ya as useStylesScopedQrl, ch as useTask$, lu as useTaskQrl, fh as useVisibleTask$, ih as useVisibleTaskQrl, Sr as version, he as withLocale };
